/* eslint-disable */
/*
/* This file is generated automatically by i18n preprocessor. Do not modify it directly.
 */
import { addLang, locale } from '../../../locale';

const i18n = {
  "en-US": {
    "country": {
      "AF": "Afghanistan",
      "AX": "\u00C5land Islands",
      "AL": "Albania",
      "DZ": "Algeria",
      "AS": "American Samoa",
      "AD": "Andorra",
      "AO": "Angola",
      "AI": "Anguilla",
      "AQ": "Antarctica",
      "AG": "Antigua and Barbuda",
      "AR": "Argentina",
      "AM": "Armenia",
      "AW": "Aruba",
      "AC": "Ascension Island",
      "AU": "Australia",
      "AT": "Austria",
      "AZ": "Azerbaijan",
      "BS": "Bahamas",
      "BH": "Bahrain",
      "BD": "Bangladesh",
      "BB": "Barbados",
      "BY": "Belarus",
      "BE": "Belgium",
      "BZ": "Belize",
      "BJ": "Benin",
      "BM": "Bermuda",
      "BT": "Bhutan",
      "BO": "Bolivia (Plurinational State of)",
      "BA": "Bosnia and Herzegovina",
      "BW": "Botswana",
      "BV": "Bouvet Island",
      "BR": "Brazil",
      "BQ": "Bonaire, Sint Eustatius and Saba",
      "IO": "British Indian Ocean Territory",
      "VG": "Virgin Islands (British)",
      "BN": "Brunei Darussalam",
      "BG": "Bulgaria",
      "BF": "Burkina Faso",
      "BI": "Burundi",
      "KH": "Cambodia",
      "CM": "Cameroon",
      "CA": "Canada",
      "IC": "Canary Islands",
      "CT": "Canton and Enderbury Islands",
      "CV": "Cabo Verde",
      "KY": "Cayman Islands",
      "CF": "Central African Republic",
      "EA": "Ceuta and Melilla",
      "TD": "Chad",
      "CL": "Chile",
      "CN": "China",
      "CN-ML": "Chinese Mainland",
      "CX": "Christmas Island",
      "CP": "Clipperton Island",
      "CC": "Cocos (Keeling) Islands",
      "CO": "Colombia",
      "KM": "Comoros",
      "CD": "Congo, Democratic Republic of the",
      "CK": "Cook Islands",
      "CR": "Costa Rica",
      "CI": "C\u00F4te d'Ivoire",
      "HR": "Croatia",
      "CU": "Cuba",
      "CW": "Cura\u00E7ao",
      "CY": "Cyprus",
      "CZ": "Czechia",
      "DK": "Denmark",
      "DG": "Diego Garcia",
      "DJ": "Djibouti",
      "DM": "Dominica",
      "DO": "Dominican Republic",
      "NQ": "Dronning Maud Land",
      "EC": "Ecuador",
      "EG": "Egypt",
      "SV": "El Salvador",
      "GQ": "Equatorial Guinea",
      "ER": "Eritrea",
      "EE": "Estonia",
      "ET": "Ethiopia",
      "EU": "European Union",
      "FK": "Falkland Islands (Malvinas)",
      "FO": "Faroe Islands",
      "FJ": "Fiji",
      "FI": "Finland",
      "FR": "France",
      "GF": "French Guiana",
      "PF": "French Polynesia",
      "TF": "French Southern Territories",
      "FQ": "French Southern and Antarctic Territories",
      "GA": "Gabon",
      "GM": "Gambia",
      "GE": "Georgia",
      "DE": "Germany",
      "GH": "Ghana",
      "GI": "Gibraltar",
      "GR": "Greece",
      "GL": "Greenland",
      "GD": "Grenada",
      "GP": "Guadeloupe",
      "GU": "Guam",
      "GT": "Guatemala",
      "GG": "Guernsey",
      "GN": "Guinea",
      "GW": "Guinea-Bissau",
      "GY": "Guyana",
      "HT": "Haiti",
      "HM": "Heard Island and McDonald Islands",
      "HN": "Honduras",
      "HK": "Hong Kong SAR",
      "HU": "Hungary",
      "IS": "Iceland",
      "IN": "India",
      "ID": "Indonesia",
      "IR": "Iran (Islamic Republic of)",
      "IE": "Ireland",
      "IM": "Isle of Man",
      "IL": "Israel",
      "IQ": "Iraq",
      "IT": "Italy",
      "JM": "Jamaica",
      "JP": "Japan",
      "JE": "Jersey",
      "JT": "Johnston Island",
      "JO": "Jordan",
      "KZ": "Kazakhstan",
      "KE": "Kenya",
      "KI": "Kiribati",
      "KP": "Korea (Democratic People's Republic of)",
      "KR": "Korea, Republic of",
      "XK": "Kosovo",
      "KW": "Kuwait",
      "KG": "Kyrgyzstan",
      "LA": "Lao People's Democratic Republic",
      "LV": "Latvia",
      "LB": "Lebanon",
      "LS": "Lesotho",
      "LR": "Liberia",
      "LY": "Libya",
      "LI": "Liechtenstein",
      "LT": "Lithuania",
      "LU": "Luxembourg",
      "MO": "Macau SAR",
      "MK": "North Macedonia",
      "MG": "Madagascar",
      "MW": "Malawi",
      "MY": "Malaysia",
      "MV": "Maldives",
      "ML": "Mali",
      "MT": "Malta",
      "MH": "Marshall Islands",
      "MQ": "Martinique",
      "MR": "Mauritania",
      "MU": "Mauritius",
      "YT": "Mayotte",
      "FX": "Metropolitan France",
      "MX": "Mexico",
      "FM": "Micronesia (Federated States of)",
      "MI": "Midway Islands",
      "MD": "Moldova, Republic of",
      "MC": "Monaco",
      "MN": "Mongolia",
      "ME": "Montenegro",
      "MS": "Montserrat",
      "MA": "Morocco",
      "MZ": "Mozambique",
      "MM": "Myanmar",
      "NA": "Namibia",
      "NR": "Nauru",
      "NP": "Nepal",
      "NL": "Netherlands",
      "AN": "Netherlands Antilles",
      "NT": "Neutral Zone",
      "NC": "New Caledonia",
      "NZ": "New Zealand",
      "NI": "Nicaragua",
      "NE": "Niger",
      "NG": "Nigeria",
      "NU": "Niue",
      "NF": "Norfolk Island",
      "VD": "North Vietnam",
      "MP": "Northern Mariana Islands",
      "NO": "Norway",
      "OM": "Oman",
      "OM_mobile": "Oman Mobile",
      "QO": "Outlying Oceania",
      "PC": "Pacific Islands Trust Territory",
      "PK": "Pakistan",
      "PW": "Palau",
      "PS": "Palestine, State of",
      "PA": "Panama",
      "PZ": "Panama Canal Zone",
      "PY": "Paraguay",
      "YD": "People's Democratic Republic of Yemen",
      "PE": "Peru",
      "PH": "Philippines",
      "PN": "Pitcairn",
      "PL": "Poland",
      "PT": "Portugal",
      "PR": "Puerto Rico",
      "QA": "Qatar",
      "RE": "R\u00E9union",
      "RO": "Romania",
      "RU": "Russian Federation",
      "RW": "Rwanda",
      "BL": "Saint Barth\u00E9lemy",
      "SH": "Saint Helena, Ascension and Tristan da Cunha",
      "KN": "Saint Kitts and Nevis",
      "LC": "Saint Lucia",
      "MF": "Saint Martin (French part)",
      "PM": "Saint Pierre and Miquelon",
      "VC": "Saint Vincent and the Grenadines",
      "WS": "Samoa",
      "SM": "San Marino",
      "ST": "Sao Tome and Principe",
      "SA": "Saudi Arabia",
      "SN": "Senegal",
      "RS": "Serbia",
      "CS": "Serbia and Montenegro",
      "SC": "Seychelles",
      "SL": "Sierra Leone",
      "SG": "Singapore",
      "SX": "Sint Maarten (Dutch part)",
      "SK": "Slovakia",
      "SI": "Slovenia",
      "SB": "Solomon Islands",
      "SO": "Somalia",
      "ZA": "South Africa",
      "GS": "South Georgia and the South Sandwich Islands",
      "ES": "Spain",
      "LK": "Sri Lanka",
      "SR": "Suriname",
      "SJ": "Svalbard and Jan Mayen",
      "SZ": "Eswatini",
      "SE": "Sweden",
      "CH": "Switzerland",
      "SY": "Syrian Arab Republic",
      "TW": "Taiwan, China",
      "TW_mobile": "Taiwan Mobile",
      "TJ": "Tajikistan",
      "TZ": "Tanzania, United Republic of",
      "TH": "Thailand",
      "TL": "Timor-Leste",
      "TG": "Togo",
      "TK": "Tokelau",
      "TO": "Tonga",
      "TT": "Trinidad and Tobago",
      "TA": "Tristan da Cunha",
      "TN": "Tunisia",
      "TR": "Turkey",
      "TM": "Turkmenistan",
      "TC": "Turks and Caicos Islands",
      "TV": "Tuvalu",
      "UM": "United States Minor Outlying Islands",
      "PU": "U.S. Miscellaneous Pacific Islands",
      "VI": "Virgin Islands (U.S.)",
      "UG": "Uganda",
      "UA": "Ukraine",
      "AE": "United Arab Emirates",
      "GB": "United Kingdom",
      "US": "United States of America",
      "UY": "Uruguay",
      "UZ": "Uzbekistan",
      "VU": "Vanuatu",
      "VA": "Holy See",
      "VE": "Venezuela (Bolivarian Republic of)",
      "VN": "Viet Nam",
      "WK": "Wake Island",
      "WF": "Wallis and Futuna",
      "EH": "Western Sahara",
      "YE": "Yemen",
      "ZM": "Zambia",
      "SD": "Sudan",
      "SS": "South Sudan",
      "ZW": "Zimbabwe",
      "CG": "Congo",
      "PG": "Papua New Guinea",
      "language.display": "{0} ({1})",
      "en-US": "USA",
      "en-GB": "UK",
      "zh-CN": "China",
      "es-ES": "Spain",
      "fr-FR": "France",
      "jp-JP": "Japan",
      "de-DE": "Germany",
      "pt-PT": "Portuguese",
      "ru-RU": "Russian",
      "TW-TW": "Taiwan"
    }
  },
  "de-DE": {
    "country": {
      "AF": "Afghanistan",
      "AX": "\u00C5land-Inseln",
      "AL": "Albanien",
      "DZ": "Algerien",
      "AS": "Amerikanisch-Samoa",
      "AD": "Andorra",
      "AO": "Angola",
      "AI": "Anguilla",
      "AQ": "Antarktis",
      "AG": "Antigua und Barbuda",
      "AR": "Argentinien",
      "AM": "Armenien",
      "AW": "Aruba",
      "AC": "Ascension",
      "AU": "Australien",
      "AT": "\u00D6sterreich",
      "AZ": "Aserbaidschan",
      "BS": "Bahamas",
      "BH": "Bahrain",
      "BD": "Bangladesch",
      "BB": "Barbados",
      "BY": "Wei\u00DFrussland",
      "BE": "Belgien",
      "BZ": "Belize",
      "BJ": "Benin",
      "BM": "Bermuda",
      "BT": "Bhutan",
      "BO": "Bolivien",
      "BA": "Bosnien und Herzegowina",
      "BW": "Botswana",
      "BV": "Bouvetinsel",
      "BR": "Brasilien",
      "BQ": "Bonaire, Sint Eustatius und Saba",
      "IO": "Britisches Territorium im Indischen Ozean",
      "VG": "Jungferninseln (Britisch)",
      "BN": "Brunei Darussalam",
      "BG": "Bulgarien",
      "BF": "Burkina Faso",
      "BI": "Burundi",
      "KH": "Kambodscha",
      "CM": "Kamerun",
      "CA": "Kanada",
      "IC": "Kanarische Inseln",
      "CT": "Kanton- und Enderbury-Insel",
      "CV": "Kapverdische Inseln",
      "KY": "Kaimaninseln",
      "CF": "Zentralafrikanische Republik",
      "EA": "Ceuta und Melilla",
      "TD": "Tschad",
      "CL": "Chile",
      "CN": "China",
      "CX": "Weihnachtsinseln",
      "CP": "Clipperton-Insel",
      "CC": "Kokosinseln",
      "CO": "Kolumbien",
      "KM": "Komoren",
      "CD": "Kongo, Demokratische Republik",
      "CK": "Cookinseln",
      "CR": "Costa Rica",
      "CI": "Cote d\u2018Ivoire",
      "HR": "Kroatien",
      "CU": "Kuba",
      "CW": "Cura\u00E7ao",
      "CY": "Zypern",
      "CZ": "Tschechien",
      "DK": "D\u00E4nemark",
      "DG": "Diego Garcia",
      "DJ": "Dschibuti",
      "DM": "Dominica",
      "DO": "Dominikanische Republik",
      "NQ": "K\u00F6nigin-Maud-Land",
      "EC": "Ecuador",
      "EG": "\u00C4gypten",
      "SV": "El Salvador",
      "GQ": "\u00C4quatorialguinea",
      "ER": "Eritrea",
      "EE": "Estland",
      "ET": "\u00C4thiopien",
      "EU": "Europ\u00E4ische Union",
      "FK": "Falklandinseln (Malvinen)",
      "FO": "F\u00E4r\u00F6ischen Inseln",
      "FJ": "Fidschi",
      "FI": "Finnland",
      "FR": "Frankreich",
      "GF": "Franz\u00F6sisch-Guayana",
      "PF": "Franz\u00F6sisch-Polynesien",
      "TF": "Franz\u00F6sische S\u00FCdgebiete",
      "FQ": "Franz\u00F6sische S\u00FCd- und Antarktisgebiete",
      "GA": "Gabun",
      "GM": "Gambia",
      "GE": "Georgien",
      "DE": "Deutschland",
      "GH": "Ghana",
      "GI": "Gibraltar",
      "GR": "Griechenland",
      "GL": "Gr\u00F6nland",
      "GD": "Grenada",
      "GP": "Guadeloupe",
      "GU": "Guam",
      "GT": "Guatemala",
      "GG": "Guernsey",
      "GN": "Guinea",
      "GW": "Guinea-Bissau",
      "GY": "Guyana",
      "HT": "Haiti",
      "HM": "Heard und McDonaldinseln",
      "HN": "Honduras",
      "HK": "Hongkong SAR",
      "HU": "Ungarn",
      "IS": "Island",
      "IN": "Indien",
      "ID": "Indonesien",
      "IR": "Iran",
      "IE": "Irland",
      "IM": "Isle of Man",
      "IL": "Israel",
      "IQ": "Irak",
      "IT": "Italien",
      "JM": "Jamaica",
      "JP": "Japan",
      "JE": "Jersey",
      "JT": "Johnston-Inseln",
      "JO": "Jordanien",
      "KZ": "Kasachstan",
      "KE": "Kenia",
      "KI": "Kiribati",
      "KP": "Korea (Demokratische Volksrepublik)",
      "KR": "Korea, Republik",
      "XK": "Kosovo",
      "KW": "Kuwait",
      "KG": "Kirgisistan",
      "LA": "Laos",
      "LV": "Lettland",
      "LB": "Libanon",
      "LS": "Lesotho",
      "LR": "Liberia",
      "LY": "Libyen",
      "LI": "Liechtenstein",
      "LT": "Litauen",
      "LU": "Luxemburg",
      "MO": "Macau SAR",
      "MK": "Nordmazedonien",
      "MG": "Madagaskar",
      "MW": "Malawi",
      "MY": "Malaysia",
      "MV": "Malediven",
      "ML": "Mali",
      "MT": "Malta",
      "MH": "Marschallinseln",
      "MQ": "Martinique",
      "MR": "Mauretanien",
      "MU": "Mauritius",
      "YT": "Mayotte",
      "FX": "Metropolitan-Frankreich",
      "MX": "Mexiko",
      "FM": "Mikronesien",
      "MI": "Midwayinseln",
      "MD": "Moldawien/Republik Moldau",
      "MC": "Monaco",
      "MN": "Mongolei",
      "ME": "Montenegro",
      "MS": "Montserrat",
      "MA": "Marokko",
      "MZ": "Mosambik",
      "MM": "Myanmar",
      "NA": "Namibia",
      "NR": "Nauru",
      "NP": "Nepal",
      "NL": "Niederlande",
      "AN": "Niederl\u00E4ndische Antillen",
      "NT": "Neutrale Zone",
      "NC": "Neukaledonien",
      "NZ": "Neuseeland",
      "NI": "Nicaragua",
      "NE": "Niger",
      "NG": "Nigeria",
      "NU": "Niue",
      "NF": "Norfolkinsel",
      "VD": "Nordvietnam",
      "MP": "N\u00F6rdliche Marianen",
      "NO": "Norwegen",
      "OM": "Oman",
      "QO": "Outlying Islands von Ozeanien",
      "PC": "Treuhandgebiet Pazifische Inseln",
      "PK": "Pakistan",
      "PW": "Palau",
      "PS": "Pal\u00E4stina",
      "PA": "Panama",
      "PZ": "Panamakanalzone",
      "PY": "Paraguay",
      "YD": "Demokratische Volksrepublik Jemen",
      "PE": "Peru",
      "PH": "Philippinen",
      "PN": "Pitcairn",
      "PL": "Polen",
      "PT": "Portugal",
      "PR": "Puerto Rico",
      "QA": "Katar",
      "RE": "Reunion",
      "RO": "Rum\u00E4nien",
      "RU": "Russische F\u00F6deration",
      "RW": "Ruanda",
      "BL": "St. Bartholom\u00E4us",
      "SH": "Saint Helena, Ascension und Tristan da Cunha",
      "KN": "St. Kitts und Nevis",
      "LC": "St. Lucia",
      "MF": "Saint Martin (franz\u00F6sischer Teil)",
      "PM": "St. Pierre und Miquelon",
      "VC": "St. Vincent und die Grenadinen",
      "WS": "Samoa",
      "SM": "San Marino",
      "ST": "Sao Tome und Principe",
      "SA": "Saudi-Arabien",
      "SN": "Senegal",
      "RS": "Serbien",
      "CS": "Serbien und Montenegro",
      "SC": "Seychellen",
      "SL": "Sierra Leone",
      "SG": "Singapur",
      "SX": "Sint Maarten (niederl\u00E4ndischer Teil)",
      "SK": "Slowakei",
      "SI": "Slowenien",
      "SB": "Salomonen",
      "SO": "Somalia",
      "ZA": "S\u00FCdafrika",
      "GS": "S\u00FCdgeorgien und die S\u00FCdlichen Sandwichinseln",
      "ES": "Spanien",
      "LK": "Sri Lanka",
      "SR": "Suriname",
      "SJ": "Svalbard und Jan Mayen",
      "SZ": "Eswatini",
      "SE": "Schweden",
      "CH": "Schweiz",
      "SY": "Syrische Arabische Republik",
      "TW": "Taiwan, China",
      "TJ": "Tadschikistan",
      "TZ": "Tansania",
      "TH": "Thailand",
      "TL": "Timor-Leste",
      "TG": "Togo",
      "TK": "Tokelau",
      "TO": "Tonga",
      "TT": "Trinidad und Tobago",
      "TA": "Tristan da Cunha",
      "TN": "Tunesien",
      "TR": "T\u00FCrkei",
      "TM": "Turkmenistan",
      "TC": "Turks- und Caicosinseln",
      "TV": "Tuvalu",
      "UM": "Kleinere Inselbesitzungen der Vereinigten Staaten",
      "PU": "U.S. Miscellaneous Pacific Islands",
      "VI": "Jungferninseln (USA)",
      "UG": "Uganda",
      "UA": "Ukraine",
      "AE": "Vereinigte Arabische Emirate",
      "GB": "Vereinigtes K\u00F6nigreich",
      "US": "Vereinigte Staaten von Amerika",
      "UY": "Uruguay",
      "UZ": "Usbekistan",
      "VU": "Vanuatu",
      "VA": "Vatikanstaat",
      "VE": "Venezuela",
      "VN": "Vietnam",
      "WK": "Wake-Insel",
      "WF": "Wallis und Futuna",
      "EH": "Westsahara",
      "YE": "Jemen",
      "ZM": "Sambia",
      "SD": "Sudan",
      "SS": "S\u00FCdsudan",
      "ZW": "Simbabwe",
      "fr-FR": "Frankreich",
      "en-GB": "Vereinigtes K\u00F6nigreich",
      "en-US": "USA",
      "zh-CN": "China",
      "es-ES": "Spanien",
      "language.display": "{0} ({1})",
      "OM_mobile": "Oman Mobile",
      "TW_mobile": "Taiwan Mobile",
      "de-DE": "Deutschland",
      "jp-JP": "Japan",
      "pt-PT": "Portugiesisch",
      "ru-RU": "Russisch",
      "TW-TW": "Taiwan",
      "PG": "Papua-Neuguinea",
      "CG": "Kongo"
    }
  },
  "es-ES": {
    "country": {
      "AF": "Afganist\u00E1n",
      "AX": "Islas \u00C5land",
      "AL": "Albania",
      "DZ": "Argelia",
      "AS": "Samoa Americana",
      "AD": "Andorra",
      "AO": "Angola",
      "AI": "Anguila",
      "AQ": "Ant\u00E1rtida",
      "AG": "Antigua y Barbuda",
      "AR": "Argentina",
      "AM": "Armenia",
      "AW": "Aruba",
      "AC": "Isla Ascensi\u00F3n",
      "AU": "Australia",
      "AT": "Austria",
      "AZ": "Azerbaiy\u00E1n",
      "BS": "Bahamas",
      "BH": "Bar\u00E9in",
      "BD": "Banglad\u00E9s",
      "BB": "Barbados",
      "BY": "Bielorrusia",
      "BE": "B\u00E9lgica",
      "BZ": "Belice",
      "BJ": "Ben\u00EDn",
      "BM": "Bermudas",
      "BT": "But\u00E1n",
      "BO": "Bolivia (Estado Plurinacional de)",
      "BA": "Bosnia-Herzegovina",
      "BW": "Botsuana\u00A0",
      "BV": "Bouvet Island",
      "BR": "Brasil\u00A0",
      "BQ": "Bonaire, San Eustaquio y Saba",
      "IO": "Territorio Brit\u00E1nico en el Oc\u00E9ano \u00CDndico",
      "VG": "Islas v\u00EDrgenes (Reino Unido)",
      "BN": "Brun\u00E9i",
      "BG": "Bulgaria",
      "BF": "Burkina Faso",
      "BI": "Burundi",
      "KH": "Camboya\u00A0",
      "CM": "Camer\u00FAn",
      "CA": "Canad\u00E1",
      "IC": "Canary Islands",
      "CT": "Canton and Enderbury Islands",
      "CV": "Cabo Verde",
      "KY": "Islas Caim\u00E1n",
      "CF": "Rep\u00FAblica Centroafricana",
      "EA": "Ceuta and Melilla",
      "TD": "Chad",
      "CL": "Chile",
      "CN": "China",
      "CX": "Isla de Navidad",
      "CP": "Clipperton Island",
      "CC": "Islas Cocos (Keeling)",
      "CO": "Colombia",
      "KM": "Comoros",
      "CD": "Congo, Rep\u00FAblica Democr\u00E1tica del",
      "CK": "Cook Islands",
      "CR": "Costa Rica",
      "CI": "Costa de Marfil",
      "HR": "Croacia",
      "CU": "Cuba",
      "CW": "Curazao",
      "CY": "Chipre",
      "CZ": "Rep\u00FAblica Checa",
      "DK": "Dinamarca",
      "DG": "Diego Garcia",
      "DJ": "Yibuti",
      "DM": "Dominica",
      "DO": "Rep\u00FAblica Dominicana",
      "NQ": "Dronning Maud Land",
      "EC": "Ecuador",
      "EG": "Egipto",
      "SV": "El Salvador",
      "GQ": "Guinea Ecuatorial",
      "ER": "Eritrea",
      "EE": "Estonia",
      "ET": "Etiop\u00EDa",
      "EU": "Uni\u00F3n Europea",
      "FK": "Islas Falkland (Malvinas)",
      "FO": "Islas Feroe",
      "FJ": "Fiyi",
      "FI": "Finlandia",
      "FR": "Francia",
      "GF": "Guayana Francesa",
      "PF": "Polinesia Francesa",
      "TF": "French Southern Territories",
      "FQ": "Territorios Australes Franceses",
      "GA": "Gab\u00F3n",
      "GM": "Gambia",
      "GE": "Georgia",
      "DE": "Alemania",
      "GH": "Ghana",
      "GI": "Gibraltar",
      "GR": "Grecia",
      "GL": "Groenlandia",
      "GD": "Granada",
      "GP": "Guadalupe",
      "GU": "Guam",
      "GT": "Guatemala",
      "GG": "Guernesey",
      "GN": "Rep\u00FAblica Guinea",
      "GW": "Guinea-Bissau",
      "GY": "Guyana",
      "HT": "Hait\u00ED",
      "HM": "Islas Heard y McDonald",
      "HN": "Honduras",
      "HK": "RAE de Hong Kong",
      "HU": "Hungr\u00EDa",
      "IS": "Islandia",
      "IN": "India",
      "ID": "Indonesia",
      "IR": "Ir\u00E1n (Rep\u00FAblica Isl\u00E1mica de)",
      "IE": "Irlanda",
      "IM": "Isla de Man",
      "IL": "Israel",
      "IQ": "Iraq",
      "IT": "Italia",
      "JM": "Jamaica",
      "JP": "Jap\u00F3n",
      "JE": "Isla de Jersey",
      "JT": "Johnston Island",
      "JO": "Jordania",
      "KZ": "Kazajst\u00E1n",
      "KE": "Kenia",
      "KI": "Kiribati",
      "KP": "Corea (Rep\u00FAblica Popular Democr\u00E1tica de)",
      "KR": "Corea, Rep\u00FAblica de",
      "XK": "Kosovo",
      "KW": "Kuwait",
      "KG": "Kirguist\u00E1n",
      "LA": "Rep\u00FAblica Popular Democr\u00E1tica de Laos",
      "LV": "Letonia",
      "LB": "L\u00EDbano",
      "LS": "Lesotho",
      "LR": "Liberia",
      "LY": "Libia",
      "LI": "Liechtenstein",
      "LT": "Lituania",
      "LU": "Luxemburgo",
      "MO": "RAE de Macao",
      "MK": "Macedonia del Norte",
      "MG": "Madagascar",
      "MW": "Malawi",
      "MY": "Malasia",
      "MV": "Maldivas",
      "ML": "Mal\u00ED",
      "MT": "Malta",
      "MH": "Islas Marshall",
      "MQ": "Martinica",
      "MR": "Mauritania",
      "MU": "Mauricio",
      "YT": "Mayotte",
      "FX": "Metropolitan France",
      "MX": "M\u00E9xico",
      "FM": "Micronesia (Estados Federados de)",
      "MI": "Midway Islands",
      "MD": "Moldavia, Rep\u00FAblica de",
      "MC": "M\u00F3naco",
      "MN": "Mongolia",
      "ME": "Montenegro",
      "MS": "Montserrat",
      "MA": "Marruecos",
      "MZ": "Mozambique",
      "MM": "Myanmar",
      "NA": "Namibia",
      "NR": "Nauru",
      "NP": "Nepal",
      "NL": "Pa\u00EDses Bajos",
      "AN": "Netherlands Antilles",
      "NT": "Neutral Zone",
      "NC": "Nueva Caledonia",
      "NZ": "Nueva Zelanda",
      "NI": "Nicaragua",
      "NE": "N\u00EDger",
      "NG": "Nigeria",
      "NU": "Niue",
      "NF": "Isla Norfolk",
      "VD": "North Vietnam",
      "MP": "Islas Marianas del Norte",
      "NO": "Noruega",
      "OM": "Om\u00E1n",
      "QO": "Outlying Oceania",
      "PC": "Pacific Islands Trust Territory",
      "PK": "Pakist\u00E1n",
      "PW": "Palaos",
      "PS": "Palestina",
      "PA": "Panam\u00E1",
      "PZ": "Panama Canal Zone",
      "PY": "Paraguay",
      "YD": "People's Democratic Republic of Yemen",
      "PE": "Per\u00FA",
      "PH": "Filipinas",
      "PN": "Pitcairn",
      "PL": "Polonia",
      "PT": "Portugal",
      "PR": "Puerto Rico",
      "QA": "Qatar",
      "RE": "Reuni\u00F3n",
      "RO": "Ruman\u00EDa",
      "RU": "Federaci\u00F3n Rusa",
      "RW": "Ruanda",
      "BL": "Saint Barth\u00E9lemy",
      "SH": "Santa Helena, Ascensi\u00F3n y Trist\u00E1n de Acu\u00F1a",
      "KN": "San Crist\u00F3bal y Nieves",
      "LC": "Santa Luc\u00EDa",
      "MF": "San Mart\u00EDn (parte francesa)",
      "PM": "San Pedro y Miquel\u00F3n",
      "VC": "San Vicente y las Granadinas",
      "WS": "Samoa",
      "SM": "San Marino",
      "ST": "Santo Tom\u00E9 y Pr\u00EDncipe",
      "SA": "Arabia Saudita",
      "SN": "Senegal",
      "RS": "Serbia",
      "CS": "Serbia and Montenegro",
      "SC": "Seychelles",
      "SL": "Sierra Leona",
      "SG": "Singapur",
      "SX": "Sint Maarten (parte holandesa)",
      "SK": "Eslovaquia",
      "SI": "Eslovenia",
      "SB": "Islas Salom\u00F3n",
      "SO": "Somalia",
      "ZA": "Sud\u00E1frica",
      "GS": "South Georgia and the South Sandwich Islands",
      "ES": "Espa\u00F1a",
      "LK": "Sri Lanka",
      "SR": "Suriname",
      "SJ": "Svalbard and Jan Mayen",
      "SZ": "Suazilandia",
      "SE": "Sweden",
      "CH": "Suiza",
      "SY": "Syrian Arab Republic",
      "TW": "Taiw\u00E1n, China",
      "TJ": "Tayikist\u00E1n",
      "TZ": "Tanzania, Rep\u00FAblica Unida de",
      "TH": "Tailandia",
      "TL": "Timor-Leste",
      "TG": "Togo",
      "TK": "Tokelau",
      "TO": "Tonga",
      "TT": "Trinidad y Tobago",
      "TA": "Tristan da Cunha",
      "TN": "T\u00FAnez",
      "TR": "Turqu\u00EDa",
      "TM": "Turkmenist\u00E1n",
      "TC": "Islas Turcas y Caicos",
      "TV": "Tuvalu",
      "UM": "Islas Ultramarinas Menores de los Estados Unidos",
      "PU": "U.S. Miscellaneous Pacific Islands",
      "VI": "Islas v\u00EDrgenes (EE. UU.)",
      "UG": "Uganda",
      "UA": "Ucrania",
      "AE": "Emiratos \u00C1rabes Unidos",
      "GB": "Reino Unido",
      "US": "Estados Unidos de Am\u00E9rica",
      "UY": "Uruguay",
      "UZ": "Uzbekist\u00E1n",
      "VU": "Vanuatu",
      "VA": "Santa Sede",
      "VE": "Venezuela (Rep\u00FAblica Bolivariana de)",
      "VN": "Vietnam",
      "WK": "Wake Island",
      "WF": "Wallis and Futuna",
      "EH": "S\u00E1hara Occidental",
      "YE": "Yemen",
      "ZM": "Zambia",
      "SD": "Sud\u00E1n",
      "SS": "Sud\u00E1n del Sur",
      "ZW": "Zimbabue",
      "fr-FR": "Francia",
      "en-GB": "Reino Unido",
      "en-US": "Estados Unidos",
      "zh-CN": "China",
      "es-ES": "Espa\u00F1a",
      "language.display": "{0} ({1})",
      "OM_mobile": "M\u00F3vil Oman",
      "TW_mobile": "M\u00F3vil Taiw\u00E1n",
      "de-DE": "Alemania",
      "jp-JP": "Jap\u00F3n",
      "pt-PT": "Portugu\u00E9s",
      "ru-RU": "Ruso",
      "TW-TW": "Taiw\u00E1n",
      "PG": "Pap\u00FAa Nueva Guinea",
      "CG": "Congo"
    }
  },
  "fr-FR": {
    "country": {
      "AF": "Afghanistan",
      "AX": "\u00CEles d\u2019Aland",
      "AL": "Albania",
      "DZ": "Alg\u00E9rie",
      "AS": "Samoa am\u00E9ricaines",
      "AD": "Andorra",
      "AO": "Angola",
      "AI": "Anguilla",
      "AQ": "Antarctique",
      "AG": "Antigua-et-Barbuda",
      "AR": "Argentina",
      "AM": "Arm\u00E9nie",
      "AW": "Aruba",
      "AC": "Ascension Island",
      "AU": "Australia",
      "AT": "Austria",
      "AZ": "Azerba\u00EFdjan",
      "BS": "Bahamas",
      "BH": "Bahre\u00EFn",
      "BD": "Bangladesh",
      "BB": "Barbados",
      "BY": "Bi\u00E9lorussie",
      "BE": "Belgique",
      "BZ": "Belize",
      "BJ": "B\u00E9nin",
      "BM": "Bermudes",
      "BT": "Bhoutan",
      "BO": "Bolivie (\u00C9tat plurinational de)",
      "BA": "Bosnie-Herz\u00E9govine",
      "BW": "Botswana",
      "BV": "\u00CEle Bouvet",
      "BR": "Br\u00E9sil",
      "BQ": "Bonaire, Saint-Eustatius et Saba",
      "IO": "Bonaire, Saint Eustatius and Saba",
      "VG": "\u00CEles Vierges (Britanniques)",
      "BN": "Brunei Darussalam",
      "BG": "Bulgaria",
      "BF": "Burkina Faso",
      "BI": "Burundi",
      "KH": "Cambodge",
      "CM": "Cameroun",
      "CA": "Canada",
      "IC": "Canary Islands",
      "CT": "Canton and Enderbury Islands",
      "CV": "Cap-Vert",
      "KY": "\u00CEles Ca\u00EFmans",
      "CF": "Central African Republic",
      "EA": "Ceuta and Melilla",
      "TD": "Tchad",
      "CL": "Chili",
      "CN": "Chine",
      "CX": "\u00CEle Christmas",
      "CP": "Clipperton Island",
      "CC": "\u00CEles Cocos (Keeling)",
      "CO": "Colombie",
      "KM": "Comores",
      "CD": "Congo, R\u00E9publique d\u00E9mocratique du",
      "CK": "\u00CEles Cook",
      "CR": "Costa Rica",
      "CI": "C\u00F4te d\u2019Ivoire",
      "HR": "Croatia",
      "CU": "Cuba",
      "CW": "Cura\u00E7ao",
      "CY": "Cyprus",
      "CZ": "Tch\u00E9quie",
      "DK": "Denmark",
      "DG": "Diego Garcia",
      "DJ": "Djibouti",
      "DM": "Dominica",
      "DO": "R\u00E9publique dominicaine",
      "NQ": "Dronning Maud Land",
      "EC": "Equateur",
      "EG": "\u00C9gypte",
      "SV": "El Salvador",
      "GQ": "Guin\u00E9e \u00E9quatoriale",
      "ER": "Erythr\u00E9e",
      "EE": "Estonie",
      "ET": "\u00C9thiopie",
      "EU": "European Union",
      "FK": "\u00CEles Falkland (Malvinas)",
      "FO": "\u00CEles F\u00E9ro\u00E9",
      "FJ": "Fidji",
      "FI": "Finlande",
      "FR": "France",
      "GF": "Guyane fran\u00E7aise",
      "PF": "Polyn\u00E9sie fran\u00E7aise",
      "TF": "French Southern Territories",
      "FQ": "French Southern and Antarctic Territories",
      "GA": "Gabon",
      "GM": "Gambia",
      "GE": "G\u00E9orgie",
      "DE": "Allemagne",
      "GH": "Ghana",
      "GI": "Gibraltar",
      "GR": "Gr\u00E8ce",
      "GL": "Greenland",
      "GD": "Grenada",
      "GP": "Guadeloupe",
      "GU": "Guam",
      "GT": "Guatemala",
      "GG": "Guernsey",
      "GN": "Guin\u00E9e",
      "GW": "Guin\u00E9e-Bissau",
      "GY": "Guyana",
      "HT": "Ha\u00EFti",
      "HM": "Heard Island and McDonald Islands",
      "HN": "Honduras",
      "HK": "RAS de Hong Kong",
      "HU": "Hongrie",
      "IS": "Islande",
      "IN": "Inde",
      "ID": "Indon\u00E9sie",
      "IR": "Iran (R\u00E9publique Islamique d\u2019)",
      "IE": "Ireland",
      "IM": "Isle of Man",
      "IL": "Isra\u00EBl",
      "IQ": "Iraq",
      "IT": "Italie",
      "JM": "Jamaica",
      "JP": "Japon",
      "JE": "Jersey",
      "JT": "Johnston Island",
      "JO": "Jordanie",
      "KZ": "Kazakhstan",
      "KE": "Kenya",
      "KI": "Kiribati",
      "KP": "Cor\u00E9e (R\u00E9publique Populaire D\u00E9mocratique de)",
      "KR": "Cor\u00E9e, R\u00E9publique de",
      "XK": "Kosovo",
      "KW": "Kowe\u00EFt",
      "KG": "Kirghizistan",
      "LA": "R\u00E9publique D\u00E9mocratique Populaire Lao",
      "LV": "Lettonie",
      "LB": "Liban",
      "LS": "Lesotho",
      "LR": "Liberia",
      "LY": "Libya",
      "LI": "Liechtenstein",
      "LT": "Lithuania",
      "LU": "Luxembourg",
      "MO": "RAS de Macao",
      "MK": "Mac\u00E9doine du Nord",
      "MG": "Madagascar",
      "MW": "Malawi",
      "MY": "Malaisie",
      "MV": "Maldives",
      "ML": "Mali",
      "MT": "Malta",
      "MH": "\u00CEles Marshall",
      "MQ": "Martinique",
      "MR": "Mauritania",
      "MU": "Maurice",
      "YT": "Mayotte",
      "FX": "Metropolitan France",
      "MX": "Mexique",
      "FM": "Micron\u00E9sie (\u00C9tats F\u00E9d\u00E9r\u00E9s de)",
      "MI": "Midway Islands",
      "MD": "Moldavie, R\u00E9publique de",
      "MC": "Monaco",
      "MN": "Mongolie",
      "ME": "Montenegro",
      "MS": "Montserrat",
      "MA": "Maroc",
      "MZ": "Mozambique",
      "MM": "Myanmar",
      "NA": "Namibie",
      "NR": "Nauru",
      "NP": "N\u00E9pal",
      "NL": "Pays-Bas",
      "AN": "Antilles n\u00E9erlandaises",
      "NT": "Neutral Zone",
      "NC": "Nouvelle-Cal\u00E9donie",
      "NZ": "Nouvelle-Z\u00E9lande",
      "NI": "Nicaragua",
      "NE": "Niger",
      "NG": "Nig\u00E9ria",
      "NU": "Niue",
      "NF": "\u00CEle Norfolk",
      "VD": "North Vietnam",
      "MP": "Northern Mariana Islands",
      "NO": "Norv\u00E8ge",
      "OM": "Oman",
      "QO": "Outlying Oceania",
      "PC": "Pacific Islands Trust Territory",
      "PK": "Pakistan",
      "PW": "Palau",
      "PS": "Palestine, \u00C9tat de",
      "PA": "Panama",
      "PZ": "Panama Canal Zone",
      "PY": "Paraguay",
      "YD": "People's Democratic Republic of Yemen",
      "PE": "Peru",
      "PH": "Philippines",
      "PN": "Pitcairn",
      "PL": "Pologne",
      "PT": "Portugal",
      "PR": "Puerto Rico",
      "QA": "Qatar",
      "RE": "R\u00E9union",
      "RO": "Roumanie",
      "RU": "F\u00E9d\u00E9ration de Russie",
      "RW": "Rwanda",
      "BL": "Saint Barth\u00E9lemy",
      "SH": "Sainte-H\u00E9l\u00E8ne, Ascension et Tristan da Cunha",
      "KN": "Saint-Kitts-et-Nevis",
      "LC": "Sainte-Lucie",
      "MF": "Saint-Martin (Antilles fran\u00E7aises)",
      "PM": "Saint Pierre and Miquelon",
      "VC": "Saint Vincent and the Grenadines",
      "WS": "Samoa (ind\u00E9pendantes)",
      "SM": "Saint-Marin",
      "ST": "Sao Tom\u00E9-et-Principe",
      "SA": "Arabie Saoudite",
      "SN": "S\u00E9n\u00E9gal",
      "RS": "Serbie",
      "CS": "Serbia and Montenegro",
      "SC": "Seychelles",
      "SL": "Sierra Leone",
      "SG": "Singapour",
      "SX": "Saint-Martin (Royaume des Pays-Bas)",
      "SK": "Slovaquie",
      "SI": "Slov\u00E9nie",
      "SB": "\u00CEles Salomon",
      "SO": "Somalia",
      "ZA": "Afrique du Sud",
      "GS": "South Georgia and the South Sandwich Islands",
      "ES": "Espagne",
      "LK": "Sri Lanka",
      "SR": "Suriname",
      "SJ": "Svalbard and Jan Mayen",
      "SZ": "Eswatini",
      "SE": "Su\u00E8de",
      "CH": "Suisse",
      "SY": "Syrian Arab Republic",
      "TW": "Ta\u00EFwan, Chine",
      "TJ": "Tajikistan",
      "TZ": "Tanzanie, R\u00E9publique Unie de",
      "TH": "Tha\u00EFlande",
      "TL": "Timor-Leste",
      "TG": "Togo",
      "TK": "Tokelau",
      "TO": "Tonga",
      "TT": "Trinit\u00E9-et-Tobago",
      "TA": "Tristan da Cunha",
      "TN": "Tunisie",
      "TR": "Turquie",
      "TM": "Turkm\u00E9nistan",
      "TC": "Turks and Caicos Islands",
      "TV": "Tuvalu",
      "UM": "\u00CEles mineures \u00E9loign\u00E9es des \u00C9tats-Unis",
      "PU": "U.S. Miscellaneous Pacific Islands",
      "VI": "\u00CEles Vierges (\u00C9tats-Unis)",
      "UG": "Ouganda",
      "UA": "Ukraine",
      "AE": "\u00C9mirats arabes unis",
      "GB": "Royaume-Uni",
      "US": "\u00C9tats-Unis d\u2019Am\u00E9rique",
      "UY": "Uruguay",
      "UZ": "Ouzb\u00E9kistan",
      "VU": "Vanuatu",
      "VA": "Saint-Si\u00E8ge",
      "VE": "Venezuela (R\u00E9publique Bolivarienne du)",
      "VN": "Vietnam",
      "WK": "Wake Island",
      "WF": "Wallis and Futuna",
      "EH": "Sahara occidental",
      "YE": "Y\u00E9men",
      "ZM": "Zambie",
      "SD": "Sudan",
      "SS": "South Sudan",
      "ZW": "Zimbabwe",
      "fr-FR": "Fran\u00E7ais",
      "en-GB": "Royaume-Uni",
      "en-US": "\u00C9tats-Unis",
      "zh-CN": "Chine",
      "es-ES": "Espagne",
      "language.display": "{0} ({1})",
      "OM_mobile": "Oman Mobile",
      "TW_mobile": "Taiwan Mobile",
      "de-DE": "Allemagne",
      "jp-JP": "Japon",
      "pt-PT": "Portugais",
      "ru-RU": "Russe",
      "TW-TW": "Ta\u00EFwan",
      "PG": "Papouasie-Nouvelle-Guin\u00E9e",
      "CG": "Congo"
    }
  },
  "it-IT": {
    "country": {
      "AF": "Afghanistan",
      "AX": "Isole \u00C5land",
      "AL": "Albania",
      "DZ": "Algeria",
      "AS": "Samoa Americane",
      "AD": "Andorra",
      "AO": "Angola",
      "AI": "Anguilla",
      "AQ": "Antartide",
      "AG": "Antigua e Barbuda",
      "AR": "Argentina",
      "AM": "Armenia",
      "AW": "Aruba",
      "AC": "Isola dell\u2019Ascensione",
      "AU": "Australia",
      "AT": "Austria",
      "AZ": "Azerbaigian",
      "BS": "Bahamas",
      "BH": "Bahrain",
      "BD": "Bangladesh",
      "BB": "Barbados",
      "BY": "Bielorussia",
      "BE": "Belgio",
      "BZ": "Belize",
      "BJ": "Benin",
      "BM": "Bermuda",
      "BT": "Bhutan",
      "BO": "Stato Plurinazionale della Bolivia",
      "BA": "Bosnia ed Erzegovina",
      "BW": "Botswana",
      "BV": "Isola Bouvet",
      "BR": "Brasile",
      "BQ": "Bonaire, Sint Eustatius e Saba.",
      "IO": "Territori Britannici dell\u2019Oceano Indiano",
      "VG": "Isole vergini (britanniche)",
      "BN": "Sultanato del Brunei",
      "BG": "Bulgaria",
      "BF": "Burkina Faso",
      "BI": "Burundi",
      "KH": "Cambogia",
      "CM": "Camerun",
      "CA": "Canada",
      "IC": "Isole Canarie",
      "CT": "Isole Canton ed Enderbury",
      "CV": "Capo Verde",
      "KY": "Isole Cayman",
      "CF": "Repubblica Centrafricana",
      "EA": "Ceuta e Melilla",
      "TD": "Ciad",
      "CL": "Cile",
      "CN": "Cina",
      "CX": "Isola di Natale",
      "CP": "Isola Clipperton",
      "CC": "Isole Cocos (Keeling)",
      "CO": "Colombia",
      "KM": "Comore",
      "CD": "Repubblica Democratica del Congo",
      "CK": "Isole Cook",
      "CR": "Costa Rica",
      "CI": "Costa d\u2019Avorio",
      "HR": "Croazia",
      "CU": "Cuba",
      "CW": "Cura\u00E7ao",
      "CY": "Cipro",
      "CZ": "Repubblica Ceca",
      "DK": "Danimarca",
      "DG": "Diego Garcia",
      "DJ": "Gibuti",
      "DM": "Dominica",
      "DO": "Repubblica Dominicana",
      "NQ": "Terra della regina Maud",
      "EC": "Ecuador",
      "EG": "Egitto",
      "SV": "El Salvador",
      "GQ": "Guinea Equatoriale",
      "ER": "Eritrea",
      "EE": "Estonia",
      "ET": "Etiopia",
      "EU": "Unione Europea",
      "FK": "Isole Falkland (Malvine)",
      "FO": "Isole Faroe",
      "FJ": "Figi",
      "FI": "Finlandia",
      "FR": "Francia",
      "GF": "Guiana francese",
      "PF": "Polinesia francese",
      "TF": "Terre australi francesi",
      "FQ": "Terre australi e antartiche francesi",
      "GA": "Gabon",
      "GM": "Gambia",
      "GE": "Georgia",
      "DE": "Germania",
      "GH": "Ghana",
      "GI": "Gibilterra",
      "GR": "Grecia",
      "GL": "Groenlandia",
      "GD": "Grenada",
      "GP": "Guadalupe",
      "GU": "Guam",
      "GT": "Guatemala",
      "GG": "Guernsey",
      "GN": "Guinea",
      "GW": "Guinea-Bissau",
      "GY": "Guyana",
      "HT": "Haiti",
      "HM": "Isole Heard e McDonald",
      "HN": "Honduras",
      "HK": "RAS di Hong Kong",
      "HU": "Ungheria",
      "IS": "Islanda",
      "IN": "India",
      "ID": "Indonesia",
      "IR": "Repubblica Islamica dell\u2019Iran",
      "IE": "Irlanda",
      "IM": "Isola di Man",
      "IL": "Israele",
      "IQ": "Iraq",
      "IT": "Italia",
      "JM": "Giamaica",
      "JP": "Giappone",
      "JE": "Jersey",
      "JT": "Atollo Johnston",
      "JO": "Giordania",
      "KZ": "Kazakhistan",
      "KE": "Kenya",
      "KI": "Kiribati",
      "KP": "Repubblica Democratica Popolare di Corea",
      "KR": "Repubblica di Corea",
      "XK": "Kosovo",
      "KW": "Kuwait",
      "KG": "Kirghizistan",
      "LA": "Repubblica Democratica Popolare del Laos",
      "LV": "Lettonia",
      "LB": "Libano",
      "LS": "Lesotho",
      "LR": "Liberia",
      "LY": "Libia",
      "LI": "Liechtenstein",
      "LT": "Lituania",
      "LU": "Lussemburgo",
      "MO": "RAS di Macao",
      "MK": "Macedonia del Nord",
      "MG": "Madagascar",
      "MW": "Malawi",
      "MY": "Malesia",
      "MV": "Maldive",
      "ML": "Mali",
      "MT": "Malta",
      "MH": "Isole Marshall",
      "MQ": "Martinica",
      "MR": "Mauritania",
      "MU": "Maurizio",
      "YT": "Mayotte",
      "FX": "Francia Metropolitana",
      "MX": "Messico",
      "FM": "Stati Federati della Micronesia",
      "MI": "Isole Midway",
      "MD": "Repubblica di Moldavia",
      "MC": "Monaco",
      "MN": "Mongolia",
      "ME": "Montenegro",
      "MS": "Montserrat",
      "MA": "Marocco",
      "MZ": "Mozambico",
      "MM": "Myanmar",
      "NA": "Namibia",
      "NR": "Nauru",
      "NP": "Nepal",
      "NL": "Paesi Bassi",
      "AN": "Paesi Bassi Caraibici",
      "NT": "Zona Neutra",
      "NC": "Nuova Caledonia",
      "NZ": "Nuova Zelanda",
      "NI": "Nicaragua",
      "NE": "Niger",
      "NG": "Nigeria",
      "NU": "Niue",
      "NF": "Isola Norfolk",
      "VD": "Vietnam del Nord",
      "MP": "Isole Marianne Settentrionali",
      "NO": "Norvegia",
      "OM": "Oman",
      "OM_mobile": "Oman Mobile",
      "QO": "Territori Periferici dell\u2019Oceania",
      "PC": "Territorio fiduciario delle Isole del Pacifico",
      "PK": "Pakistan",
      "PW": "Palau",
      "PS": "Stato della Palestina",
      "PA": "Panama",
      "PZ": "Zona del Canale di Panama",
      "PY": "Paraguay",
      "YD": "Repubblica Democratica Popolare dello Yemen",
      "PE": "Per\u00F9",
      "PH": "Filippine",
      "PN": "Pitcairn",
      "PL": "Polonia",
      "PT": "Portogallo",
      "PR": "Porto Rico",
      "QA": "Qatar",
      "RE": "Riunione",
      "RO": "Romania",
      "RU": "Federazione Russa",
      "RW": "Ruanda",
      "BL": "Saint-Barth\u00E9lemy",
      "SH": "Sant\u2019Elena, Ascensione e Tristan da Cunha",
      "KN": "Saint Kitts e Nevis",
      "LC": "Santa Lucia",
      "MF": "San Martino (parte francese)",
      "PM": "Saint Pierre Miquelon",
      "VC": "Saint Vincent e Grenadine",
      "WS": "Samoa",
      "SM": "San Marino",
      "ST": "S\u00E3o Tom\u00E9 e Pr\u00EDncipe",
      "SA": "Arabia Saudita",
      "SN": "Senegal",
      "RS": "Serbia",
      "CS": "Serbia e Montenegro",
      "SC": "Seychelles",
      "SL": "Sierra Leone",
      "SG": "Singapore",
      "SX": "San Martino (parte olandese)",
      "SK": "Slovacchia",
      "SI": "Slovenia",
      "SB": "Isole Salomone",
      "SO": "Somalia",
      "ZA": "Sudafrica",
      "GS": "Georgia del Sud e Isole Sandwich Australi",
      "ES": "Spagna",
      "LK": "Sri Lanka",
      "SR": "Suriname",
      "SJ": "Svalbard e Jan Mayen",
      "SZ": "Eswatini",
      "SE": "Svezia",
      "CH": "Svizzera",
      "SY": "Repubblica Araba Siriana",
      "TW": "Taiwan, Cina",
      "TW_mobile": "Taiwan Mobile",
      "TJ": "Tagikistan",
      "TZ": "Repubblica Unita di Tanzania",
      "TH": "Tailandia",
      "TL": "Timor Est",
      "TG": "Togo",
      "TK": "Tokelau",
      "TO": "Tonga",
      "TT": "Trinidad e Tobago",
      "TA": "Tristan da Cunha",
      "TN": "Tunisia",
      "TR": "Turchia",
      "TM": "Turkmenistan",
      "TC": "Turks e Caicos",
      "TV": "Tuvalu",
      "UM": "Isole minori esterne degli Stati Uniti d\u2019America",
      "PU": "Stati Uniti Varie Isole del Pacifico",
      "VI": "Isole vergini (statunitensi)",
      "UG": "Uganda",
      "UA": "Ucraina",
      "AE": "Emirati Arabi Uniti",
      "GB": "Regno Unito",
      "US": "Stati Uniti d\u2019America",
      "UY": "Uruguay",
      "UZ": "Uzbekistan",
      "VU": "Vanuatu",
      "VA": "Vaticano",
      "VE": "Repubblica Bolivariana del Venezuela",
      "VN": "Vietnam",
      "WK": "Isola di Wake",
      "WF": "Wallis e Futuna",
      "EH": "Sahara Occidentale",
      "YE": "Yemen",
      "ZM": "Zambia",
      "SD": "Sudan",
      "SS": "Sudan del Sud",
      "ZW": "Zimbabwe",
      "CG": "Congo",
      "PG": "Papua Nuova Guinea",
      "language.display": "{0} ({1})",
      "en-US": "Stati Uniti d\u2019America",
      "en-GB": "Regno Unito",
      "zh-CN": "Cina",
      "es-ES": "Spagna",
      "fr-FR": "Francia",
      "jp-JP": "Giappone",
      "de-DE": "Germania",
      "pt-PT": "Portoghese",
      "ru-RU": "Russo",
      "TW-TW": "Taiwan"
    }
  },
  "jp-JP": {
    "country": {
      "AF": "\u30A2\u30D5\u30AC\u30CB\u30B9\u30BF\u30F3",
      "AX": "\u30AA\u30FC\u30E9\u30F3\u30C9\u8AF8\u5CF6",
      "AL": "\u30A2\u30EB\u30D0\u30CB\u30A2",
      "DZ": "\u30A2\u30EB\u30B8\u30A7\u30EA\u30A2",
      "AS": "\u30A2\u30E1\u30EA\u30AB\u9818\u30B5\u30E2\u30A2",
      "AD": "\u30A2\u30F3\u30C9\u30E9",
      "AO": "\u30A2\u30F3\u30B4\u30E9",
      "AI": "\u30A2\u30F3\u30AE\u30E9",
      "AQ": "\u5357\u6975\u5927\u9678",
      "AG": "\u30A2\u30F3\u30C1\u30B0\u30A2\u30D0\u30FC\u30D6\u30FC\u30C0",
      "AR": "\u30A2\u30EB\u30BC\u30F3\u30C1\u30F3",
      "AM": "\u30A2\u30EB\u30E1\u30CB\u30A2",
      "AW": "\u30A2\u30EB\u30D0",
      "AC": "\u30A2\u30BB\u30F3\u30B7\u30E7\u30F3\u5CF6",
      "AU": "\u30AA\u30FC\u30B9\u30C8\u30E9\u30EA\u30A2",
      "AT": "\u30AA\u30FC\u30B9\u30C8\u30EA\u30A2",
      "AZ": "\u30A2\u30BC\u30EB\u30D0\u30A4\u30B8\u30E3\u30F3",
      "BS": "\u30D0\u30CF\u30DE",
      "BH": "\u30D0\u30FC\u30EC\u30FC\u30F3",
      "BD": "\u30D0\u30F3\u30B0\u30E9\u30C7\u30B7\u30E5",
      "BB": "\u30D0\u30EB\u30D0\u30C9\u30B9",
      "BY": "\u30D9\u30E9\u30EB\u30FC\u30B7",
      "BE": "\u30D9\u30EB\u30AE\u30FC",
      "BZ": "\u30D9\u30EA\u30FC\u30BA",
      "BJ": "\u30D9\u30CA\u30F3",
      "BM": "\u30D0\u30DF\u30E5\u30FC\u30C0",
      "BT": "\u30D6\u30FC\u30BF\u30F3",
      "BO": "\u30DC\u30EA\u30D3\u30A2\u591A\u6C11\u65CF\u56FD",
      "BA": "\u30DC\u30B9\u30CB\u30A2\u30FB\u30D8\u30EB\u30C4\u30A7\u30B4\u30D3\u30CA",
      "BW": "\u30DC\u30C4\u30EF\u30CA",
      "BV": "\u30D6\u30FC\u30D9\u5CF6",
      "BR": "\u30D6\u30E9\u30B8\u30EB",
      "BQ": "\u30DC\u30CD\u30FC\u30EB\u3001\u30B7\u30F3\u30C8\u30FB\u30E6\u30FC\u30B9\u30BF\u30C6\u30A3\u30A6\u30B9\u304A\u3088\u3073\u30B5\u30D0",
      "IO": "\u30A4\u30AE\u30EA\u30B9\u9818\u30A4\u30F3\u30C9\u6D0B\u5730\u57DF",
      "VG": "\u30F4\u30A1\u30FC\u30B8\u30F3\u8AF8\u5CF6\uFF08\u30A4\u30AE\u30EA\u30B9\u9818\uFF09",
      "BN": "\u30D6\u30EB\u30CD\u30A4\u30FB\u30C0\u30EB\u30B5\u30E9\u30FC\u30E0",
      "BG": "\u30D6\u30EB\u30AC\u30EA\u30A2",
      "BF": "\u30D6\u30EB\u30AD\u30CA\u30D5\u30A1\u30BD",
      "BI": "\u30D6\u30EB\u30F3\u30B8",
      "KH": "\u30AB\u30F3\u30DC\u30B8\u30A2",
      "CM": "\u30AB\u30E1\u30EB\u30FC\u30F3",
      "CA": "\u30AB\u30CA\u30C0",
      "IC": "\u30AB\u30CA\u30EA\u30A2\u8AF8\u5CF6",
      "CT": "\u30AB\u30F3\u30C8\u30F3\u3068\u30A8\u30F3\u30C0\u30D9\u30EA\u30FC\u8AF8\u5CF6",
      "CV": "\u30AB\u30FC\u30DC\u30D9\u30EB\u30C7",
      "KY": "\u30B1\u30A4\u30DE\u30F3\u8AF8\u5CF6",
      "CF": "\u4E2D\u592E\u30A2\u30D5\u30EA\u30AB\u5171\u548C\u56FD",
      "EA": "\u30BB\u30A6\u30BF\u3068\u30E1\u30EA\u30EA\u30E3",
      "TD": "\u30C1\u30E3\u30C9",
      "CL": "\u30C1\u30EA",
      "CN": "\u4E2D\u56FD",
      "CX": "\u30AF\u30EA\u30B9\u30DE\u30B9\u5CF6",
      "CP": "\u30AF\u30EA\u30C3\u30D1\u30FC\u30C8\u30F3\u5CF6",
      "CC": "\u30B3\u30B3\u30B9\uFF08\u30AD\u30FC\u30EA\u30F3\u30B0\uFF09\u8AF8\u5CF6",
      "CO": "\u30B3\u30ED\u30F3\u30D3\u30A2",
      "KM": "\u30B3\u30E2\u30ED",
      "CD": "\u30B3\u30F3\u30B4\u6C11\u4E3B\u5171\u548C\u56FD",
      "CK": "\u30AF\u30C3\u30AF\u8AF8\u5CF6",
      "CR": "\u30B3\u30B9\u30BF\u30EA\u30AB",
      "CI": "\u30B3\u30FC\u30C8\u30B8\u30DC\u30A2\u30FC\u30EB",
      "HR": "\u30AF\u30ED\u30A2\u30C1\u30A2",
      "CU": "\u30AD\u30E5\u30FC\u30D0",
      "CW": "\u30AD\u30E5\u30E9\u30BD\u30FC\u5CF6",
      "CY": "\u30AD\u30D7\u30ED\u30B9",
      "CZ": "\u30C1\u30A7\u30AD\u30A2",
      "DK": "\u30C7\u30F3\u30DE\u30FC\u30AF",
      "DG": "\u30C7\u30A3\u30A8\u30B4\u30FB\u30AC\u30EB\u30B7\u30A2",
      "DJ": "\u30B8\u30D6\u30C1",
      "DM": "\u30C9\u30DF\u30CB\u30AB\u56FD",
      "DO": "\u30C9\u30DF\u30CB\u30AB\u5171\u548C\u56FD",
      "NQ": "\u30C9\u30ED\u30F3\u30A4\u30F3\u30B0\u30E2\u30FC\u30C9\u30E9\u30F3\u30C9",
      "EC": "\u30A8\u30AF\u30A2\u30C9\u30EB",
      "EG": "\u30A8\u30B8\u30D7\u30C8",
      "SV": "\u30A8\u30EB\u30B5\u30EB\u30D0\u30C9\u30EB",
      "GQ": "\u8D64\u9053\u30AE\u30CB\u30A2",
      "ER": "\u30A8\u30EA\u30C8\u30EA\u30A2",
      "EE": "\u30A8\u30B9\u30C8\u30CB\u30A2",
      "ET": "\u30A8\u30C1\u30AA\u30D4\u30A2",
      "EU": "\u6B27\u5DDE\u9023\u5408",
      "FK": "\u30D5\u30A9\u30FC\u30AF\u30E9\u30F3\u30C9\u8AF8\u5CF6\uFF08\u30DE\u30EB\u30D3\u30CA\u30B9\u8AF8\u5CF6\uFF09",
      "FO": "\u30D5\u30A7\u30ED\u30FC\u8AF8\u5CF6",
      "FJ": "\u30D5\u30A3\u30B8\u30FC",
      "FI": "\u30D5\u30A3\u30F3\u30E9\u30F3\u30C9",
      "FR": "\u30D5\u30E9\u30F3\u30B9",
      "GF": "\u30D5\u30E9\u30F3\u30B9\u9818\u30AE\u30A2\u30CA",
      "PF": "\u30D5\u30E9\u30F3\u30B9\u9818\u30DD\u30EA\u30CD\u30B7\u30A2",
      "TF": "\u30D5\u30E9\u30F3\u30B9\u9818\u6975\u5357\u8AF8\u5CF6",
      "FQ": "\u30D5\u30E9\u30F3\u30B9\u9818\u5357\u65B9\u30FB\u5357\u6975\u5730\u57DF",
      "GA": "\u30AC\u30DC\u30F3",
      "GM": "\u30AC\u30F3\u30D3\u30A2",
      "GE": "\u30B8\u30E7\u30FC\u30B8\u30A2",
      "DE": "\u30C9\u30A4\u30C4",
      "GH": "\u30AC\u30FC\u30CA",
      "GI": "\u30B8\u30D6\u30E9\u30EB\u30BF\u30EB",
      "GR": "\u30AE\u30EA\u30B7\u30E3",
      "GL": "\u30B0\u30EA\u30FC\u30F3\u30E9\u30F3\u30C9",
      "GD": "\u30B0\u30EC\u30CA\u30C0",
      "GP": "\u30B0\u30A2\u30C9\u30EB\u30FC\u30D7",
      "GU": "\u30B0\u30A2\u30E0",
      "GT": "\u30B0\u30A2\u30C6\u30DE\u30E9",
      "GG": "\u30AC\u30FC\u30F3\u30B8\u30FC\u5CF6",
      "GN": "\u30AE\u30CB\u30A2",
      "GW": "\u30AE\u30CB\u30A2\u30D3\u30B5\u30A6",
      "GY": "\u30AC\u30A4\u30A2\u30CA",
      "HT": "\u30CF\u30A4\u30C1",
      "HM": "\u30CF\u30FC\u30C9\u5CF6\u3068\u30DE\u30AF\u30C9\u30CA\u30EB\u30C9\u8AF8\u5CF6",
      "HN": "\u30DB\u30F3\u30B8\u30E5\u30E9\u30B9",
      "HK": "\u9999\u6E2F\u7279\u5225\u884C\u653F\u533A",
      "HU": "\u30CF\u30F3\u30AC\u30EA\u30FC",
      "IS": "\u30A2\u30A4\u30B9\u30E9\u30F3\u30C9",
      "IN": "\u30A4\u30F3\u30C9",
      "ID": "\u30A4\u30F3\u30C9\u30CD\u30B7\u30A2",
      "IR": "\u30A4\u30E9\u30F3\u30FB\u30A4\u30B9\u30E9\u30E0\u5171\u548C\u56FD",
      "IE": "\u30A2\u30A4\u30EB\u30E9\u30F3\u30C9",
      "IM": "\u30DE\u30F3\u5CF6",
      "IL": "\u30A4\u30B9\u30E9\u30A8\u30EB",
      "IQ": "\u30A4\u30E9\u30AF",
      "IT": "\u30A4\u30BF\u30EA\u30A2",
      "JM": "\u30B8\u30E3\u30DE\u30A4\u30AB",
      "JP": "\u65E5\u672C",
      "JE": "\u30B8\u30E3\u30FC\u30B8\u30FC",
      "JT": "\u30B8\u30E7\u30F3\u30B9\u30C8\u30F3\u5CF6",
      "JO": "\u30E8\u30EB\u30C0\u30F3",
      "KZ": "\u30AB\u30B6\u30D5\u30B9\u30BF\u30F3",
      "KE": "\u30B1\u30CB\u30A2",
      "KI": "\u30AD\u30EA\u30D0\u30B9",
      "KP": "\u671D\u9BAE\u6C11\u4E3B\u4E3B\u7FA9\u4EBA\u6C11\u5171\u548C\u56FD",
      "KR": "\u5927\u97D3\u6C11\u56FD",
      "XK": "\u30B3\u30BD\u30DC",
      "KW": "\u30AF\u30A6\u30A7\u30FC\u30C8",
      "KG": "\u30AD\u30EB\u30AE\u30B9",
      "LA": "\u30E9\u30AA\u30B9\u4EBA\u6C11\u6C11\u4E3B\u5171\u548C\u56FD",
      "LV": "\u30E9\u30C8\u30D3\u30A2",
      "LB": "\u30EC\u30D0\u30CE\u30F3",
      "LS": "\u30EC\u30BD\u30C8",
      "LR": "\u30EA\u30D9\u30EA\u30A2",
      "LY": "\u30EA\u30D3\u30A2",
      "LI": "\u30EA\u30D2\u30C6\u30F3\u30B7\u30E5\u30BF\u30A4\u30F3",
      "LT": "\u30EA\u30C8\u30A2\u30CB\u30A2",
      "LU": "\u30EB\u30AF\u30BB\u30F3\u30D6\u30EB\u30AF",
      "MO": "\u30DE\u30AB\u30AA\u7279\u5225\u884C\u653F\u533A",
      "MK": "\u5317\u30DE\u30B1\u30C9\u30CB\u30A2",
      "MG": "\u30DE\u30C0\u30AC\u30B9\u30AB\u30EB",
      "MW": "\u30DE\u30E9\u30A6\u30A4",
      "MY": "\u30DE\u30EC\u30FC\u30B7\u30A2",
      "MV": "\u30E2\u30EB\u30C7\u30A3\u30D6",
      "ML": "\u30DE\u30EA",
      "MT": "\u30DE\u30EB\u30BF",
      "MH": "\u30DE\u30FC\u30B7\u30E3\u30EB\u8AF8\u5CF6",
      "MQ": "\u30DE\u30EB\u30C6\u30A3\u30CB\u30FC\u30AF\u5CF6",
      "MR": "\u30E2\u30FC\u30EA\u30BF\u30CB\u30A2",
      "MU": "\u30E2\u30FC\u30EA\u30B7\u30E3\u30B9",
      "YT": "\u30DE\u30E8\u30C3\u30C8\u5CF6",
      "FX": "\u30D5\u30E9\u30F3\u30B9\u30FB\u30E1\u30C8\u30ED\u30DD\u30EA\u30C6\u30FC\u30CC",
      "MX": "\u30E1\u30AD\u30B7\u30B3",
      "FM": "\u30DF\u30AF\u30ED\u30CD\u30B7\u30A2\u9023\u90A6",
      "MI": "\u30DF\u30C3\u30C9\u30A6\u30A7\u30FC\u8AF8\u5CF6",
      "MD": "\u30E2\u30EB\u30C9\u30D0\u5171\u548C\u56FD",
      "MC": "\u30E2\u30CA\u30B3",
      "MN": "\u30E2\u30F3\u30B4\u30EB\u56FD",
      "ME": "\u30E2\u30F3\u30C6\u30CD\u30B0\u30ED",
      "MS": "\u30E2\u30F3\u30C8\u30BB\u30E9\u30C8",
      "MA": "\u30E2\u30ED\u30C3\u30B3",
      "MZ": "\u30E2\u30B6\u30F3\u30D3\u30FC\u30AF",
      "MM": "\u30DF\u30E3\u30F3\u30DE\u30FC",
      "NA": "\u30CA\u30DF\u30D3\u30A2",
      "NR": "\u30CA\u30A6\u30EB",
      "NP": "\u30CD\u30D1\u30FC\u30EB",
      "NL": "\u30AA\u30E9\u30F3\u30C0",
      "AN": "\u30AA\u30E9\u30F3\u30C0\u9818\u30A2\u30F3\u30C6\u30A3\u30EB\u8AF8\u5CF6",
      "NT": "\u4E2D\u7ACB\u5730\u5E2F",
      "NC": "\u30CB\u30E5\u30FC\u30AB\u30EC\u30C9\u30CB\u30A2",
      "NZ": "\u30CB\u30E5\u30FC\u30B8\u30FC\u30E9\u30F3\u30C9",
      "NI": "\u30CB\u30AB\u30E9\u30B0\u30A2",
      "NE": "\u30CB\u30B8\u30A7\u30FC\u30EB",
      "NG": "\u30CA\u30A4\u30B8\u30A7\u30EA\u30A2",
      "NU": "\u30CB\u30A6\u30A8\u5CF6",
      "NF": "\u30CE\u30FC\u30D5\u30A9\u30FC\u30AF\u5CF6",
      "VD": "\u5317\u30D9\u30C8\u30CA\u30E0",
      "MP": "\u5317\u30DE\u30EA\u30A2\u30CA\u8AF8\u5CF6",
      "NO": "\u30CE\u30EB\u30A6\u30A7\u30FC",
      "OM": "\u30AA\u30DE\u30FC\u30F3",
      "QO": "\u305D\u306E\u4ED6\u306E\u30AA\u30BB\u30A2\u30CB\u30A2",
      "PC": "\u592A\u5E73\u6D0B\u8AF8\u5CF6\u4FE1\u8A17\u7D71\u6CBB\u9818",
      "PK": "\u30D1\u30AD\u30B9\u30BF\u30F3",
      "PW": "\u30D1\u30E9\u30AA",
      "PS": "\u30D1\u30EC\u30B9\u30C1\u30CA\u56FD",
      "PA": "\u30D1\u30CA\u30DE",
      "PZ": "\u30D1\u30CA\u30DE\u904B\u6CB3\u5730\u5E2F",
      "PY": "\u30D1\u30E9\u30B0\u30A2\u30A4",
      "YD": "\u30A4\u30A8\u30E1\u30F3\u6C11\u4E3B\u4EBA\u6C11\u5171\u548C\u56FD",
      "PE": "\u30DA\u30EB\u30FC",
      "PH": "\u30D5\u30A3\u30EA\u30D4\u30F3",
      "PN": "\u30D4\u30C8\u30B1\u30A2\u30F3\u8AF8\u5CF6",
      "PL": "\u30DD\u30FC\u30E9\u30F3\u30C9",
      "PT": "\u30DD\u30EB\u30C8\u30AC\u30EB",
      "PR": "\u30D7\u30A8\u30EB\u30C8\u30EA\u30B3",
      "QA": "\u30AB\u30BF\u30FC\u30EB",
      "RE": "\u30EC\u30E6\u30CB\u30AA\u30F3",
      "RO": "\u30EB\u30FC\u30DE\u30CB\u30A2",
      "RU": "\u30ED\u30B7\u30A2\u9023\u90A6",
      "RW": "\u30EB\u30EF\u30F3\u30C0",
      "BL": "\u30B5\u30F3\u30FB\u30D0\u30EB\u30C6\u30EB\u30DF\u30FC\u5CF6",
      "SH": "\u30BB\u30F3\u30C8\u30D8\u30EC\u30CA\u30FB\u30A2\u30BB\u30F3\u30B7\u30E7\u30F3\u304A\u3088\u3073\u30C8\u30EA\u30B9\u30BF\u30F3\u30C0\u30AF\u30FC\u30CB\u30E3",
      "KN": "\u30BB\u30F3\u30C8\u30AF\u30EA\u30B9\u30C8\u30D5\u30A1\u30FC\u30FB\u30CD\u30A4\u30D3\u30B9",
      "LC": "\u30BB\u30F3\u30C8\u30EB\u30B7\u30A2",
      "MF": "\u30BB\u30F3\u30C8\u30FB\u30DE\u30FC\u30C1\u30F3\u5CF6\uFF08\u30D5\u30E9\u30F3\u30B9\u9818\uFF09",
      "PM": "\u30B5\u30F3\u30D4\u30A8\u30FC\u30EB\u5CF6\u304A\u3088\u3073\u30DF\u30AF\u30ED\u30F3\u5CF6",
      "VC": "\u30BB\u30F3\u30C8\u30D3\u30F3\u30BB\u30F3\u30C8\u304A\u3088\u3073\u30B0\u30EC\u30CA\u30C7\u30A3\u30FC\u30F3\u8AF8\u5CF6",
      "WS": "\u30B5\u30E2\u30A2",
      "SM": "\u30B5\u30F3\u30DE\u30EA\u30CE",
      "ST": "\u30B5\u30F3\u30C8\u30E1\u30FB\u30D7\u30EA\u30F3\u30B7\u30DA",
      "SA": "\u30B5\u30A6\u30B8\u30A2\u30E9\u30D3\u30A2",
      "SN": "\u30BB\u30CD\u30AC\u30EB",
      "RS": "\u30BB\u30EB\u30D3\u30A2",
      "CS": "\u30BB\u30EB\u30D3\u30A2\u30FB\u30E2\u30F3\u30C6\u30CD\u30B0\u30ED",
      "SC": "\u30BB\u30A4\u30B7\u30A7\u30EB",
      "SL": "\u30B7\u30A8\u30E9\u30EC\u30AA\u30CD",
      "SG": "\u30B7\u30F3\u30AC\u30DD\u30FC\u30EB",
      "SX": "\u30B7\u30F3\u30C8\u30FB\u30DE\u30FC\u30EB\u30C6\u30F3\uFF08\u30AA\u30E9\u30F3\u30C0\u9818\uFF09",
      "SK": "\u30B9\u30ED\u30D0\u30AD\u30A2",
      "SI": "\u30B9\u30ED\u30D9\u30CB\u30A2",
      "SB": "\u30BD\u30ED\u30E2\u30F3\u8AF8\u5CF6",
      "SO": "\u30BD\u30DE\u30EA\u30A2",
      "ZA": "\u5357\u30A2\u30D5\u30EA\u30AB",
      "GS": "\u5357\u30B8\u30E7\u30FC\u30B8\u30A2\u5CF6\u304A\u3088\u3073\u5357\u30B5\u30F3\u30C9\u30A4\u30C3\u30C1\u8AF8\u5CF6",
      "ES": "\u30B9\u30DA\u30A4\u30F3",
      "LK": "\u30B9\u30EA\u30E9\u30F3\u30AB",
      "SR": "\u30B9\u30EA\u30CA\u30E0",
      "SJ": "\u30B9\u30D0\u30FC\u30EB\u30D0\u30EB\u8AF8\u5CF6\u304A\u3088\u3073\u30E4\u30F3\u30DE\u30A4\u30A8\u30F3\u5CF6",
      "SZ": "\u30A8\u30B9\u30EF\u30C6\u30A3\u30CB",
      "SE": "\u30B9\u30A6\u30A7\u30FC\u30C7\u30F3",
      "CH": "\u30B9\u30A4\u30B9",
      "SY": "\u30B7\u30EA\u30A2\u30FB\u30A2\u30E9\u30D6\u5171\u548C\u56FD",
      "TW": "\u4E2D\u56FD\u53F0\u6E7E",
      "TJ": "\u30BF\u30B8\u30AD\u30B9\u30BF\u30F3",
      "TZ": "\u30BF\u30F3\u30B6\u30CB\u30A2\u9023\u5408\u5171\u548C\u56FD",
      "TH": "\u30BF\u30A4",
      "TL": "\u6771\u30C6\u30A3\u30E2\u30FC\u30EB",
      "TG": "\u30C8\u30FC\u30B4",
      "TK": "\u30C8\u30B1\u30E9\u30A6\u8AF8\u5CF6",
      "TO": "\u30C8\u30F3\u30AC",
      "TT": "\u30C8\u30EA\u30CB\u30C0\u30FC\u30C9\u30FB\u30C8\u30D0\u30B4",
      "TA": "\u30C8\u30EA\u30B9\u30BF\u30F3\u30FB\u30C0\u30FB\u30AF\u30FC\u30CB\u30E3",
      "TN": "\u30C1\u30E5\u30CB\u30B8\u30A2",
      "TR": "\u30C8\u30EB\u30B3",
      "TM": "\u30C8\u30EB\u30AF\u30E1\u30CB\u30B9\u30BF\u30F3",
      "TC": "\u30BF\u30FC\u30AF\u30B9\u30FB\u30AB\u30A4\u30B3\u30B9\u8AF8\u5CF6",
      "TV": "\u30C4\u30D0\u30EB",
      "UM": "\u5408\u8846\u56FD\u9818\u6709\u5C0F\u96E2\u5CF6",
      "PU": "\u7C73\u9818\u592A\u5E73\u6D0B\u8AF8\u5CF6",
      "VI": "\u30F4\u30A1\u30FC\u30B8\u30F3\u8AF8\u5CF6\uFF08\u30A2\u30E1\u30EA\u30AB\u9818\uFF09",
      "UG": "\u30A6\u30AC\u30F3\u30C0",
      "UA": "\u30A6\u30AF\u30E9\u30A4\u30CA",
      "AE": "\u30A2\u30E9\u30D6\u9996\u9577\u56FD\u9023\u90A6",
      "GB": "\u82F1\u56FD",
      "US": "\u30A2\u30E1\u30EA\u30AB\u5408\u8846\u56FD",
      "UY": "\u30A6\u30EB\u30B0\u30A2\u30A4",
      "UZ": "\u30A6\u30BA\u30D9\u30AD\u30B9\u30BF\u30F3",
      "VU": "\u30D0\u30CC\u30A2\u30C4",
      "VA": "\u6559\u7687\u5E81",
      "VE": "\u30D9\u30CD\u30BA\u30A8\u30E9\u30FB\u30DC\u30EA\u30D0\u30EB\u5171\u548C\u56FD",
      "VN": "\u30D9\u30C8\u30CA\u30E0",
      "WK": "\u30A6\u30A7\u30FC\u30AF\u5CF6",
      "WF": "\u30A6\u30A9\u30EA\u30B9\u30FB\u30D5\u30C4\u30CA",
      "EH": "\u897F\u30B5\u30CF\u30E9",
      "YE": "\u30A4\u30A8\u30E1\u30F3",
      "ZM": "\u30B6\u30F3\u30D3\u30A2",
      "SD": "\u30B9\u30FC\u30C0\u30F3",
      "SS": "\u5357\u30B9\u30FC\u30C0\u30F3",
      "ZW": "\u30B8\u30F3\u30D0\u30D6\u30A8",
      "fr-FR": "\u30D5\u30E9\u30F3\u30B9",
      "en-GB": "\u82F1\u56FD",
      "en-US": "\u7C73\u56FD",
      "zh-CN": "\u4E2D\u56FD",
      "es-ES": "\u30B9\u30DA\u30A4\u30F3",
      "language.display": "{0}\uFF08{1}\uFF09",
      "OM_mobile": "\u30AA\u30FC\u30DE\u30F3\u30E2\u30D0\u30A4\u30EB",
      "TW_mobile": "\u53F0\u6E7E\u30E2\u30D0\u30A4\u30EB",
      "de-DE": "\u30C9\u30A4\u30C4",
      "jp-JP": "\u65E5\u672C",
      "pt-PT": "\u30DD\u30EB\u30C8\u30AC\u30EB\u8A9E",
      "ru-RU": "\u30ED\u30B7\u30A2\u8A9E",
      "TW-TW": "\u53F0\u6E7E",
      "PG": "\u30D1\u30D7\u30A2\u30CB\u30E5\u30FC\u30AE\u30CB\u30A2",
      "CG": "\u30B3\u30F3\u30B4"
    }
  },
  "ko-KO": {
    "country": {
      "AF": "\uC544\uD504\uAC00\uB2C8\uC2A4\uD0C4",
      "AX": "\uC62C\uB780\uB4DC \uC81C\uB3C4",
      "AL": "\uC54C\uBC14\uB2C8\uC544",
      "DZ": "\uC54C\uC81C\uB9AC",
      "AS": "\uBBF8\uAD6D\uB839 \uC0AC\uBAA8\uC544",
      "AD": "\uC548\uB3C4\uB77C",
      "AO": "\uC559\uACE8\uB77C",
      "AI": "\uC575\uADC8\uB77C",
      "AQ": "\uB0A8\uADF9",
      "AG": "\uC564\uD2F0\uAC00 \uBC14\uBD80\uB2E4",
      "AR": "\uC544\uB974\uD5E8\uD2F0\uB098",
      "AM": "\uC544\uB974\uBA54\uB2C8\uC544",
      "AW": "\uC544\uB8E8\uBC14",
      "AC": "\uC5B4\uC13C\uC158 \uC12C",
      "AU": "\uD638\uC8FC",
      "AT": "\uC624\uC2A4\uD2B8\uB9AC\uC544",
      "AZ": "\uC544\uC81C\uB974\uBC14\uC774\uC794",
      "BS": "\uBC14\uD558\uB9C8",
      "BH": "\uBC14\uB808\uC778",
      "BD": "\uBC29\uAE00\uB77C\uB370\uC2DC",
      "BB": "\uBC14\uBCA0\uC774\uB3C4\uC2A4",
      "BY": "\uBCA8\uB77C\uB8E8\uC2A4",
      "BE": "\uBCA8\uAE30\uC5D0",
      "BZ": "\uBCA8\uB9AC\uC988",
      "BJ": "\uBCA0\uB0C9",
      "BM": "\uBC84\uBBA4\uB2E4",
      "BT": "\uBD80\uD0C4",
      "BO": "\uBCFC\uB9AC\uBE44\uC544 \uB2E4\uBBFC\uC871 \uACF5\uD654\uAD6D",
      "BA": "\uBCF4\uC2A4\uB2C8\uC544 \uD5E4\uB974\uCCB4\uACE0\uBE44\uB098",
      "BW": "\uBCF4\uCE20\uC640\uB098",
      "BV": "\uBD80\uBCA0\uC774 \uC12C",
      "BR": "\uBE0C\uB77C\uC9C8",
      "BQ": "\uBCF4\uB124\uB974, \uC2E0\uD2B8\uC678\uC2A4\uD0C0\uD2F0\uC6B0\uC2A4 \uBC0F \uC0AC\uBC14",
      "IO": "\uC601\uC778\uB3C4 \uC81C\uB3C4",
      "VG": "\uC601\uAD6D\uB839 \uBC84\uC9C4 \uC544\uC77C\uB79C\uB4DC",
      "BN": "\uBE0C\uB8E8\uB098\uC774 \uB2E4\uB8E8\uC0B4\uB78C",
      "BG": "\uBD88\uAC00\uB9AC\uC544",
      "BF": "\uBD80\uB974\uD0A4\uB098\uD30C\uC18C",
      "BI": "\uBD80\uB8EC\uB514",
      "KH": "\uCE84\uBCF4\uB514\uC544",
      "CM": "\uCE74\uBA54\uB8EC",
      "CA": "\uCE90\uB098\uB2E4",
      "IC": "\uCE74\uB098\uB9AC\uC544 \uC81C\uB3C4",
      "CT": "\uCE94\uD134 \uC5D4\uB354\uBC84\uB9AC \uC81C\uB3C4",
      "CV": "\uCE74\uBCF4\uBCA0\uB974\uB370",
      "KY": "\uCF00\uC774\uB9E8 \uC81C\uB3C4",
      "CF": "\uC911\uC559 \uC544\uD504\uB9AC\uCE74",
      "EA": "\uC138\uC6B0\uD0C0 \uBC0F \uBA5C\uB9AC\uC57C",
      "TD": "\uCC28\uB4DC",
      "CL": "\uCE60\uB808",
      "CN": "\uC911\uAD6D",
      "CX": "\uD06C\uB9AC\uC2A4\uB9C8\uC2A4 \uC12C",
      "CP": "\uD074\uB9BD\uD37C\uD2BC \uC12C",
      "CC": "\uCF54\uCF54\uC2A4 \uAD70\uB3C4",
      "CO": "\uCF5C\uB86C\uBE44\uC544",
      "KM": "\uCF54\uBAA8\uB85C",
      "CD": "\uCF69\uACE0 \uBBFC\uC8FC \uACF5\uD654\uAD6D",
      "CK": "\uCFE1 \uC81C\uB3C4",
      "CR": "\uCF54\uC2A4\uD0C0\uB9AC\uCE74",
      "CI": "\uCF54\uD2B8\uB514\uBD80\uC544\uB974",
      "HR": "\uD06C\uB85C\uC544\uD2F0\uC544",
      "CU": "\uCFE0\uBC14",
      "CW": "\uCFE0\uB77C\uC0AC\uC6B0\uC12C",
      "CY": "\uC0AC\uC774\uD504\uB7EC\uC2A4",
      "CZ": "\uCCB4\uCF54",
      "DK": "\uB374\uB9C8\uD06C",
      "DG": "\uB514\uC5D0\uACE0 \uAC00\uB974\uC2DC\uC544 \uC12C",
      "DJ": "\uC9C0\uBD80\uD2F0",
      "DM": "\uB3C4\uBBF8\uB2C8\uCE74",
      "DO": "\uB3C4\uBBF8\uB2C8\uCE74 \uACF5\uD654\uAD6D",
      "NQ": "\uD038\uBAA8\uB4DC\uB79C\uB4DC",
      "EC": "\uC5D0\uCF70\uB3C4\uB974",
      "EG": "\uC774\uC9D1\uD2B8",
      "SV": "\uC5D8\uC0B4\uBC14\uB3C4\uB974",
      "GQ": "\uC801\uB3C4 \uAE30\uB2C8",
      "ER": "\uC5D0\uB9AC\uD2B8\uB9AC\uC544",
      "EE": "\uC5D0\uC2A4\uD1A0\uB2C8\uC544",
      "ET": "\uC5D0\uD2F0\uC624\uD53C\uC544",
      "EU": "\uC720\uB7FD \uC5F0\uD569",
      "FK": "\uD3EC\uD074\uB79C\uB4DC \uC81C\uB3C4(\uB9D0\uBE44\uB098\uC2A4)",
      "FO": "\uD398\uB85C \uC81C\uB3C4",
      "FJ": "\uD53C\uC9C0",
      "FI": "\uD540\uB780\uB4DC",
      "FR": "\uD504\uB791\uC2A4",
      "GF": "\uD504\uB791\uC2A4\uB839 \uAE30\uC544\uB098",
      "PF": "\uD504\uB791\uC2A4\uB839 \uD3F4\uB9AC\uB124\uC2DC\uC544",
      "TF": "\uD504\uB791\uC2A4 \uB0A8\uCABD \uC601\uC5ED",
      "FQ": "\uD504\uB791\uC2A4\uB839 \uB0A8\uCABD \uBC0F \uB0A8\uADF9\uC9C0\uC5ED",
      "GA": "\uAC00\uBD09",
      "GM": "\uAC10\uBE44\uC544",
      "GE": "\uC870\uC9C0\uC544",
      "DE": "\uB3C5\uC77C",
      "GH": "\uAC00\uB098",
      "GI": "\uC9C0\uBE0C\uB864\uD130",
      "GR": "\uADF8\uB9AC\uC2A4",
      "GL": "\uADF8\uB9B0\uB780\uB4DC",
      "GD": "\uADF8\uB808\uB098\uB2E4",
      "GP": "\uACFC\uB2EC\uB8E8\uD504",
      "GU": "\uAD0C",
      "GT": "\uACFC\uD14C\uB9D0\uB77C",
      "GG": "\uAC74\uC9C0\uC12C",
      "GN": "\uAE30\uB2C8",
      "GW": "\uAE30\uB2C8\uBE44\uC0AC\uC6B0",
      "GY": "\uAC00\uC774\uC544\uB098",
      "HT": "\uC544\uC774\uD2F0",
      "HM": "\uD5C8\uB4DC \uC12C \uBC0F \uB9E5\uB3C4\uB0A0\uB4DC \uAD70\uB3C4",
      "HN": "\uC628\uB450\uB77C\uC2A4",
      "HK": "\uD64D\uCF69 \uD2B9\uBCC4 \uD589\uC815\uAD6C",
      "HU": "\uD5DD\uAC00\uB9AC",
      "IS": "\uC544\uC774\uC2AC\uB780\uB4DC",
      "IN": "\uC778\uB3C4",
      "ID": "\uC778\uB3C4\uB124\uC2DC\uC544",
      "IR": "\uC774\uB780",
      "IE": "\uC544\uC77C\uB79C\uB4DC",
      "IM": "\uB9E8 \uC12C",
      "IL": "\uC774\uC2A4\uB77C\uC5D8",
      "IQ": "\uC774\uB77C\uD06C",
      "IT": "\uC774\uD0C8\uB9AC\uC544",
      "JM": "\uC790\uBA54\uC774\uCE74",
      "JP": "\uC77C\uBCF8",
      "JE": "\uC800\uC9C0\uC12C",
      "JT": "\uC874\uC2A8\uC12C",
      "JO": "\uC694\uB974\uB2E8",
      "KZ": "\uCE74\uC790\uD750\uC2A4\uD0C4",
      "KE": "\uCF00\uB0D0",
      "KI": "\uD0A4\uB9AC\uBC14\uC2DC",
      "KP": "\uBD81\uD55C",
      "KR": "\uB300\uD55C\uBBFC\uAD6D",
      "XK": "\uCF54\uC18C\uBCF4",
      "KW": "\uCFE0\uC6E8\uC774\uD2B8",
      "KG": "\uD0A4\uB974\uAE30\uC2A4\uC2A4\uD0C4",
      "LA": "\uB77C\uC624\uC2A4 \uC778\uBBFC \uBBFC\uC8FC \uACF5\uD654\uAD6D",
      "LV": "\uB77C\uD2B8\uBE44\uC544",
      "LB": "\uB808\uBC14\uB17C",
      "LS": "\uB808\uC18C\uD1A0",
      "LR": "\uB77C\uC774\uBCA0\uB9AC\uC544",
      "LY": "\uB9AC\uBE44\uC544",
      "LI": "\uB9AC\uD788\uD150\uC288\uD0C0\uC778",
      "LT": "\uB9AC\uD22C\uC544\uB2C8\uC544",
      "LU": "\uB8E9\uC148\uBD80\uB974\uD06C",
      "MO": "\uB9C8\uCE74\uC624 \uD2B9\uBCC4 \uD589\uC815\uAD6C",
      "MK": "\uBD81\uB9C8\uCF00\uB3C4\uB2C8\uC544",
      "MG": "\uB9C8\uB2E4\uAC00\uC2A4\uCE74\uB974",
      "MW": "\uB9D0\uB77C\uC704",
      "MY": "\uB9D0\uB808\uC774\uC2DC\uC544",
      "MV": "\uBAB0\uB514\uBE0C",
      "ML": "\uB9D0\uB9AC",
      "MT": "\uBAB0\uD0C0",
      "MH": "\uB9C8\uC0EC \uAD70\uB3C4",
      "MQ": "\uB9C8\uB974\uD2F0\uB2C8\uD06C",
      "MR": "\uBAA8\uB9AC\uD0C0\uB2C8",
      "MU": "\uBAA8\uB9AC\uC154\uC2A4",
      "YT": "\uB9C8\uC694\uD2F0",
      "FX": "\uD504\uB791\uC2A4 \uC218\uB3C4\uAD8C",
      "MX": "\uBA55\uC2DC\uCF54",
      "FM": "\uBBF8\uD06C\uB85C\uB124\uC2DC\uC544",
      "MI": "\uBBF8\uB4DC\uC6E8\uC774 \uC81C\uB3C4",
      "MD": "\uBAB0\uB3C4\uBC14",
      "MC": "\uBAA8\uB098\uCF54",
      "MN": "\uBABD\uACE8",
      "ME": "\uBAAC\uD14C\uB124\uADF8\uB85C",
      "MS": "\uBAAC\uC138\uB77C\uD2B8",
      "MA": "\uBAA8\uB85C\uCF54",
      "MZ": "\uBAA8\uC7A0\uBE44\uD06C",
      "MM": "\uBBF8\uC580\uB9C8",
      "NA": "\uB098\uBBF8\uBE44\uC544",
      "NR": "\uB098\uC6B0\uB8E8",
      "NP": "\uB124\uD314",
      "NL": "\uB124\uB35C\uB780\uB4DC",
      "AN": "\uB124\uB35C\uB780\uB4DC\uB839 \uC564\uD2F8\uB9AC\uC2A4",
      "NT": "\uC911\uB9BD\uC9C0\uB300",
      "NC": "\uB274\uCE7C\uB808\uB3C4\uB2C8\uC544",
      "NZ": "\uB274\uC9C8\uB79C\uB4DC",
      "NI": "\uB2C8\uCE74\uB77C\uAD6C\uC544",
      "NE": "\uB2C8\uC81C\uB974",
      "NG": "\uB098\uC774\uC9C0\uB9AC\uC544",
      "NU": "\uB2C8\uC6B0\uC5D0",
      "NF": "\uB178\uD37D",
      "VD": "\uBD81\uBCA0\uD2B8\uB0A8",
      "MP": "\uBD81\uB9C8\uB9AC\uC544\uB098 \uAD70\uB3C4",
      "NO": "\uB178\uB974\uC6E8\uC774",
      "OM": "\uC624\uB9CC",
      "OM_mobile": "Oman Mobile",
      "QO": "\uC624\uC138\uC544\uB2C8\uC544 \uC678\uACFD",
      "PC": "\uD0DC\uD3C9\uC591 \uC81C\uB3C4 \uC2E0\uD0C1\uD1B5\uCE58\uB839",
      "PK": "\uD30C\uD0A4\uC2A4\uD0C4",
      "PW": "\uD314\uB77C\uC6B0",
      "PS": "\uD314\uB808\uC2A4\uD0C0\uC778",
      "PA": "\uD30C\uB098\uB9C8",
      "PZ": "\uD30C\uB098\uB9C8 \uC6B4\uD558 \uC9C0\uB300",
      "PY": "\uD30C\uB77C\uACFC\uC774",
      "YD": "\uC608\uBA58 \uC778\uBBFC\uBBFC\uC8FC\uC8FC\uC758 \uACF5\uD654\uAD6D",
      "PE": "\uD398\uB8E8",
      "PH": "\uD544\uB9AC\uD540",
      "PN": "\uD54F\uCF00\uC5B8",
      "PL": "\uD3F4\uB780\uB4DC",
      "PT": "\uD3EC\uB974\uD22C\uAC08",
      "PR": "\uD478\uC5D0\uB974\uD1A0\uB9AC\uCF54",
      "QA": "\uCE74\uD0C0\uB974",
      "RE": "\uB9AC\uC720\uB2C8\uC5B8 \uC12C",
      "RO": "\uB8E8\uB9C8\uB2C8\uC544",
      "RU": "\uB7EC\uC2DC\uC544",
      "RW": "\uB974\uC644\uB2E4",
      "BL": "\uC0DD\uBC14\uB974\uD154\uB974\uBBF8\u00E9",
      "SH": "\uC138\uC778\uD2B8 \uD5EC\uB808\uB098, \uC5B4\uC13C\uC158 \uBC0F \uD2B8\uB9AC\uC2A4\uD0C4 \uB2E4 \uCFE0\uB098",
      "KN": "\uC138\uC778\uD2B8 \uD06C\uB9AC\uC2A4\uD1A0\uD37C \uB124\uBE44\uC2A4",
      "LC": "\uC138\uC778\uD2B8 \uB8E8\uC2DC\uC544",
      "MF": "\uC138\uC778\uD2B8 \uB9C8\uD2F4(\uD504\uB791\uC2A4\uB839)",
      "PM": "\uC138\uC778\uD2B8 \uD53C\uC5D0\uB974 \uBBF8\uCF08\uB860",
      "VC": "\uC138\uC778\uD2B8 \uBE48\uC13C\uD2B8 \uADF8\uB808\uB098\uB518",
      "WS": "\uC0AC\uBAA8\uC544",
      "SM": "\uC0B0\uB9C8\uB9AC\uB178",
      "ST": "\uC0C1\uD22C\uBA54 \uD504\uB9B0\uC2DC\uD398",
      "SA": "\uC0AC\uC6B0\uB514 \uC544\uB77C\uBE44\uC544",
      "SN": "\uC138\uB124\uAC08",
      "RS": "\uC138\uB974\uBE44\uC544",
      "CS": "\uC138\uB974\uBE44\uC544 \uBC0F \uBAAC\uD14C\uB124\uADF8\uB85C",
      "SC": "\uC138\uC774\uC258",
      "SL": "\uC2DC\uC5D0\uB77C\uB9AC\uC628",
      "SG": "\uC2F1\uAC00\uD3EC\uB974",
      "SX": "\uC2E0\uD2B8\uB9C8\uB974\uD150(\uB124\uB35C\uB780\uB4DC\uB839)",
      "SK": "\uC2AC\uB85C\uBC14\uD0A4\uC544",
      "SI": "\uC2AC\uB85C\uBCA0\uB2C8\uC544",
      "SB": "\uC194\uB85C\uBAAC \uC81C\uB3C4",
      "SO": "\uC18C\uB9D0\uB9AC\uC544",
      "ZA": "\uB0A8\uC544\uD504\uB9AC\uCE74",
      "GS": "\uC0AC\uC6B0\uC2A4 \uC870\uC9C0\uC544 \uBC0F \uC0AC\uC6B0\uC2A4 \uC0CC\uB4DC\uC704\uCE58 \uAD70",
      "ES": "\uC2A4\uD398\uC778",
      "LK": "\uC2A4\uB9AC\uB791\uCE74",
      "SR": "\uC218\uB9AC\uB0A8",
      "SJ": "\uC2A4\uBC1C\uBC14\uB974\uC81C\uB3C4-\uC580\uB9C8\uC6EC\uC12C",
      "SZ": "\uC5D0\uC2A4\uC640\uD2F0\uB2C8",
      "SE": "\uC2A4\uC6E8\uB374",
      "CH": "\uC2A4\uC704\uC2A4",
      "SY": "\uC2DC\uB9AC\uC544",
      "TW": "\uC911\uAD6D \uB300\uB9CC",
      "TW_mobile": "Taiwan Mobile",
      "TJ": "\uD0C0\uC9C0\uD0A4\uC2A4\uD0C4",
      "TZ": "\uD0C4\uC790\uB2C8\uC544",
      "TH": "\uD0DC\uAD6D",
      "TL": "\uB3D9\uD2F0\uBAA8\uB974",
      "TG": "\uD1A0\uACE0",
      "TK": "\uD1A0\uCF08\uB77C\uC6B0",
      "TO": "\uD1B5\uAC00",
      "TT": "\uD2B8\uB9AC\uB2C8\uB2E4\uB4DC \uD1A0\uBC14\uACE0",
      "TA": "\uD2B8\uB9AC\uC2A4\uD0C4 \uB2E4 \uCFE0\uB098",
      "TN": "\uD280\uB2C8\uC9C0",
      "TR": "\uD130\uD0A4",
      "TM": "\uD22C\uB974\uD06C\uBA54\uB2C8\uC2A4\uD0C4",
      "TC": "\uD130\uD06C\uC2A4 \uCE74\uC774\uCF54\uC2A4 \uAD70\uB3C4",
      "TV": "\uD22C\uBC1C\uB8E8",
      "UM": "\uBBF8\uAD6D \uC18C\uC218 \uC678\uBD80 \uC81C\uB3C4",
      "PU": "\uBBF8\uAD6D \uAE30\uD0C0 \uD0DC\uD3C9\uC591 \uC81C\uB3C4",
      "VI": "\uBBF8\uAD6D\uB839 \uBC84\uC9C4 \uC544\uC77C\uB79C\uB4DC",
      "UG": "\uC6B0\uAC04\uB2E4",
      "UA": "\uC6B0\uD06C\uB77C\uC774\uB098",
      "AE": "\uC544\uB78D\uC5D0\uBBF8\uB9AC\uD2B8",
      "GB": "\uC601\uAD6D",
      "US": "\uBBF8\uAD6D",
      "UY": "\uC6B0\uB8E8\uACFC\uC774",
      "UZ": "\uC6B0\uC988\uBCA0\uD0A4\uC2A4\uD0C4",
      "VU": "\uBC14\uB204\uC544\uD22C",
      "VA": "\uAD50\uD669\uCCAD",
      "VE": "\uBCA0\uB124\uC218\uC5D8\uB77C",
      "VN": "\uBCA0\uD2B8\uB0A8",
      "WK": "\uC6E8\uC774\uD06C \uC12C",
      "WF": "\uC6D4\uB9AC\uC2A4 \uD478\uD22C\uB098",
      "EH": "\uC11C\uC0AC\uD558\uB77C",
      "YE": "\uC608\uBA58",
      "ZM": "\uC7A0\uBE44\uC544",
      "SD": "\uC218\uB2E8",
      "SS": "\uB0A8\uC218\uB2E8",
      "ZW": "\uC9D0\uBC14\uBE0C\uC6E8",
      "language.display": "{0}({1})",
      "en-US": "\uBBF8\uAD6D",
      "en-GB": "\uC601\uAD6D",
      "zh-CN": "\uC911\uAD6D",
      "es-ES": "\uC2A4\uD398\uC778",
      "fr-FR": "\uD504\uB791\uC2A4",
      "jp-JP": "\uC77C\uBCF8",
      "de-DE": "\uB3C5\uC77C",
      "pt-PT": "\uD3EC\uB974\uD22C\uAC08\uC5B4",
      "ru-RU": "\uB7EC\uC2DC\uC544\uC5B4",
      "TW-TW": "\uB300\uB9CC",
      "PG": "\uD30C\uD478\uC544\uB274\uAE30\uB2C8",
      "CG": "\uCF69\uACE0"
    }
  },
  "pt-PT": {
    "country": {
      "AF": "Afeganist\u00E3o",
      "AX": "Ilhas Aland",
      "AL": "Alb\u00E2nia",
      "DZ": "Arg\u00E9lia",
      "AS": "Samoa Americana",
      "AD": "Andorra",
      "AO": "Angola",
      "AI": "Anguilla",
      "AQ": "Ant\u00E1rtica",
      "AG": "Ant\u00EDgua e Barbuda",
      "AR": "Argentina",
      "AM": "Arm\u00EAnia",
      "AW": "Aruba",
      "AC": "Ilha de Ascens\u00E3o",
      "AU": "Austr\u00E1lia",
      "AT": "\u00C1ustria",
      "AZ": "Azerbaij\u00E3o",
      "BS": "Bahamas",
      "BH": "Bahrein",
      "BD": "Bangladesh",
      "BB": "Barbados",
      "BY": "Belarus",
      "BE": "B\u00E9lgica",
      "BZ": "Belize",
      "BJ": "Benin",
      "BM": "Bermuda",
      "BT": "But\u00E3o",
      "BO": "Bol\u00EDvia (Estado Plurinacional da)",
      "BA": "B\u00F3snia e Herzegovina",
      "BW": "Botsuana",
      "BV": "Ilha Bouvet",
      "BR": "Brasil",
      "BQ": "Bonaire, Santo Eust\u00E1quio e Saba",
      "IO": "Territ\u00F3rio Brit\u00E2nico do Oceano \u00CDndico",
      "VG": "Ilhas Virgens (Brit\u00E2nicas)",
      "BN": "Brunei Darussalam",
      "BG": "Bulg\u00E1ria",
      "BF": "Burkina Faso",
      "BI": "Burundi",
      "KH": "Camboja",
      "CM": "Camar\u00F5es",
      "CA": "Canad\u00E1",
      "IC": "Ilhas Can\u00E1rias",
      "CT": "Ilhas Canton e Enderbury",
      "CV": "Cabo Verde",
      "KY": "Ilhas Cayman",
      "CF": "Rep\u00FAblica Centro-africana",
      "EA": "Ceuta e Melilla",
      "TD": "Chade",
      "CL": "Chile",
      "CN": "China",
      "CX": "Ilha Christmas",
      "CP": "Ilha Clipperton",
      "CC": "Ilhas Cocos (Keeling)",
      "CO": "Col\u00F4mbia",
      "KM": "Comores",
      "CD": "Congo, Rep\u00FAblica Democr\u00E1tica do",
      "CK": "Ilhas Cook",
      "CR": "Costa Rica",
      "CI": "Costa do Marfim",
      "HR": "Cro\u00E1cia",
      "CU": "Cuba",
      "CW": "Cura\u00E7ao",
      "CY": "Chipre",
      "CZ": "Rep\u00FAblica Tcheca",
      "DK": "Dinamarca",
      "DG": "Diego Garcia",
      "DJ": "Djibouti",
      "DM": "Dominica",
      "DO": "Rep\u00FAblica Dominicana",
      "NQ": "Terra da Rainha Maud",
      "EC": "Equador",
      "EG": "Egito",
      "SV": "El Salvador",
      "GQ": "Guin\u00E9 Equatorial",
      "ER": "Eritreia",
      "EE": "Est\u00F4nia",
      "ET": "Eti\u00F3pia",
      "EU": "Uni\u00E3o Europeia",
      "FK": "Ilhas Falkland (Malvinas)",
      "FO": "Ilhas Faro\u00E9",
      "FJ": "Fiji",
      "FI": "Finl\u00E2ndia",
      "FR": "Fran\u00E7a",
      "GF": "Guiana Francesa",
      "PF": "Polin\u00E9sia Francesa",
      "TF": "Territ\u00F3rios Franceses do Sul",
      "FQ": "Terras Austrais e Ant\u00E1rticas Francesas",
      "GA": "Gab\u00E3o",
      "GM": "G\u00E2mbia",
      "GE": "Ge\u00F3rgia",
      "DE": "Alemanha",
      "GH": "Gana",
      "GI": "Gibraltar",
      "GR": "Gr\u00E9cia",
      "GL": "Groenl\u00E2ndia",
      "GD": "Granada",
      "GP": "Guadalupe",
      "GU": "Guam",
      "GT": "Guatemala",
      "GG": "Guernsey",
      "GN": "Guin\u00E9",
      "GW": "Guin\u00E9-Bissau",
      "GY": "Guiana",
      "HT": "Haiti",
      "HM": "Ilha Heard e Ilhas McDonald",
      "HN": "Honduras",
      "HK": "RAE de Hong Kong",
      "HU": "Hungria",
      "IS": "Isl\u00E2ndia",
      "IN": "\u00CDndia",
      "ID": "Indon\u00E9sia",
      "IR": "Ir\u00E3 (Rep\u00FAblica Isl\u00E2mica do)",
      "IE": "Irlanda",
      "IM": "Ilha de Man",
      "IL": "Israel",
      "IQ": "Iraque",
      "IT": "It\u00E1lia",
      "JM": "Jamaica",
      "JP": "Jap\u00E3o",
      "JE": "Jersey",
      "JT": "Atol Johnston",
      "JO": "Jord\u00E2nia",
      "KZ": "Cazaquist\u00E3o",
      "KE": "Qu\u00EAnia",
      "KI": "Kiribati",
      "KP": "Coreia (Rep\u00FAblica Popular Democr\u00E1tica da)",
      "KR": "Coreia, Rep\u00FAblica da",
      "XK": "Kosovo",
      "KW": "Kuwait",
      "KG": "Quirguist\u00E3o",
      "LA": "Rep\u00FAblica Democr\u00E1tica Popular do Laos",
      "LV": "Let\u00F4nia",
      "LB": "L\u00EDbano",
      "LS": "Lesoto",
      "LR": "Lib\u00E9ria",
      "LY": "L\u00EDbia",
      "LI": "Liechtenstein",
      "LT": "Litu\u00E2nia",
      "LU": "Luxemburgo",
      "MO": "RAE de Macau",
      "MK": "Maced\u00F4nia do Norte",
      "MG": "Madagascar",
      "MW": "Malaui",
      "MY": "Mal\u00E1sia",
      "MV": "Maldivas",
      "ML": "Mali",
      "MT": "Malta",
      "MH": "Ilhas Marshall",
      "MQ": "Martinica",
      "MR": "Maurit\u00E2nia",
      "MU": "Ilhas Maur\u00EDcio",
      "YT": "Mayotte",
      "FX": "Fran\u00E7a Metropolitana",
      "MX": "M\u00E9xico",
      "FM": "Micron\u00E9sia (Estados Federados da)",
      "MI": "Ilhas Midway",
      "MD": "Mold\u00E1via, Rep\u00FAblica da",
      "MC": "M\u00F4naco",
      "MN": "Mong\u00F3lia",
      "ME": "Montenegro",
      "MS": "Montserrat",
      "MA": "Marrocos",
      "MZ": "Mo\u00E7ambique",
      "MM": "Myanmar",
      "NA": "Nam\u00EDbia",
      "NR": "Nauru",
      "NP": "Nepal",
      "NL": "Pa\u00EDses Baixos",
      "AN": "Antilhas Holandesas",
      "NT": "Zona Neutra",
      "NC": "Nova Caled\u00F4nia",
      "NZ": "Nova Zel\u00E2ndia",
      "NI": "Nicar\u00E1gua",
      "NE": "N\u00EDger",
      "NG": "Nig\u00E9ria",
      "NU": "Niue",
      "NF": "Ilha Norfolk",
      "VD": "Vietn\u00E3 do Norte",
      "MP": "Ilhas Marianas do Norte",
      "NO": "Noruega",
      "OM": "Om\u00E3",
      "OM_mobile": "Om\u00E3 Mobile",
      "QO": "Oceania Distante",
      "PC": "Protetorado das Ilhas do Pac\u00EDfico das Na\u00E7\u00F5es Unidas",
      "PK": "Paquist\u00E3o",
      "PW": "Palau",
      "PS": "Palestina, Estado da",
      "PA": "Panam\u00E1",
      "PZ": "Zona do Canal do Panam\u00E1",
      "PY": "Paraguai",
      "YD": "Rep\u00FAblica Democr\u00E1tica Popular do I\u00EAmen",
      "PE": "Peru",
      "PH": "Filipinas",
      "PN": "Ilhas Pitcairn",
      "PL": "Pol\u00F4nia",
      "PT": "Portugal",
      "PR": "Porto Rico",
      "QA": "Catar",
      "RE": "Reuni\u00E3o",
      "RO": "Rom\u00EAnia",
      "RU": "Federa\u00E7\u00E3o Russa",
      "RW": "Ruanda",
      "BL": "S\u00E3o Bartolomeu",
      "SH": "Santa Helena, Ascens\u00E3o e Trist\u00E3o da Cunha",
      "KN": "S\u00E3o Crist\u00F3v\u00E3o e Nevis",
      "LC": "Santa L\u00FAcia",
      "MF": "Ilha de S\u00E3o Martinho (parte francesa)",
      "PM": "Saint-Pierre e Miquelon",
      "VC": "S\u00E3o Vicente e Granadinas",
      "WS": "Samoa",
      "SM": "San Marino",
      "ST": "S\u00E3o Tom\u00E9 e Pr\u00EDncipe",
      "SA": "Ar\u00E1bia Saudita",
      "SN": "Senegal",
      "RS": "S\u00E9rvia",
      "CS": "S\u00E9rvia e Montenegro",
      "SC": "Seychelles",
      "SL": "Serra Leoa",
      "SG": "Singapura",
      "SX": "Ilha de S\u00E3o Martinho (parte holandesa)",
      "SK": "Eslov\u00E1quia",
      "SI": "Eslov\u00EAnia",
      "SB": "Ilhas Salom\u00E3o",
      "SO": "Som\u00E1lia",
      "ZA": "\u00C1frica do Sul",
      "GS": "Ilhas Ge\u00F3rgia do Sul e Sandwich do Sul",
      "ES": "Espanha",
      "LK": "Sri Lanka",
      "SR": "Suriname",
      "SJ": "Svalbard e Jan Mayen",
      "SZ": "Suazil\u00E2ndia",
      "SE": "Su\u00E9cia",
      "CH": "Su\u00ED\u00E7a",
      "SY": "Rep\u00FAblica \u00C1rabe da S\u00EDria",
      "TW": "Taiwan, China",
      "TW_mobile": "Taiwan Mobile",
      "TJ": "Tajiquist\u00E3o",
      "TZ": "Tanz\u00E2nia, Rep\u00FAblica Unida da",
      "TH": "Tail\u00E2ndia",
      "TL": "Timor-Leste",
      "TG": "Togo",
      "TK": "Tokelau",
      "TO": "Tonga",
      "TT": "Trinidade e Tobago",
      "TA": "Trist\u00E3o da Cunha",
      "TN": "Tun\u00EDsia",
      "TR": "Turquia",
      "TM": "Turcomenist\u00E3o",
      "TC": "Ilhas Turks e Caicos",
      "TV": "Tuvalu",
      "UM": "Ilhas Menores Distantes dos Estados Unidos",
      "PU": "Diversas Ilhas do Pac\u00EDfico dos EUA",
      "VI": "Ilhas Virgens (Americanas)",
      "UG": "Uganda",
      "UA": "Ucr\u00E2nia",
      "AE": "Emirados \u00C1rabes Unidos",
      "GB": "Reino Unido",
      "US": "Estados Unidos da Am\u00E9rica",
      "UY": "Uruguai",
      "UZ": "Uzbequist\u00E3o",
      "VU": "Vanuatu",
      "VA": "Santa S\u00E9",
      "VE": "Venezuela (Rep\u00FAblica Bolivariana da)",
      "VN": "Vietn\u00E3",
      "WK": "Ilha Wake",
      "WF": "Wallis e Futuna",
      "EH": "Saara Ocidental",
      "YE": "I\u00EAmen",
      "ZM": "Z\u00E2mbia",
      "SD": "Sud\u00E3o",
      "SS": "Sud\u00E3o do Sul",
      "ZW": "Zimb\u00E1bue",
      "language.display": "{0} ({1})",
      "en-US": "EUA",
      "en-GB": "RU",
      "zh-CN": "China",
      "es-ES": "Espanha",
      "fr-FR": "Fran\u00E7a",
      "jp-JP": "Jap\u00E3o",
      "de-DE": "Alemanha",
      "pt-PT": "Portugu\u00EAs",
      "ru-RU": "Russo",
      "TW-TW": "Taiwan",
      "PG": "Papua Nova Guin\u00E9",
      "CG": "Congo"
    }
  },
  "ru-RU": {
    "country": {
      "AF": "\u0410\u0444\u0433\u0430\u043D\u0438\u0441\u0442\u0430\u043D",
      "AX": "\u0410\u043B\u0430\u043D\u0434\u0441\u043A\u0438\u0435 \u043E\u0441\u0442\u0440\u043E\u0432\u0430",
      "AL": "\u0410\u043B\u0431\u0430\u043D\u0438\u044F",
      "DZ": "\u0410\u043B\u0436\u0438\u0440",
      "AS": "\u0410\u043C\u0435\u0440\u0438\u043A\u0430\u043D\u0441\u043A\u043E\u0435 \u0421\u0430\u043C\u043E\u0430",
      "AD": "\u0410\u043D\u0434\u043E\u0440\u0440\u0430",
      "AO": "\u0410\u043D\u0433\u043E\u043B\u0430",
      "AI": "\u0410\u043D\u0433\u0438\u043B\u044C\u044F",
      "AQ": "\u0410\u043D\u0442\u0430\u0440\u043A\u0442\u0438\u0434\u0430",
      "AG": "\u0410\u043D\u0442\u0438\u0433\u0443\u0430 \u0438 \u0411\u0430\u0440\u0431\u0443\u0434\u0430",
      "AR": "\u0410\u0440\u0433\u0435\u043D\u0442\u0438\u043D\u0430",
      "AM": "\u0410\u0440\u043C\u0435\u043D\u0438\u044F",
      "AW": "\u0410\u0440\u0443\u0431\u0430",
      "AC": "\u041E\u0441\u0442\u0440\u043E\u0432 \u0412\u043E\u0437\u043D\u0435\u0441\u0435\u043D\u0438\u044F",
      "AU": "\u0410\u0432\u0441\u0442\u0440\u0430\u043B\u0438\u044F",
      "AT": "\u0410\u0432\u0441\u0442\u0440\u0438\u044F",
      "AZ": "\u0410\u0437\u0435\u0440\u0431\u0430\u0439\u0434\u0436\u0430\u043D",
      "BS": "\u0411\u0430\u0433\u0430\u043C\u0441\u043A\u0438\u0435 \u043E\u0441\u0442\u0440\u043E\u0432\u0430",
      "BH": "\u0411\u0430\u0445\u0440\u0435\u0439\u043D",
      "BD": "\u0411\u0430\u043D\u0433\u043B\u0430\u0434\u0435\u0448",
      "BB": "\u0411\u0430\u0440\u0431\u0430\u0434\u043E\u0441",
      "BY": "\u0411\u0435\u043B\u043E\u0440\u0443\u0441\u0441\u0438\u044F",
      "BE": "\u0411\u0435\u043B\u044C\u0433\u0438\u044F",
      "BZ": "\u0411\u0435\u043B\u0438\u0437",
      "BJ": "\u0411\u0435\u043D\u0438\u043D",
      "BM": "\u0411\u0435\u0440\u043C\u0443\u0434\u0441\u043A\u0438\u0435 \u043E\u0441\u0442\u0440\u043E\u0432\u0430",
      "BT": "\u0411\u0443\u0442\u0430\u043D",
      "BO": "\u0411\u043E\u043B\u0438\u0432\u0438\u044F, \u041C\u043D\u043E\u0433\u043E\u043D\u0430\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u043E\u0435 \u0413\u043E\u0441\u0443\u0434\u0430\u0440\u0441\u0442\u0432\u043E",
      "BA": "\u0411\u043E\u0441\u043D\u0438\u044F \u0438 \u0413\u0435\u0440\u0446\u0435\u0433\u043E\u0432\u0438\u043D\u0430",
      "BW": "\u0411\u043E\u0442\u0441\u0432\u0430\u043D\u0430",
      "BV": "\u041E\u0441\u0442\u0440\u043E\u0432 \u0411\u0443\u0432\u0435",
      "BR": "\u0411\u0440\u0430\u0437\u0438\u043B\u0438\u044F",
      "BQ": "\u0411\u043E\u043D\u0430\u0439\u0440\u0435, \u0421\u0438\u043D\u0442-\u042D\u0441\u0442\u0430\u0442\u0438\u0443\u0441 \u0438 \u0421\u0430\u0431\u0430",
      "IO": "\u0411\u0440\u0438\u0442\u0430\u043D\u0441\u043A\u0430\u044F \u0442\u0435\u0440\u0440\u0438\u0442\u043E\u0440\u0438\u044F \u0432 \u0418\u043D\u0434\u0438\u0439\u0441\u043A\u043E\u043C \u043E\u043A\u0435\u0430\u043D\u0435",
      "VG": "\u0412\u0438\u0440\u0433\u0438\u043D\u0441\u043A\u0438\u0435 \u043E-\u0432\u0430 (\u0411\u0440\u0438\u0442\u0430\u043D\u0441\u043A\u0438\u0435)",
      "BN": "\u0411\u0440\u0443\u043D\u0435\u0439-\u0414\u0430\u0440\u0443\u0441\u0441\u0430\u043B\u0430\u043C",
      "BG": "\u0411\u043E\u043B\u0433\u0430\u0440\u0438\u044F",
      "BF": "\u0411\u0443\u0440\u043A\u0438\u043D\u0430-\u0424\u0430\u0441\u043E",
      "BI": "\u0411\u0443\u0440\u0443\u043D\u0434\u0438",
      "KH": "\u041A\u0430\u043C\u0431\u043E\u0434\u0436\u0430",
      "CM": "\u041A\u0430\u043C\u0435\u0440\u0443\u043D",
      "CA": "\u041A\u0430\u043D\u0430\u0434\u0430",
      "IC": "\u041A\u0430\u043D\u0430\u0440\u0441\u043A\u0438\u0435 \u043E\u0441\u0442\u0440\u043E\u0432\u0430",
      "CT": "\u041E\u0441\u0442\u0440\u043E\u0432\u0430 \u041A\u0430\u043D\u0442\u043E\u043D \u0438 \u042D\u043D\u0434\u0435\u0440\u0431\u0435\u0440\u0438",
      "CV": "\u041A\u0430\u0431\u043E-\u0412\u0435\u0440\u0434\u0435",
      "KY": "\u041A\u0430\u0439\u043C\u0430\u043D\u043E\u0432\u044B \u043E\u0441\u0442\u0440\u043E\u0432\u0430",
      "CF": "\u0426\u0435\u043D\u0442\u0440\u0430\u043B\u044C\u043D\u043E\u0430\u0444\u0440\u0438\u043A\u0430\u043D\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430",
      "EA": "\u0421\u0435\u0443\u0442\u0430 \u0438 \u041C\u0435\u043B\u0438\u043B\u044C\u044F",
      "TD": "\u0427\u0430\u0434",
      "CL": "\u0427\u0438\u043B\u0438",
      "CN": "\u041A\u0438\u0442\u0430\u0439",
      "CX": "\u041E\u0441\u0442\u0440\u043E\u0432 \u0420\u043E\u0436\u0434\u0435\u0441\u0442\u0432\u0430",
      "CP": "\u041E\u0441\u0442\u0440\u043E\u0432 \u041A\u043B\u0438\u043F\u043F\u0435\u0440\u0442\u043E\u043D",
      "CC": "\u041A\u043E\u043A\u043E\u0441\u043E\u0432\u044B\u0435 \u043E\u0441\u0442\u0440\u043E\u0432\u0430 (\u041A\u0438\u043B\u0438\u043D\u0433)",
      "CO": "\u041A\u043E\u043B\u0443\u043C\u0431\u0438\u044F",
      "KM": "\u041A\u043E\u043C\u043E\u0440\u0441\u043A\u0438\u0435 \u043E\u0441\u0442\u0440\u043E\u0432\u0430",
      "CD": "\u041A\u043E\u043D\u0433\u043E, \u0414\u0435\u043C\u043E\u043A\u0440\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430",
      "CK": "\u041E\u0441\u0442\u0440\u043E\u0432\u0430 \u041A\u0443\u043A\u0430",
      "CR": "\u041A\u043E\u0441\u0442\u0430-\u0420\u0438\u043A\u0430",
      "CI": "\u041A\u043E\u0442-\u0434\u2019\u0418\u0432\u0443\u0430\u0440",
      "HR": "\u0425\u043E\u0440\u0432\u0430\u0442\u0438\u044F",
      "CU": "\u041A\u0443\u0431\u0430",
      "CW": "\u041A\u044E\u0440\u0430\u0441\u0430\u043E",
      "CY": "\u041A\u0438\u043F\u0440",
      "CZ": "\u0427\u0435\u0445\u0438\u044F",
      "DK": "\u0414\u0430\u043D\u0438\u044F",
      "DG": "\u0414\u0438\u0435\u0433\u043E-\u0413\u0430\u0440\u0441\u0438\u044F",
      "DJ": "\u0414\u0436\u0438\u0431\u0443\u0442\u0438",
      "DM": "\u0414\u043E\u043C\u0438\u043D\u0438\u043A\u0430",
      "DO": "\u0414\u043E\u043C\u0438\u043D\u0438\u043A\u0430\u043D\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430",
      "NQ": "\u0417\u0435\u043C\u043B\u044F \u041A\u043E\u0440\u043E\u043B\u0435\u0432\u044B \u041C\u043E\u0434",
      "EC": "\u042D\u043A\u0432\u0430\u0434\u043E\u0440",
      "EG": "\u0415\u0433\u0438\u043F\u0435\u0442",
      "SV": "\u0421\u0430\u043B\u044C\u0432\u0430\u0434\u043E\u0440",
      "GQ": "\u042D\u043A\u0432\u0430\u0442\u043E\u0440\u0438\u0430\u043B\u044C\u043D\u0430\u044F \u0413\u0432\u0438\u043D\u0435\u044F",
      "ER": "\u042D\u0440\u0438\u0442\u0440\u0435\u044F",
      "EE": "\u042D\u0441\u0442\u043E\u043D\u0438\u044F",
      "ET": "\u042D\u0444\u0438\u043E\u043F\u0438\u044F",
      "EU": "\u0415\u0432\u0440\u043E\u043F\u0435\u0439\u0441\u043A\u0438\u0439 \u0421\u043E\u044E\u0437",
      "FK": "\u0424\u043E\u043B\u043A\u043B\u0435\u043D\u0434\u0441\u043A\u0438\u0435 \u043E-\u0432\u0430 (\u041C\u0430\u043B\u044C\u0432\u0438\u043D\u0441\u043A\u0438\u0435)",
      "FO": "\u0424\u0430\u0440\u0435\u0440\u0441\u043A\u0438\u0435 \u043E\u0441\u0442\u0440\u043E\u0432\u0430",
      "FJ": "\u0424\u0438\u0434\u0436\u0438",
      "FI": "\u0424\u0438\u043D\u043B\u044F\u043D\u0434\u0438\u044F",
      "FR": "\u0424\u0440\u0430\u043D\u0446\u0438\u044F",
      "GF": "\u0424\u0440\u0430\u043D\u0446\u0443\u0437\u0441\u043A\u0430\u044F \u0413\u0432\u0438\u0430\u043D\u0430",
      "PF": "\u0424\u0440\u0430\u043D\u0446\u0443\u0437\u0441\u043A\u0430\u044F \u041F\u043E\u043B\u0438\u043D\u0435\u0437\u0438\u044F",
      "TF": "\u0424\u0440\u0430\u043D\u0446\u0443\u0437\u0441\u043A\u0438\u0435 \u042E\u0436\u043D\u044B\u0435 \u0422\u0435\u0440\u0440\u0438\u0442\u043E\u0440\u0438\u0438",
      "FQ": "\u0424\u0440\u0430\u043D\u0446\u0443\u0437\u0441\u043A\u0438\u0435 \u042E\u0436\u043D\u044B\u0435 \u0438 \u0410\u043D\u0442\u0430\u0440\u043A\u0442\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u0442\u0435\u0440\u0440\u0438\u0442\u043E\u0440\u0438\u0438",
      "GA": "\u0413\u0430\u0431\u043E\u043D",
      "GM": "\u0413\u0430\u043C\u0431\u0438\u044F",
      "GE": "\u0413\u0440\u0443\u0437\u0438\u044F",
      "DE": "\u0413\u0435\u0440\u043C\u0430\u043D\u0438\u044F",
      "GH": "\u0413\u0430\u043D\u0430",
      "GI": "\u0413\u0438\u0431\u0440\u0430\u043B\u0442\u0430\u0440",
      "GR": "\u0413\u0440\u0435\u0446\u0438\u044F",
      "GL": "\u0413\u0440\u0435\u043D\u043B\u0430\u043D\u0434\u0438\u044F",
      "GD": "\u0413\u0440\u0435\u043D\u0430\u0434\u0430",
      "GP": "\u0413\u0432\u0430\u0434\u0435\u043B\u0443\u043F\u0430",
      "GU": "\u0413\u0443\u0430\u043C",
      "GT": "\u0413\u0432\u0430\u0442\u0435\u043C\u0430\u043B\u0430",
      "GG": "\u0413\u0435\u0440\u043D\u0441\u0438",
      "GN": "\u0413\u0432\u0438\u043D\u0435\u044F",
      "GW": "\u0413\u0432\u0438\u043D\u0435\u044F-\u0411\u0438\u0441\u0430\u0443",
      "GY": "\u0413\u0430\u044F\u043D\u0430",
      "HT": "\u0413\u0430\u0438\u0442\u0438",
      "HM": "\u041E\u0441\u0442\u0440\u043E\u0432 \u0425\u0435\u0440\u0434 \u0438 \u043E\u0441\u0442\u0440\u043E\u0432\u0430 \u041C\u0430\u043A\u0434\u043E\u043D\u0430\u043B\u044C\u0434",
      "HN": "\u0413\u043E\u043D\u0434\u0443\u0440\u0430\u0441",
      "HK": "\u0421\u0410\u0420 \u0413\u043E\u043D\u043A\u043E\u043D\u0433",
      "HU": "\u0412\u0435\u043D\u0433\u0440\u0438\u044F",
      "IS": "\u0418\u0441\u043B\u0430\u043D\u0434\u0438\u044F",
      "IN": "\u0418\u043D\u0434\u0438\u044F",
      "ID": "\u0418\u043D\u0434\u043E\u043D\u0435\u0437\u0438\u044F",
      "IR": "\u0418\u0440\u0430\u043D, \u0418\u0441\u043B\u0430\u043C\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430",
      "IE": "\u0418\u0440\u043B\u0430\u043D\u0434\u0438\u044F",
      "IM": "\u041E\u0441\u0442\u0440\u043E\u0432 \u041C\u044D\u043D",
      "IL": "\u0418\u0437\u0440\u0430\u0438\u043B\u044C",
      "IQ": "\u0418\u0440\u0430\u043A",
      "IT": "\u0418\u0442\u0430\u043B\u0438\u044F",
      "JM": "\u042F\u043C\u0430\u0439\u043A\u0430",
      "JP": "\u042F\u043F\u043E\u043D\u0438\u044F",
      "JE": "\u0414\u0436\u0435\u0440\u0441\u0438",
      "JT": "\u041E\u0441\u0442\u0440\u043E\u0432 \u0414\u0436\u043E\u043D\u0441\u0442\u043E\u043D",
      "JO": "\u0418\u043E\u0440\u0434\u0430\u043D\u0438\u044F",
      "KZ": "\u041A\u0430\u0437\u0430\u0445\u0441\u0442\u0430\u043D",
      "KE": "\u041A\u0435\u043D\u0438\u044F",
      "KI": "\u041A\u0438\u0440\u0438\u0431\u0430\u0442\u0438",
      "KP": "\u041A\u043E\u0440\u0435\u044F, \u041D\u0430\u0440\u043E\u0434\u043D\u043E-\u0414\u0435\u043C\u043E\u043A\u0440\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430",
      "KR": "\u041A\u043E\u0440\u0435\u044F, \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430",
      "XK": "\u041A\u043E\u0441\u043E\u0432\u043E",
      "KW": "\u041A\u0443\u0432\u0435\u0439\u0442",
      "KG": "\u041A\u0438\u0440\u0433\u0438\u0437\u0438\u044F",
      "LA": "\u041B\u0430\u043E\u0441\u0441\u043A\u0430\u044F \u041D\u0430\u0440\u043E\u0434\u043D\u043E-\u0414\u0435\u043C\u043E\u043A\u0440\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430",
      "LV": "\u041B\u0430\u0442\u0432\u0438\u044F",
      "LB": "\u041B\u0438\u0432\u0430\u043D",
      "LS": "\u041B\u0435\u0441\u043E\u0442\u043E",
      "LR": "\u041B\u0438\u0431\u0435\u0440\u0438\u044F",
      "LY": "\u041B\u0438\u0432\u0438\u044F",
      "LI": "\u041B\u0438\u0445\u0442\u0435\u043D\u0448\u0442\u0435\u0439\u043D",
      "LT": "\u041B\u0438\u0442\u0432\u0430",
      "LU": "\u041B\u044E\u043A\u0441\u0435\u043C\u0431\u0443\u0440\u0433",
      "MO": "\u0421\u0410\u0420 \u041C\u0430\u043A\u0430\u043E",
      "MK": "\u0421\u0435\u0432\u0435\u0440\u043D\u0430\u044F \u041C\u0430\u043A\u0435\u0434\u043E\u043D\u0438\u044F",
      "MG": "\u041C\u0430\u0434\u0430\u0433\u0430\u0441\u043A\u0430\u0440",
      "MW": "\u041C\u0430\u043B\u0430\u0432\u0438",
      "MY": "\u041C\u0430\u043B\u0430\u0439\u0437\u0438\u044F",
      "MV": "\u041C\u0430\u043B\u044C\u0434\u0438\u0432\u044B",
      "ML": "\u041C\u0430\u043B\u0438",
      "MT": "\u041C\u0430\u043B\u044C\u0442\u0430",
      "MH": "\u041C\u0430\u0440\u0448\u0430\u043B\u043B\u043E\u0432\u044B \u043E\u0441\u0442\u0440\u043E\u0432\u0430",
      "MQ": "\u041C\u0430\u0440\u0442\u0438\u043D\u0438\u043A\u0430",
      "MR": "\u041C\u0430\u0432\u0440\u0438\u0442\u0430\u043D\u0438\u044F",
      "MU": "\u041C\u0430\u0432\u0440\u0438\u043A\u0438\u0439",
      "YT": "\u041C\u0430\u0439\u043E\u0442\u0442\u0430",
      "FX": "\u041C\u0435\u0442\u0440\u043E\u043F\u043E\u043B\u0438\u044F \u0424\u0440\u0430\u043D\u0446\u0438\u0438",
      "MX": "\u041C\u0435\u043A\u0441\u0438\u043A\u0430",
      "FM": "\u041C\u0438\u043A\u0440\u043E\u043D\u0435\u0437\u0438\u044F, \u0424\u0435\u0434\u0435\u0440\u0430\u0442\u0438\u0432\u043D\u044B\u0435 \u0428\u0442\u0430\u0442\u044B",
      "MI": "\u041E\u0441\u0442\u0440\u043E\u0432\u0430 \u041C\u0438\u0434\u0443\u044D\u0439",
      "MD": "\u041C\u043E\u043B\u0434\u043E\u0432\u0430, \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430",
      "MC": "\u041C\u043E\u043D\u0430\u043A\u043E",
      "MN": "\u041C\u043E\u043D\u0433\u043E\u043B\u0438\u044F",
      "ME": "\u0427\u0435\u0440\u043D\u043E\u0433\u043E\u0440\u0438\u044F",
      "MS": "\u041C\u043E\u043D\u0442\u0441\u0435\u0440\u0440\u0430\u0442",
      "MA": "\u041C\u0430\u0440\u043E\u043A\u043A\u043E",
      "MZ": "\u041C\u043E\u0437\u0430\u043C\u0431\u0438\u043A",
      "MM": "\u041C\u044C\u044F\u043D\u043C\u0430",
      "NA": "\u041D\u0430\u043C\u0438\u0431\u0438\u044F",
      "NR": "\u041D\u0430\u0443\u0440\u0443",
      "NP": "\u041D\u0435\u043F\u0430\u043B",
      "NL": "\u041D\u0438\u0434\u0435\u0440\u043B\u0430\u043D\u0434\u044B",
      "AN": "\u041D\u0438\u0434\u0435\u0440\u043B\u0430\u043D\u0434\u0441\u043A\u0438\u0435 \u0410\u043D\u0442\u0438\u043B\u044C\u0441\u043A\u0438\u0435 \u043E\u0441\u0442\u0440\u043E\u0432\u0430",
      "NT": "\u041D\u0435\u0439\u0442\u0440\u0430\u043B\u044C\u043D\u0430\u044F \u0437\u043E\u043D\u0430",
      "NC": "\u041D\u043E\u0432\u0430\u044F \u041A\u0430\u043B\u0435\u0434\u043E\u043D\u0438\u044F",
      "NZ": "\u041D\u043E\u0432\u0430\u044F \u0417\u0435\u043B\u0430\u043D\u0434\u0438\u044F",
      "NI": "\u041D\u0438\u043A\u0430\u0440\u0430\u0433\u0443\u0430",
      "NE": "\u041D\u0438\u0433\u0435\u0440",
      "NG": "\u041D\u0438\u0433\u0435\u0440\u0438\u044F",
      "NU": "\u041D\u0438\u0443\u044D",
      "NF": "\u041E\u0441\u0442\u0440\u043E\u0432 \u041D\u043E\u0440\u0444\u043E\u043B\u043A",
      "VD": "\u0421\u0435\u0432\u0435\u0440\u043D\u044B\u0439 \u0412\u044C\u0435\u0442\u043D\u0430\u043C",
      "MP": "\u0421\u0435\u0432\u0435\u0440\u043D\u044B\u0435 \u041C\u0430\u0440\u0438\u0430\u043D\u0441\u043A\u0438\u0435 \u043E\u0441\u0442\u0440\u043E\u0432\u0430",
      "NO": "\u041D\u043E\u0440\u0432\u0435\u0433\u0438\u044F",
      "OM": "\u041E\u043C\u0430\u043D",
      "OM_mobile": "\u041E\u043C\u0430\u043D \u041C\u043E\u0431\u0430\u0439\u043B",
      "QO": "\u041E\u0442\u0434\u0430\u043B\u0435\u043D\u043D\u0430\u044F \u041E\u043A\u0435\u0430\u043D\u0438\u044F",
      "PC": "\u041F\u043E\u0434\u043E\u043F\u0435\u0447\u043D\u0430\u044F \u0442\u0435\u0440\u0440\u0438\u0442\u043E\u0440\u0438\u044F \u0422\u0438\u0445\u043E\u043E\u043A\u0435\u0430\u043D\u0441\u043A\u0438\u0435 \u043E\u0441\u0442\u0440\u043E\u0432\u0430",
      "PK": "\u041F\u0430\u043A\u0438\u0441\u0442\u0430\u043D",
      "PW": "\u041F\u0430\u043B\u0430\u0443",
      "PS": "\u041F\u0430\u043B\u0435\u0441\u0442\u0438\u043D\u0441\u043A\u0430\u044F \u0410\u0432\u0442\u043E\u043D\u043E\u043C\u0438\u044F",
      "PA": "\u041F\u0430\u043D\u0430\u043C\u0430",
      "PZ": "\u0417\u043E\u043D\u0430 \u041F\u0430\u043D\u0430\u043C\u0441\u043A\u043E\u0433\u043E \u043A\u0430\u043D\u0430\u043B\u0430",
      "PY": "\u041F\u0430\u0440\u0430\u0433\u0432\u0430\u0439",
      "YD": "\u041D\u0430\u0440\u043E\u0434\u043D\u043E-\u0414\u0435\u043C\u043E\u043A\u0440\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0419\u0435\u043C\u0435\u043D",
      "PE": "\u041F\u0435\u0440\u0443",
      "PH": "\u0424\u0438\u043B\u0438\u043F\u043F\u0438\u043D\u044B",
      "PN": "\u041F\u0438\u0442\u043A\u0435\u0440\u043D",
      "PL": "\u041F\u043E\u043B\u044C\u0448\u0430",
      "PT": "\u041F\u043E\u0440\u0442\u0443\u0433\u0430\u043B\u0438\u044F",
      "PR": "\u041F\u0443\u044D\u0440\u0442\u043E-\u0420\u0438\u043A\u043E",
      "QA": "\u041A\u0430\u0442\u0430\u0440",
      "RE": "\u0420\u0435\u044E\u043D\u044C\u043E\u043D",
      "RO": "\u0420\u0443\u043C\u044B\u043D\u0438\u044F",
      "RU": "\u0420\u043E\u0441\u0441\u0438\u0439\u0441\u043A\u0430\u044F \u0424\u0435\u0434\u0435\u0440\u0430\u0446\u0438\u044F",
      "RW": "\u0420\u0443\u0430\u043D\u0434\u0430",
      "BL": "\u0421\u0435\u043D-\u0411\u0430\u0440\u0442\u0435\u043B\u0435\u043C\u0438",
      "SH": "\u041E\u0441\u0442\u0440\u043E\u0432\u0430 \u0421\u0432. \u0415\u043B\u0435\u043D\u044B, \u0412\u043E\u0437\u043D\u0435\u0441\u0435\u043D\u0438\u044F \u0438 \u0422\u0440\u0438\u0441\u0442\u0430\u043D-\u0434\u0430-\u041A\u0443\u043D\u044C\u044F",
      "KN": "\u0421\u0435\u043D\u0442-\u041A\u0438\u0442\u0441 \u0438 \u041D\u0435\u0432\u0438\u0441",
      "LC": "\u0421\u0435\u043D\u0442-\u041B\u044E\u0441\u0438\u044F",
      "MF": "\u0421\u0435\u043D-\u041C\u0430\u0440\u0442\u0435\u043D (\u0444\u0440\u0430\u043D\u0446\u0443\u0437\u0441\u043A\u0430\u044F \u0447\u0430\u0441\u0442\u044C)",
      "PM": "\u0421\u0435\u043D-\u041F\u044C\u0435\u0440 \u0438 \u041C\u0438\u043A\u0435\u043B\u043E\u043D",
      "VC": "\u0421\u0435\u043D\u0442-\u0412\u0438\u043D\u0441\u0435\u043D\u0442 \u0438 \u0413\u0440\u0435\u043D\u0430\u0434\u0438\u043D\u044B",
      "WS": "\u0421\u0430\u043C\u043E\u0430",
      "SM": "\u0421\u0430\u043D-\u041C\u0430\u0440\u0438\u043D\u043E",
      "ST": "\u0421\u0430\u043D-\u0422\u043E\u043C\u0435 \u0438 \u041F\u0440\u0438\u043D\u0441\u0438\u043F\u0438",
      "SA": "\u0421\u0430\u0443\u0434\u043E\u0432\u0441\u043A\u0430\u044F \u0410\u0440\u0430\u0432\u0438\u044F",
      "SN": "\u0421\u0435\u043D\u0435\u0433\u0430\u043B",
      "RS": "\u0421\u0435\u0440\u0431\u0438\u044F",
      "CS": "\u0421\u0435\u0440\u0431\u0438\u044F \u0438 \u0427\u0435\u0440\u043D\u043E\u0433\u043E\u0440\u0438\u044F",
      "SC": "\u0421\u0435\u0439\u0448\u0435\u043B\u044C\u0441\u043A\u0438\u0435 \u043E\u0441\u0442\u0440\u043E\u0432\u0430",
      "SL": "\u0421\u044C\u0435\u0440\u0440\u0430-\u041B\u0435\u043E\u043D\u0435",
      "SG": "\u0421\u0438\u043D\u0433\u0430\u043F\u0443\u0440",
      "SX": "\u0421\u0435\u043D-\u041C\u0430\u0440\u0442\u0435\u043D (\u043D\u0438\u0434\u0435\u0440\u043B\u0430\u043D\u0434\u0441\u043A\u0430\u044F \u0447\u0430\u0441\u0442\u044C)",
      "SK": "\u0421\u043B\u043E\u0432\u0430\u043A\u0438\u044F",
      "SI": "\u0421\u043B\u043E\u0432\u0435\u043D\u0438\u044F",
      "SB": "\u0421\u043E\u043B\u043E\u043C\u043E\u043D\u043E\u0432\u044B \u043E\u0441\u0442\u0440\u043E\u0432\u0430",
      "SO": "\u0421\u043E\u043C\u0430\u043B\u0438",
      "ZA": "\u042E\u0410\u0420",
      "GS": "\u042E\u0436\u043D\u0430\u044F \u0413\u0435\u043E\u0440\u0433\u0438\u044F \u0438 \u042E\u0436\u043D\u044B\u0435 \u0421\u0430\u043D\u0434\u0432\u0438\u0447\u0435\u0432\u044B \u041E\u0441\u0442\u0440\u043E\u0432\u0430",
      "ES": "\u0418\u0441\u043F\u0430\u043D\u0438\u044F",
      "LK": "\u0428\u0440\u0438-\u041B\u0430\u043D\u043A\u0430",
      "SR": "\u0421\u0443\u0440\u0438\u043D\u0430\u043C",
      "SJ": "\u0428\u043F\u0438\u0446\u0431\u0435\u0440\u0433\u0435\u043D \u0438 \u042F\u043D-\u041C\u0430\u0439\u0435\u043D",
      "SZ": "\u0421\u0432\u0430\u0437\u0438\u043B\u0435\u043D\u0434",
      "SE": "\u0428\u0432\u0435\u0446\u0438\u044F",
      "CH": "\u0428\u0432\u0435\u0439\u0446\u0430\u0440\u0438\u044F",
      "SY": "\u0421\u0438\u0440\u0438\u0439\u0441\u043A\u0430\u044F \u0410\u0440\u0430\u0431\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430",
      "TW": "\u0422\u0430\u0439\u0432\u0430\u043D\u044C, \u041A\u0438\u0442\u0430\u0439",
      "TW_mobile": "\u0422\u0430\u0439\u0432\u0430\u043D\u044C \u041C\u043E\u0431\u0430\u0439\u043B",
      "TJ": "\u0422\u0430\u0434\u0436\u0438\u043A\u0438\u0441\u0442\u0430\u043D",
      "TZ": "\u0422\u0430\u043D\u0437\u0430\u043D\u0438\u044F, \u041E\u0431\u044A\u0435\u0434\u0438\u043D\u0435\u043D\u043D\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430",
      "TH": "\u0422\u0430\u0438\u043B\u0430\u043D\u0434",
      "TL": "\u0412\u043E\u0441\u0442\u043E\u0447\u043D\u044B\u0439 \u0422\u0438\u043C\u043E\u0440",
      "TG": "\u0422\u043E\u0433\u043E",
      "TK": "\u0422\u043E\u043A\u0435\u043B\u0430\u0443",
      "TO": "\u0422\u043E\u043D\u0433\u0430",
      "TT": "\u0422\u0440\u0438\u043D\u0438\u0434\u0430\u0434 \u0438 \u0422\u043E\u0431\u0430\u0433\u043E",
      "TA": "\u0422\u0440\u0438\u0441\u0442\u0430\u043D-\u0434\u0430-\u041A\u0443\u043D\u044C\u044F",
      "TN": "\u0422\u0443\u043D\u0438\u0441",
      "TR": "\u0422\u0443\u0440\u0446\u0438\u044F",
      "TM": "\u0422\u0443\u0440\u043A\u043C\u0435\u043D\u0438\u0441\u0442\u0430\u043D",
      "TC": "\u041E\u0441\u0442\u0440\u043E\u0432\u0430 \u0422\u0435\u0440\u043A\u0441 \u0438 \u041A\u0430\u0439\u043A\u043E\u0441",
      "TV": "\u0422\u0443\u0432\u0430\u043B\u0443",
      "UM": "\u0412\u043D\u0435\u0448\u043D\u0438\u0435 \u043C\u0430\u043B\u044B\u0435 \u043E-\u0432\u0430 (\u0421\u0428\u0410)",
      "PU": "\u0420\u0430\u0437\u043D\u044B\u0435 \u0422\u0438\u0445\u043E\u043E\u043A\u0435\u0430\u043D\u0441\u043A\u0438\u0435 \u043E\u0441\u0442\u0440\u043E\u0432\u0430 \u0421\u0428\u0410",
      "VI": "\u0412\u0438\u0440\u0433\u0438\u043D\u0441\u043A\u0438\u0435 \u043E-\u0432\u0430 (\u0421\u0428\u0410)",
      "UG": "\u0423\u0433\u0430\u043D\u0434\u0430",
      "UA": "\u0423\u043A\u0440\u0430\u0438\u043D\u0430",
      "AE": "\u041E\u0431\u044A\u0435\u0434\u0438\u043D\u0435\u043D\u043D\u044B\u0435 \u0410\u0440\u0430\u0431\u0441\u043A\u0438\u0435 \u042D\u043C\u0438\u0440\u0430\u0442\u044B",
      "GB": "\u0412\u0435\u043B\u0438\u043A\u043E\u0431\u0440\u0438\u0442\u0430\u043D\u0438\u044F",
      "US": "\u0421\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u043D\u044B\u0435 \u0428\u0442\u0430\u0442\u044B \u0410\u043C\u0435\u0440\u0438\u043A\u0438",
      "UY": "\u0423\u0440\u0443\u0433\u0432\u0430\u0439",
      "UZ": "\u0423\u0437\u0431\u0435\u043A\u0438\u0441\u0442\u0430\u043D",
      "VU": "\u0412\u0430\u043D\u0443\u0430\u0442\u0443",
      "VA": "\u0412\u0430\u0442\u0438\u043A\u0430\u043D",
      "VE": "\u0412\u0435\u043D\u0435\u0441\u0443\u044D\u043B\u0430, \u0411\u043E\u043B\u0438\u0432\u0430\u0440\u0438\u0439\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430",
      "VN": "\u0412\u044C\u0435\u0442\u043D\u0430\u043C",
      "WK": "\u041E\u0441\u0442\u0440\u043E\u0432 \u0423\u044D\u0439\u043A",
      "WF": "\u0423\u043E\u043B\u043B\u0438\u0441 \u0438 \u0424\u0443\u0442\u0443\u043D\u0430",
      "EH": "\u0417\u0430\u043F\u0430\u0434\u043D\u0430\u044F \u0421\u0430\u0445\u0430\u0440\u0430",
      "YE": "\u0419\u0435\u043C\u0435\u043D",
      "ZM": "\u0417\u0430\u043C\u0431\u0438\u044F",
      "SD": "\u0421\u0443\u0434\u0430\u043D",
      "SS": "\u042E\u0436\u043D\u044B\u0439 \u0421\u0443\u0434\u0430\u043D",
      "ZW": "\u0417\u0438\u043C\u0431\u0430\u0431\u0432\u0435",
      "language.display": "{0} ({1})",
      "en-US": "\u0421\u0428\u0410",
      "en-GB": "\u0412\u0435\u043B\u0438\u043A\u043E\u0431\u0440\u0438\u0442\u0430\u043D\u0438\u044F",
      "zh-CN": "\u041A\u0438\u0442\u0430\u0439",
      "es-ES": "\u0418\u0441\u043F\u0430\u043D\u0438\u044F",
      "fr-FR": "\u0424\u0440\u0430\u043D\u0446\u0438\u044F",
      "jp-JP": "\u042F\u043F\u043E\u043D\u0438\u044F",
      "de-DE": "\u0413\u0435\u0440\u043C\u0430\u043D\u0438\u044F",
      "pt-PT": "Portuguese",
      "ru-RU": "\u0420\u0443\u0441\u0441\u043A\u0438\u0439",
      "TW-TW": "\u0422\u0430\u0439\u0432\u0430\u043D\u044C",
      "PG": "\u041F\u0430\u043F\u0443\u0430 \u2014 \u041D\u043E\u0432\u0430\u044F \u0413\u0432\u0438\u043D\u0435\u044F",
      "CG": "\u041A\u043E\u043D\u0433\u043E"
    }
  },
  "vi-VN": {
    "country": {
      "AF": "Afghanistan",
      "AX": "Qu\u1EA7n \u0111\u1EA3o \u00C5land",
      "AL": "Albania",
      "DZ": "Algeria",
      "AS": "Samoa thu\u1ED9c M\u1EF9",
      "AD": "Andorra",
      "AO": "Angola",
      "AI": "Anguilla",
      "AQ": "Nam C\u1EF1c",
      "AG": "Antigua v\u00E0 Barbuda",
      "AR": "Argentina",
      "AM": "Armenia",
      "AW": "Aruba",
      "AC": "\u0110\u1EA3o Ascension",
      "AU": "Australia",
      "AT": "\u00C1o",
      "AZ": "Azerbaijan",
      "BS": "Bahamas",
      "BH": "Bahrain",
      "BD": "Bangladesh",
      "BB": "Barbados",
      "BY": "Belarus",
      "BE": "B\u1EC9",
      "BZ": "Belize",
      "BJ": "Benin",
      "BM": "Bermuda",
      "BT": "Bhutan",
      "BO": "Bolivia (Nh\u00E0 n\u01B0\u1EDBc \u0110a d\u00E2n t\u1ED9c)",
      "BA": "Bosnia v\u00E0 Herzegovina",
      "BW": "Botswana",
      "BV": "\u0110\u1EA3o Bouvet",
      "BR": "Brazil",
      "BQ": "Bonaire, Sint Eustatius v\u00E0 Saba",
      "IO": "L\u00E3nh th\u1ED5 \u1EA4n \u0110\u1ED9 D\u01B0\u01A1ng thu\u1ED9c Anh",
      "VG": "Qu\u1EA7n \u0111\u1EA3o Virgin (thu\u1ED9c Anh)",
      "BN": "Brunei Darussalam",
      "BG": "Bulgaria",
      "BF": "Burkina Faso",
      "BI": "Burundi",
      "KH": "Campuchia",
      "CM": "Cameroon",
      "CA": "Canada",
      "IC": "Qu\u1EA7n \u0111\u1EA3o Canarias",
      "CT": "Qu\u1EA7n \u0111\u1EA3o Canton v\u00E0 Enderbury",
      "CV": "Cabo Verde",
      "KY": "Qu\u1EA7n \u0111\u1EA3o Cayman",
      "CF": "C\u1ED9ng h\u00F2a Trung Phi",
      "EA": "Ceuta v\u00E0 Melilla",
      "TD": "Chad",
      "CL": "Chile",
      "CN": "Trung Qu\u1ED1c",
      "CX": "\u0110\u1EA3o Gi\u00E1ng Sinh",
      "CP": "\u0110\u1EA3o Clipperton",
      "CC": "Qu\u1EA7n \u0111\u1EA3o Cocos (Keeling)",
      "CO": "Colombia",
      "KM": "Comoros",
      "CD": "C\u1ED9ng h\u00F2a D\u00E2n ch\u1EE7 Congo",
      "CK": "Qu\u1EA7n \u0111\u1EA3o Cook",
      "CR": "Costa Rica",
      "CI": "B\u1EDD Bi\u1EC3n Ng\u00E0",
      "HR": "Croatia",
      "CU": "Cuba",
      "CW": "Cura\u00E7ao",
      "CY": "S\u00EDp",
      "CZ": "S\u00E9c",
      "DK": "\u0110an M\u1EA1ch",
      "DG": "Diego Garcia",
      "DJ": "Djibouti",
      "DM": "Dominica",
      "DO": "C\u1ED9ng h\u00F2a Dominicana",
      "NQ": "V\u00F9ng \u0111\u1EA5t Dronning Maud",
      "EC": "Ecuador",
      "EG": "Ai C\u1EADp",
      "SV": "El Salvador",
      "GQ": "Guinea X\u00EDch \u0111\u1EA1o",
      "ER": "Eritrea",
      "EE": "Estonia",
      "ET": "Ethiopia",
      "EU": "Li\u00EAn minh ch\u00E2u \u00C2u",
      "FK": "Qu\u1EA7n \u0111\u1EA3o Falkland (Malvinas)",
      "FO": "Qu\u1EA7n \u0111\u1EA3o Faroe",
      "FJ": "Fiji",
      "FI": "Ph\u1EA7n Lan",
      "FR": "Ph\u00E1p",
      "GF": "Guiana thu\u1ED9c Ph\u00E1p",
      "PF": "Polynesia thu\u1ED9c Ph\u00E1p",
      "TF": "V\u00F9ng \u0111\u1EA5t ph\u00EDa nam thu\u1ED9c Ph\u00E1p",
      "FQ": "V\u00F9ng \u0111\u1EA5t ph\u00EDa nam v\u00E0 ch\u00E2u Nam c\u1EF1c thu\u1ED9c Ph\u00E1p",
      "GA": "Gabon",
      "GM": "Gambia",
      "GE": "Georgia",
      "DE": "\u0110\u1EE9c",
      "GH": "Ghana",
      "GI": "Gibraltar",
      "GR": "Hi L\u1EA1p",
      "GL": "Greenland",
      "GD": "Grenada",
      "GP": "Guadeloupe",
      "GU": "Guam",
      "GT": "Guatemala",
      "GG": "Guernsey",
      "GN": "Guinea",
      "GW": "Guinea-Bissau",
      "GY": "Guyana",
      "HT": "Haiti",
      "HM": "\u0110\u1EA3o Heard v\u00E0 qu\u1EA7n \u0111\u1EA3o McDonald",
      "HN": "Honduras",
      "HK": "\u0110\u1EB7c khu h\u00E0nh ch\u00EDnh H\u1ED3ng K\u00F4ng",
      "HU": "Hungary",
      "IS": "Iceland",
      "IN": "\u1EA4n \u0110\u1ED9",
      "ID": "Indonesia",
      "IR": "C\u1ED9ng h\u00F2a H\u1ED3i gi\u00E1o Iran",
      "IE": "Ireland",
      "IM": "\u0110\u1EA3o Man",
      "IL": "Israel",
      "IQ": "Iraq",
      "IT": "Italy",
      "JM": "Jamaica",
      "JP": "Nh\u1EADt B\u1EA3n",
      "JE": "Jersey",
      "JT": "\u0110\u1EA3o Johnston",
      "JO": "Jordan",
      "KZ": "Kazakhstan",
      "KE": "Kenya",
      "KI": "Kiribati",
      "KP": "Tri\u1EC1u Ti\u00EAn (C\u1ED9ng h\u00F2a D\u00E2n ch\u1EE7 Nh\u00E2n d\u00E2n)",
      "KR": "H\u00E0n Qu\u1ED1c (\u0110\u1EA1i H\u00E0n D\u00E2n Qu\u1ED1c)",
      "XK": "Kosovo",
      "KW": "Kuwait",
      "KG": "Kyrgyzstan",
      "LA": "C\u1ED9ng ho\u00E0 D\u00E2n ch\u1EE7 Nh\u00E2n d\u00E2n L\u00E0o",
      "LV": "Latvia",
      "LB": "Liban",
      "LS": "Lesotho",
      "LR": "Liberia",
      "LY": "Libya",
      "LI": "Liechtenstein",
      "LT": "Lithuania",
      "LU": "Luxembourg",
      "MO": "\u0110\u1EB7c khu h\u00E0nh ch\u00EDnh Macao",
      "MK": "B\u1EAFc Macedonia",
      "MG": "Madagascar",
      "MW": "Malawi",
      "MY": "Malaysia",
      "MV": "Maldives",
      "ML": "Mali",
      "MT": "Malta",
      "MH": "Qu\u1EA7n \u0111\u1EA3o Marshall",
      "MQ": "Martinique",
      "MR": "Mauritania",
      "MU": "Mauritius",
      "YT": "Mayotte",
      "FX": "Ch\u00EDnh qu\u1ED1c Ph\u00E1p",
      "MX": "Mexico",
      "FM": "Li\u00EAn bang Micronesia",
      "MI": "Qu\u1EA7n \u0111\u1EA3o Midway",
      "MD": "C\u1ED9ng ho\u00E0 Moldova",
      "MC": "Monaco",
      "MN": "M\u00F4ng C\u1ED5",
      "ME": "Montenegro",
      "MS": "Montserrat",
      "MA": "Morocco",
      "MZ": "Mozambique",
      "MM": "Myanmar",
      "NA": "Namibia",
      "NR": "Nauru",
      "NP": "Nepal",
      "NL": "H\u00E0 Lan",
      "AN": "Antille thu\u1ED9c H\u00E0 Lan",
      "NT": "Khu v\u1EF1c trung l\u1EADp",
      "NC": "New Caledonia",
      "NZ": "New Zealand",
      "NI": "Nicaragua",
      "NE": "Niger",
      "NG": "Nigeria",
      "NU": "Niue",
      "NF": "\u0110\u1EA3o Norfolk",
      "VD": "Mi\u1EC1n B\u1EAFc Vi\u1EC7t Nam",
      "MP": "Qu\u1EA7n \u0111\u1EA3o B\u1EAFc Mariana",
      "NO": "Na Uy",
      "OM": "Oman",
      "OM_mobile": "Di \u0111\u1ED9ng Oman",
      "QO": "V\u00F9ng xa x\u00F4i thu\u1ED9c Ch\u00E2u \u0110\u1EA1i D\u01B0\u01A1ng",
      "PC": "L\u00E3nh th\u1ED5 \u1EE6y th\u00E1c Qu\u1EA7n \u0111\u1EA3o Th\u00E1i B\u00ECnh D\u01B0\u01A1ng",
      "PK": "Pakistan",
      "PW": "Palau",
      "PS": "Nh\u00E0 n\u01B0\u1EDBc Palestine",
      "PA": "Panama",
      "PZ": "K\u00EAnh \u0111\u00E0o Panama",
      "PY": "Paraguay",
      "YD": "C\u1ED9ng h\u00F2a D\u00E2n ch\u1EE7 Nh\u00E2n d\u00E2n Yemen",
      "PE": "Peru",
      "PH": "Philippines",
      "PN": "Pitcairn",
      "PL": "Ba Lan",
      "PT": "B\u1ED3 \u0110\u00E0o Nha",
      "PR": "Puerto Rico",
      "QA": "Qatar",
      "RE": "R\u00E9union",
      "RO": "Romania",
      "RU": "Li\u00EAn bang Nga",
      "RW": "Rwanda",
      "BL": "C\u1ED9ng \u0111\u1ED3ng Saint-Barth\u00E9lemy",
      "SH": "Saint Helena, Ascension v\u00E0 Tristan da Cunha",
      "KN": "Li\u00EAn bang Saint Kitts v\u00E0 Nevis",
      "LC": "Saint Lucia",
      "MF": "Saint-Martin (ph\u1EA7n thu\u1ED9c Ph\u00E1p)",
      "PM": "Saint Pierre v\u00E0 Miquelon",
      "VC": "Saint Vincent v\u00E0 Grenadines",
      "WS": "Samoa",
      "SM": "San Marino",
      "ST": "Sao Tome v\u00E0 Principe",
      "SA": "\u1EA2 R\u1EADp X\u00EA \u00DAt",
      "SN": "Senegal",
      "RS": "Serbia",
      "CS": "Serbia v\u00E0 Montenegro",
      "SC": "Seychelles",
      "SL": "Sierra Leone",
      "SG": "Singapore",
      "SX": "Sint Maarten (ph\u1EA7n thu\u1ED9c H\u00E0 Lan)",
      "SK": "Slovakia",
      "SI": "Slovenia",
      "SB": "Qu\u1EA7n \u0111\u1EA3o Solomon",
      "SO": "Somalia",
      "ZA": "Nam Phi",
      "GS": "Nam Georgia v\u00E0 Qu\u1EA7n \u0111\u1EA3o Nam Sandwich",
      "ES": "T\u00E2y Ban Nha",
      "LK": "Sri Lanka",
      "SR": "Suriname",
      "SJ": "Svalbard v\u00E0 Jan Mayen",
      "SZ": "Eswatini",
      "SE": "Th\u1EE5y \u0110i\u1EC3n",
      "CH": "Th\u1EE5y S\u0129",
      "SY": "C\u1ED9ng h\u00F2a \u1EA2 R\u1EADp Syria",
      "TW": "\u0110\u00E0i Loan, Trung Qu\u1ED1c",
      "TW_mobile": "Di \u0111\u1ED9ng \u0110\u00E0i Loan",
      "TJ": "Tajikistan",
      "TZ": "C\u1ED9ng h\u00F2a Th\u1ED1ng nh\u1EA5t Tanzania",
      "TH": "Th\u00E1i Lan",
      "TL": "Timor-Leste",
      "TG": "Togo",
      "TK": "Tokelau",
      "TO": "Tonga",
      "TT": "Trinidad v\u00E0 Tobago",
      "TA": "Tristan da Cunha",
      "TN": "Tunisia",
      "TR": "Th\u1ED5 Nh\u0129 K\u1EF3",
      "TM": "Turkmenistan",
      "TC": "Qu\u1EA7n \u0111\u1EA3o Turks v\u00E0 Caicos",
      "TV": "Tuvalu",
      "UM": "C\u00E1c ti\u1EC3u \u0111\u1EA3o xa c\u1EE7a Hoa K\u1EF3",
      "PU": "T\u1ED5 h\u1EE3p qu\u1EA7n \u0111\u1EA3o Th\u00E1i B\u00ECnh D\u01B0\u01A1ng thu\u1ED9c Hoa K\u1EF3",
      "VI": "Qu\u1EA7n \u0111\u1EA3o Virgin (thu\u1ED9c M\u1EF9)",
      "UG": "Uganda",
      "UA": "Ukraina",
      "AE": "C\u00E1c Ti\u1EC3u v\u01B0\u01A1ng qu\u1ED1c \u1EA3 R\u1EADp th\u1ED1ng nh\u1EA5t",
      "GB": "V\u01B0\u01A1ng qu\u1ED1c Anh",
      "US": "H\u1EE3p ch\u1EE7ng qu\u1ED1c Hoa K\u1EF3",
      "UY": "Uruguay",
      "UZ": "Uzbekistan",
      "VU": "Vanuatu",
      "VA": "Holy See",
      "VE": "C\u1ED9ng h\u00F2a Bolivariana Venezuela",
      "VN": "Vi\u1EC7t Nam",
      "WK": "\u0110\u1EA3o Wake",
      "WF": "Wallis v\u00E0 Futuna",
      "EH": "Western Sahara",
      "YE": "Yemen",
      "ZM": "Zambia",
      "SD": "Sudan",
      "SS": "Nam Sudan",
      "ZW": "Zimbabwe",
      "CG": "Congo",
      "PG": "Papua New Guinea",
      "language.display": "{0} ({1})",
      "en-US": "M\u1EF9",
      "en-GB": "V\u01B0\u01A1ng qu\u1ED1c Anh",
      "zh-CN": "Trung Qu\u1ED1c",
      "es-ES": "T\u00E2y Ban Nha",
      "fr-FR": "Ph\u00E1p",
      "jp-JP": "Nh\u1EADt B\u1EA3n",
      "de-DE": "\u0110\u1EE9c",
      "pt-PT": "Ti\u1EBFng B\u1ED3 \u0110\u00E0o Nha",
      "ru-RU": "Ti\u1EBFng Nga",
      "TW-TW": "\u0110\u00E0i Loan"
    }
  },
  "zh-CN": {
    "country": {
      "AF": "\u963F\u5BCC\u6C57",
      "AX": "\u963F\u5170\u7FA4\u5C9B",
      "AL": "\u963F\u5C14\u5DF4\u5C3C\u4E9A",
      "DZ": "\u963F\u5C14\u53CA\u5229\u4E9A",
      "AS": "\u7F8E\u5C5E\u8428\u6469\u4E9A",
      "AD": "\u5B89\u9053\u5C14",
      "AO": "\u5B89\u54E5\u62C9",
      "AI": "\u5B89\u572D\u62C9",
      "AQ": "\u5357\u6781\u6D32",
      "AG": "\u5B89\u63D0\u74DC\u548C\u5DF4\u5E03\u8FBE",
      "AR": "\u963F\u6839\u5EF7",
      "AM": "\u4E9A\u7F8E\u5C3C\u4E9A",
      "AW": "\u963F\u9C81\u5DF4",
      "AC": "\u963F\u68EE\u677E\u5C9B",
      "AU": "\u6FB3\u5927\u5229\u4E9A",
      "AT": "\u5965\u5730\u5229",
      "AZ": "\u963F\u585E\u62DC\u7586",
      "BS": "\u5DF4\u54C8\u9A6C\u7FA4\u5C9B",
      "BH": "\u5DF4\u6797",
      "BD": "\u5B5F\u52A0\u62C9\u56FD",
      "BB": "\u5DF4\u5DF4\u591A\u65AF",
      "BY": "\u767D\u4FC4\u7F57\u65AF",
      "BE": "\u6BD4\u5229\u65F6",
      "BZ": "\u4F2F\u5229\u5179\u57CE",
      "BJ": "\u8D1D\u5B81",
      "BM": "\u767E\u6155\u5927\u7FA4\u5C9B",
      "BT": "\u4E0D\u4E39",
      "BO": "\u591A\u6C11\u65CF\u73BB\u5229\u7EF4\u4E9A\u56FD",
      "BA": "\u6CE2\u65AF\u5C3C\u4E9A\u548C\u9ED1\u585E\u54E5\u7EF4\u90A3",
      "BW": "\u535A\u8328\u74E6\u7EB3",
      "BV": "\u5E03\u7EF4\u5C9B",
      "BR": "\u5DF4\u897F",
      "BQ": "\u535A\u5185\u5C14\u5C9B\u3001\u5723\u5965\u4F9D\u65AF\u5766\u56FE\u65AF\u548C\u8428\u5DF4\u5C9B",
      "IO": "\u82F1\u5C5E\u5370\u5EA6\u6D0B\u9886\u5730",
      "VG": "\u7EF4\u5C14\u4EAC\u7FA4\u5C9B\uFF08\u82F1\u5C5E\uFF09",
      "BN": "\u6587\u83B1\u8FBE\u9C81\u8428\u5170\u56FD",
      "BG": "\u4FDD\u52A0\u5229\u4E9A",
      "BF": "\u5E03\u57FA\u7EB3\u6CD5\u7D22",
      "BI": "\u5E03\u9686\u8FEA",
      "KH": "\u67EC\u57D4\u5BE8",
      "CM": "\u5580\u9EA6\u9686",
      "CA": "\u52A0\u62FF\u5927",
      "IC": "\u52A0\u90A3\u5229\u7FA4\u5C9B",
      "CT": "\u574E\u987F\u548C\u6069\u5FB7\u4F2F\u91CC\u7FA4\u5C9B",
      "CV": "\u4F5B\u5F97\u89D2",
      "KY": "\u5F00\u66FC\u7FA4\u5C9B",
      "CF": "\u4E2D\u975E\u5171\u548C\u56FD",
      "EA": "\u4F11\u8FBE\u548C\u6885\u5229\u4E9A",
      "TD": "\u4E4D\u5F97",
      "CL": "\u667A\u5229",
      "CN": "\u4E2D\u56FD",
      "CN-ML": "\u4E2D\u56FD\u5927\u9646",
      "CX": "\u5723\u8BDE\u5C9B",
      "CP": "\u514B\u5229\u4F2F\u987F\u5C9B",
      "CC": "\u79D1\u79D1\u65AF\uFF08\u57FA\u6797\uFF09\u7FA4\u5C9B",
      "CO": "\u54E5\u4F26\u6BD4\u4E9A",
      "KM": "\u79D1\u6469\u7F57",
      "CD": "\u521A\u679C\u6C11\u4E3B\u5171\u548C\u56FD",
      "CK": "\u5E93\u514B\u7FA4\u5C9B",
      "CR": "\u54E5\u65AF\u8FBE\u9ECE\u52A0",
      "CI": "\u8C61\u7259\u6D77\u5CB8",
      "HR": "\u514B\u7F57\u5730\u4E9A",
      "CU": "\u53E4\u5DF4",
      "CW": "\u5E93\u62C9\u7D22\u5C9B",
      "CY": "\u585E\u6D66\u8DEF\u65AF",
      "CZ": "\u6377\u514B",
      "DK": "\u4E39\u9EA6",
      "DG": "\u8FED\u6208\u52A0\u897F\u4E9A\u5C9B",
      "DJ": "\u5409\u5E03\u63D0",
      "DM": "\u591A\u7C73\u5C3C\u514B",
      "DO": "\u591A\u7C73\u5C3C\u52A0\u5171\u548C\u56FD",
      "NQ": "\u6BDB\u5FB7\u7687\u540E\u5730",
      "EC": "\u5384\u74DC\u591A\u5C14",
      "EG": "\u57C3\u53CA",
      "SV": "\u8428\u5C14\u74E6\u591A",
      "GQ": "\u8D64\u9053\u51E0\u5185\u4E9A",
      "ER": "\u5384\u7ACB\u7279\u5C3C\u4E9A",
      "EE": "\u7231\u6C99\u5C3C\u4E9A",
      "ET": "\u57C3\u585E\u4FC4\u6BD4\u4E9A",
      "EU": "\u6B27\u76DF",
      "FK": "\u798F\u514B\u5170\u7FA4\u5C9B\uFF08\u9A6C\u5C14\u7EF4\u7EB3\u65AF\u7FA4\u5C9B\uFF09",
      "FO": "\u6CD5\u7F57\u7FA4\u5C9B",
      "FJ": "\u6590\u6D4E",
      "FI": "\u82AC\u5170",
      "FR": "\u6CD5\u56FD",
      "GF": "\u6CD5\u5C5E\u572D\u4E9A\u90A3",
      "PF": "\u6CD5\u5C5E\u6CE2\u5229\u5C3C\u897F\u4E9A",
      "TF": "\u6CD5\u5C5E\u5357\u534A\u7403\u9886\u5730",
      "FQ": "\u6CD5\u5C5E\u5357\u65B9\u548C\u5357\u6781\u9886\u5730",
      "GA": "\u52A0\u84EC",
      "GM": "\u5188\u6BD4\u4E9A",
      "GE": "\u683C\u9C81\u5409\u4E9A",
      "DE": "\u5FB7\u56FD",
      "GH": "\u52A0\u7EB3",
      "GI": "\u76F4\u5E03\u7F57\u9640",
      "GR": "\u5E0C\u814A",
      "GL": "\u683C\u6797\u5170\u5C9B",
      "GD": "\u683C\u6797\u7EB3\u8FBE",
      "GP": "\u74DC\u5FB7\u7F57\u666E\u5C9B",
      "GU": "\u5173\u5C9B",
      "GT": "\u5371\u5730\u9A6C\u62C9",
      "GG": "\u6839\u897F\u5C9B",
      "GN": "\u51E0\u5185\u4E9A",
      "GW": "\u51E0\u5185\u4E9A\u6BD4\u7ECD",
      "GY": "\u572D\u4E9A\u90A3",
      "HT": "\u6D77\u5730",
      "HM": "\u8D6B\u5FB7\u5C9B\u548C\u9EA6\u514B\u5510\u7EB3\u7FA4\u5C9B",
      "HN": "\u6D2A\u90FD\u62C9\u65AF",
      "HK": "\u9999\u6E2F\u7279\u522B\u884C\u653F\u533A",
      "HU": "\u5308\u7259\u5229",
      "IS": "\u51B0\u5C9B",
      "IN": "\u5370\u5EA6",
      "ID": "\u5370\u5EA6\u5C3C\u897F\u4E9A",
      "IR": "\u4F0A\u6717\u4F0A\u65AF\u5170\u5171\u548C\u56FD",
      "IE": "\u7231\u5C14\u5170",
      "IM": "\u82F1\u56FD\u5C5E\u5730\u66FC\u5C9B",
      "IL": "\u4EE5\u8272\u5217",
      "IQ": "\u4F0A\u62C9\u514B",
      "IT": "\u610F\u5927\u5229",
      "JM": "\u7259\u4E70\u52A0",
      "JP": "\u65E5\u672C",
      "JE": "\u6CFD\u897F\u5C9B",
      "JT": "\u7EA6\u7FF0\u65AF\u987F\u5C9B",
      "JO": "\u7EA6\u65E6",
      "KZ": "\u54C8\u8428\u514B\u65AF\u5766",
      "KE": "\u80AF\u5C3C\u4E9A",
      "KI": "\u57FA\u91CC\u5DF4\u65AF",
      "KP": "\u671D\u9C9C\u6C11\u4E3B\u4E3B\u4E49\u4EBA\u6C11\u5171\u548C\u56FD",
      "KR": "\u97E9\u56FD",
      "XK": "\u79D1\u7D22\u6C83",
      "KW": "\u79D1\u5A01\u7279",
      "KG": "\u5409\u5C14\u5409\u65AF\u65AF\u5766",
      "LA": "\u8001\u631D\u4EBA\u6C11\u6C11\u4E3B\u5171\u548C\u56FD",
      "LV": "\u62C9\u8131\u7EF4\u4E9A",
      "LB": "\u9ECE\u5DF4\u5AE9",
      "LS": "\u83B1\u7D22\u6258",
      "LR": "\u5229\u6BD4\u91CC\u4E9A",
      "LY": "\u5229\u6BD4\u4E9A",
      "LI": "\u5217\u652F\u6566\u58EB\u767B",
      "LT": "\u7ACB\u9676\u5B9B",
      "LU": "\u5362\u68EE\u5821",
      "MO": "\u6FB3\u95E8\u7279\u522B\u884C\u653F\u533A",
      "MK": "\u5317\u9A6C\u5176\u987F",
      "MG": "\u9A6C\u8FBE\u52A0\u65AF\u52A0",
      "MW": "\u9A6C\u62C9\u7EF4",
      "MY": "\u9A6C\u6765\u897F\u4E9A",
      "MV": "\u9A6C\u5C14\u4EE3\u592B",
      "ML": "\u9A6C\u91CC",
      "MT": "\u9A6C\u8033\u4ED6",
      "MH": "\u9A6C\u7ECD\u5C14\u7FA4\u5C9B",
      "MQ": "\u9A6C\u63D0\u5C3C\u514B",
      "MR": "\u6BDB\u91CC\u5854\u5C3C\u4E9A",
      "MU": "\u6BDB\u91CC\u6C42\u65AF",
      "YT": "\u9A6C\u7EA6\u7279\u5C9B",
      "FX": "\u6CD5\u56FD\u5927\u90FD\u4F1A",
      "MX": "\u58A8\u897F\u54E5",
      "FM": "\u5BC6\u514B\u7F57\u5C3C\u897F\u4E9A\u8054\u90A6",
      "MI": "\u4E2D\u9014\u5C9B",
      "MD": "\u6469\u5C14\u591A\u74E6\u5171\u548C\u56FD",
      "MC": "\u6469\u7EB3\u54E5",
      "MN": "\u8499\u53E4",
      "ME": "\u9ED1\u5C71\u5171\u548C\u56FD",
      "MS": "\u8499\u7279\u585E\u62C9\u7279\u5C9B",
      "MA": "\u6469\u6D1B\u54E5",
      "MZ": "\u83AB\u6851\u6BD4\u514B",
      "MM": "\u7F05\u7538",
      "NA": "\u7EB3\u7C73\u6BD4\u4E9A",
      "NR": "\u7459\u9C81",
      "NP": "\u5C3C\u6CCA\u5C14",
      "NL": "\u8377\u5170",
      "AN": "\u8377\u5C5E\u5B89\u7684\u5217\u65AF",
      "NT": "\u4E2D\u7ACB\u533A",
      "NC": "\u65B0\u5580\u91CC\u591A\u5C3C\u4E9A",
      "NZ": "\u65B0\u897F\u5170",
      "NI": "\u5C3C\u52A0\u62C9\u74DC",
      "NE": "\u5C3C\u65E5\u5C14",
      "NG": "\u5C3C\u65E5\u5229\u4E9A",
      "NU": "\u7EBD\u57C3",
      "NF": "\u8BFA\u798F\u514B\u5C9B",
      "VD": "\u8D8A\u5357\u6C11\u4E3B\u5171\u548C\u56FD",
      "MP": "\u5317\u9A6C\u91CC\u4E9A\u7EB3\u7FA4\u5C9B",
      "NO": "\u632A\u5A01",
      "OM": "\u963F\u66FC",
      "OM_mobile": "\u963F\u66FC\u79FB\u52A8\u901A\u4FE1\u516C\u53F8",
      "QO": "\u8FB9\u8FDC\u5927\u6D0B\u6D32",
      "PC": "\u592A\u5E73\u6D0B\u5C9B\u5C7F\u6258\u7BA1\u5730",
      "PK": "\u5DF4\u57FA\u65AF\u5766",
      "PW": "\u5E15\u52B3",
      "PS": "\u5DF4\u52D2\u65AF\u5766",
      "PA": "\u5DF4\u62FF\u9A6C",
      "PZ": "\u5DF4\u62FF\u9A6C\u8FD0\u6CB3\u533A",
      "PY": "\u5DF4\u62C9\u572D",
      "YD": "\u4E5F\u95E8\u4EBA\u6C11\u6C11\u4E3B\u5171\u548C\u56FD",
      "PE": "\u79D8\u9C81",
      "PH": "\u83F2\u5F8B\u5BBE",
      "PN": "\u76AE\u7279\u51EF\u6069\u7FA4\u5C9B",
      "PL": "\u6CE2\u5170",
      "PT": "\u8461\u8404\u7259",
      "PR": "\u6CE2\u591A\u9ECE\u5404",
      "QA": "\u5361\u5854\u5C14",
      "RE": "\u7559\u5C3C\u65FA\u5C9B",
      "RO": "\u7F57\u9A6C\u5C3C\u4E9A",
      "RU": "\u4FC4\u7F57\u65AF\u8054\u90A6",
      "RW": "\u5362\u65FA\u8FBE",
      "BL": "\u5723\u5DF4\u6258\u6D1B\u7F2A\u5C9B",
      "SH": "\u5723\u8D6B\u52D2\u62FF\u3001\u963F\u68EE\u677E\u548C\u7279\u91CC\u65AF\u5766-\u8FBE\u5E93\u5C3C\u4E9A",
      "KN": "\u5723\u57FA\u8328\u548C\u5C3C\u7EF4\u65AF",
      "LC": "\u5723\u5362\u897F\u4E9A\u5C9B",
      "MF": "\u5723\u9A6C\u4E01\uFF08\u6CD5\u5C5E\uFF09",
      "PM": "\u5723\u76AE\u57C3\u5C14\u53CA\u5BC6\u514B\u9686\u5C9B",
      "VC": "\u5723\u6587\u68EE\u7279\u548C\u683C\u6797\u7EB3\u4E01\u65AF",
      "WS": "\u8428\u6469\u4E9A",
      "SM": "\u5723\u9A6C\u529B\u8BFA",
      "ST": "\u5723\u591A\u7F8E\u548C\u666E\u6797\u897F\u6BD4",
      "SA": "\u6C99\u7279\u963F\u62C9\u4F2F",
      "SN": "\u585E\u5185\u52A0\u5C14",
      "RS": "\u585E\u5C14\u7EF4\u4E9A",
      "CS": "\u585E\u5C14\u7EF4\u4E9A\u548C\u9ED1\u5C71",
      "SC": "\u585E\u820C\u5C14",
      "SL": "\u585E\u62C9\u5229\u6602",
      "SG": "\u65B0\u52A0\u5761",
      "SX": "\u5723\u9A6C\u4E01\uFF08\u8377\u5C5E\uFF09",
      "SK": "\u65AF\u6D1B\u4F10\u514B",
      "SI": "\u65AF\u6D1B\u6587\u5C3C\u4E9A",
      "SB": "\u6240\u7F57\u95E8\u7FA4\u5C9B",
      "SO": "\u7D22\u9A6C\u91CC",
      "ZA": "\u5357\u975E",
      "GS": "\u5357\u4E54\u6CBB\u4E9A\u5C9B\u548C\u5357\u6851\u5A01\u5947\u7FA4\u5C9B",
      "ES": "\u897F\u73ED\u7259",
      "LK": "\u65AF\u91CC\u5170\u5361",
      "SR": "\u82CF\u91CC\u5357",
      "SJ": "\u65AF\u74E6\u5C14\u5DF4\u548C\u626C\u9A6C\u5EF6",
      "SZ": "\u53F2\u74E6\u5E1D\u5C3C",
      "SE": "\u745E\u5178",
      "CH": "\u745E\u58EB",
      "SY": "\u963F\u62C9\u4F2F\u53D9\u5229\u4E9A\u5171\u548C\u56FD",
      "TW": "\u4E2D\u56FD\u53F0\u6E7E",
      "TW_mobile": "\u53F0\u6E7E\u79FB\u52A8",
      "TJ": "\u5854\u5409\u514B\u65AF\u5766",
      "TZ": "\u5766\u6851\u5C3C\u4E9A\u8054\u5408\u5171\u548C\u56FD",
      "TH": "\u6CF0\u56FD",
      "TL": "\u4E1C\u5E1D\u6C76",
      "TG": "\u591A\u54E5",
      "TK": "\u6258\u514B\u52B3",
      "TO": "\u6C64\u52A0",
      "TT": "\u7279\u7ACB\u5C3C\u8FBE\u548C\u591A\u5DF4\u54E5",
      "TA": "\u7279\u91CC\u65AF\u5766\u8FBE\u5E93\u5C3C\u4E9A\u7FA4\u5C9B",
      "TN": "\u7A81\u5C3C\u65AF",
      "TR": "\u571F\u8033\u5176",
      "TM": "\u571F\u5E93\u66FC\u65AF\u5766",
      "TC": "\u7279\u514B\u65AF\u548C\u51EF\u79D1\u65AF\u7FA4\u5C9B",
      "TV": "\u56FE\u74E6\u5362",
      "UM": "\u7F8E\u56FD\u672C\u571F\u5916\u5C0F\u5C9B\u5C7F",
      "PU": "\u7F8E\u5C5E\u592A\u5E73\u6D0B\u7FA4\u5C9B",
      "VI": "\u7EF4\u5C14\u4EAC\u7FA4\u5C9B\uFF08\u7F8E\u5C5E\uFF09",
      "UG": "\u4E4C\u5E72\u8FBE",
      "UA": "\u4E4C\u514B\u5170",
      "AE": "\u963F\u62C9\u4F2F\u8054\u5408\u914B\u957F\u56FD",
      "GB": "\u82F1\u56FD",
      "US": "\u7F8E\u56FD",
      "UY": "\u4E4C\u62C9\u572D",
      "UZ": "\u4E4C\u5179\u522B\u514B\u65AF\u5766",
      "VU": "\u74E6\u52AA\u963F\u56FE",
      "VA": "\u68B5\u8482\u5188",
      "VE": "\u59D4\u5185\u745E\u62C9\u73BB\u5229\u74E6\u5C14\u5171\u548C\u56FD",
      "VN": "\u8D8A\u5357",
      "WK": "\u590D\u6D3B\u5C9B",
      "WF": "\u74E6\u5229\u7FA4\u5C9B\u548C\u5BCC\u56FE\u7EB3\u7FA4\u5C9B",
      "EH": "\u897F\u6492\u54C8\u62C9",
      "YE": "\u4E5F\u95E8",
      "ZM": "\u8D5E\u6BD4\u4E9A",
      "SD": "\u82CF\u4E39",
      "SS": "\u5357\u82CF\u4E39",
      "ZW": "\u6D25\u5DF4\u5E03\u97E6",
      "TW-TW": "\u53F0\u6E7E",
      "language.display": "{0} ({1})",
      "en-US": "USA",
      "en-GB": "UK",
      "zh-CN": "\u4E2D\u56FD",
      "es-ES": "\u897F\u73ED\u7259",
      "fr-FR": "\u6CD5\u56FD",
      "jp-JP": "\u65E5\u672C",
      "de-DE": "\u5FB7\u56FD",
      "pt-PT": "\u8461\u8404\u7259\u8BED",
      "ru-RU": "\u4FC4\u8BED",
      "PG": "\u5DF4\u5E03\u4E9A\u65B0\u51E0\u5185\u4E9A",
      "CG": "\u521A\u679C"
    }
  },
  "zh-TW": {
    "country": {
      "AF": "\u963F\u5BCC\u6C57",
      "AX": "\u5967\u862D\u7FA4\u5CF6",
      "AL": "\u963F\u723E\u5DF4\u5C3C\u4E9E",
      "DZ": "\u963F\u723E\u53CA\u5229\u4E9E",
      "AS": "\u7F8E\u5C6C\u85A9\u6469\u4E9E",
      "AD": "\u5B89\u9053\u723E",
      "AO": "\u5B89\u54E5\u62C9",
      "AI": "\u82F1\u5C6C\u5B89\u5409\u62C9",
      "AQ": "\u5357\u6975\u6D32",
      "AG": "\u5B89\u63D0\u74DC\u53CA\u5DF4\u5E03\u9054",
      "AR": "\u963F\u6839\u5EF7",
      "AM": "\u4E9E\u7F8E\u5C3C\u4E9E",
      "AW": "\u963F\u9B6F\u5DF4",
      "AC": "\u4E9E\u68EE\u6B23\u5CF6",
      "AU": "\u6FB3\u5927\u5229\u4E9E",
      "AT": "\u5967\u5730\u5229",
      "AZ": "\u4E9E\u585E\u62DC\u7136",
      "BS": "\u5DF4\u54C8\u99AC",
      "BH": "\u5DF4\u6797",
      "BD": "\u5B5F\u52A0\u62C9",
      "BB": "\u5DF4\u8C9D\u591A",
      "BY": "\u767D\u4FC4\u7F85\u65AF",
      "BE": "\u6BD4\u5229\u6642",
      "BZ": "\u8C9D\u91CC\u65AF",
      "BJ": "\u8C9D\u5357",
      "BM": "\u767E\u6155\u9054",
      "BT": "\u4E0D\u4E39",
      "BO": "\u73BB\u5229\u7DAD\u4E9E",
      "BA": "\u6CE2\u65AF\u5C3C\u4E9E\u53CA\u9ED1\u585E\u54E5\u7DAD\u90A3",
      "BW": "\u6CE2\u672D\u90A3",
      "BV": "\u6CE2\u7DAD\u7279\u5CF6",
      "BR": "\u5DF4\u897F",
      "BQ": "\u6CE2\u5948\u3001\u8056\u4F51\u9054\u4FEE\u65AF\u548C\u6C99\u5DF4",
      "IO": "\u82F1\u5C6C\u5370\u5EA6\u6D0B\u5730\u5340",
      "VG": "\u82F1\u5C6C\u7DAD\u4EAC\u7FA4\u5CF6",
      "BN": "\u6C76\u840A",
      "BG": "\u4FDD\u52A0\u5229\u4E9E",
      "BF": "\u5E03\u5409\u7D0D\u6CD5\u7D22",
      "BI": "\u84B2\u9686\u5730",
      "KH": "\u67EC\u57D4\u5BE8",
      "CM": "\u5580\u9EA5\u9686",
      "CA": "\u52A0\u62FF\u5927",
      "IC": "\u52A0\u7D0D\u5229\u7FA4\u5CF6",
      "CT": "\u582A\u6771\u8207\u5B89\u5FB7\u67CF\u91CC\u5CF6",
      "CV": "\u7DAD\u5FB7\u89D2",
      "KY": "\u958B\u66FC\u7FA4\u5CF6",
      "CF": "\u4E2D\u975E\u5171\u548C\u570B",
      "EA": "\u4F11\u9054\u548C\u6885\u5229\u5229\u4E9E",
      "TD": "\u67E5\u5FB7",
      "CL": "\u667A\u5229",
      "CN": "\u4E2D\u570B",
      "CN-ML": "\u4E2D\u570B\u5927\u9678",
      "CX": "\u8056\u8A95\u5CF6",
      "CP": "\u514B\u5229\u73C0\u9813\u5CF6",
      "CC": "\u53EF\u53EF\u65AF\u7FA4\u5CF6",
      "CO": "\u54E5\u502B\u6BD4\u4E9E",
      "KM": "\u79D1\u6469\u7F85",
      "CD": "\u525B\u679C\u6C11\u4E3B\u5171\u548C\u570B",
      "CK": "\u5EAB\u514B\u7FA4\u5CF6",
      "CR": "\u54E5\u65AF\u5927\u9ECE\u52A0",
      "CI": "\u79D1\u7279\u8FEA\u74E6",
      "HR": "\u514B\u7F85\u57C3\u897F\u4E9E",
      "CU": "\u53E4\u5DF4",
      "CW": "\u53E4\u62C9\u679C",
      "CY": "\u8CFD\u666E\u8DEF\u65AF",
      "CZ": "\u6377\u514B",
      "DK": "\u4E39\u9EA5",
      "DG": "\u8FEA\u4E9E\u54E5\u52A0\u897F\u4E9E\u5CF6",
      "DJ": "\u5409\u5E03\u5730",
      "DM": "\u591A\u7C73\u5C3C\u514B",
      "DO": "\u591A\u7C73\u5C3C\u52A0\u5171\u548C\u570B",
      "NQ": "\u6BDB\u5FB7\u7687\u540E\u5730",
      "EC": "\u5384\u74DC\u591A",
      "EG": "\u57C3\u53CA",
      "SV": "\u85A9\u723E\u74E6\u591A",
      "GQ": "\u8D64\u9053\u5E7E\u5167\u4E9E",
      "ER": "\u5384\u7ACB\u7279\u91CC\u4E9E",
      "EE": "\u611B\u6C99\u5C3C\u4E9E",
      "ET": "\u8863\u7D22\u6BD4\u4E9E",
      "EU": "\u6B50\u6D32\u806F\u76DF",
      "FK": "\u798F\u514B\u862D\u7FA4\u5CF6\uFF08\u99AC\u723E\u7DAD\u7D0D\u65AF\u7FA4\u5CF6\uFF09",
      "FO": "\u6CD5\u7F85\u7FA4\u5CF6",
      "FJ": "\u6590\u6FDF",
      "FI": "\u82AC\u862D",
      "FR": "\u6CD5\u570B",
      "GF": "\u6CD5\u5C6C\u572D\u4E9E\u90A3",
      "PF": "\u6CD5\u5C6C\u73BB\u91CC\u5C3C\u897F\u4E9E",
      "TF": "\u6CD5\u5C6C\u5357\u90E8\u5C6C\u5730",
      "FQ": "\u6CD5\u5C6C\u5357\u90E8\u548C\u5357\u6975\u9818\u5730",
      "GA": "\u52A0\u5F6D",
      "GM": "\u7518\u6BD4\u4E9E",
      "GE": "\u55AC\u6CBB\u4E9E",
      "DE": "\u5FB7\u570B",
      "GH": "\u8FE6\u7D0D",
      "GI": "\u76F4\u5E03\u7F85\u9640",
      "GR": "\u5E0C\u81D8",
      "GL": "\u683C\u9675\u862D",
      "GD": "\u683C\u745E\u7D0D\u9054",
      "GP": "\u74DC\u5730\u6D1B\u666E",
      "GU": "\u95DC\u5CF6",
      "GT": "\u74DC\u5730\u99AC\u62C9",
      "GG": "\u6839\u606F\u5CF6",
      "GN": "\u5E7E\u5167\u4E9E",
      "GW": "\u5E7E\u5167\u4E9E\u6BD4\u7D22",
      "GY": "\u572D\u4E9E\u90A3",
      "HT": "\u6D77\u5730",
      "HM": "\u8D6B\u5FB7\u5CF6\u53CA\u9EA5\u7576\u52DE\u5CF6",
      "HN": "\u5B8F\u90FD\u62C9\u65AF",
      "HK": "\u9999\u6E2F\u7279\u5225\u884C\u653F\u5340",
      "HU": "\u5308\u7259\u5229",
      "IS": "\u51B0\u5CF6",
      "IN": "\u5370\u5EA6",
      "ID": "\u5370\u5C3C",
      "IR": "\u4F0A\u6717\u4F0A\u65AF\u862D\u5171\u548C\u570B",
      "IE": "\u611B\u723E\u862D",
      "IM": "\u82F1\u5C6C\u66FC\u5CF6",
      "IL": "\u4EE5\u8272\u5217",
      "IQ": "\u4F0A\u62C9",
      "IT": "\u7FA9\u5927\u5229",
      "JM": "\u7259\u8CB7\u52A0",
      "JP": "\u65E5\u672C",
      "JE": "\u6FA4\u897F\u5CF6",
      "JT": "\u6FA4\u897F\u5CF6",
      "JO": "\u7D04\u65E6",
      "KZ": "\u54C8\u85A9\u514B\u65AF\u5766",
      "KE": "\u80AF\u4E9E",
      "KI": "\u5409\u91CC\u5DF4\u65AF",
      "KP": "\u671D\u9BAE\u6C11\u4E3B\u4E3B\u7FA9\u4EBA\u6C11\u5171\u548C\u570B",
      "KR": "\u5927\u97D3\u6C11\u570B",
      "XK": "\u79D1\u7D22\u6C83",
      "KW": "\u79D1\u5A01\u7279",
      "KG": "\u5409\u723E\u5409\u65AF\u65AF\u5766",
      "LA": "\u5BEE\u4EBA\u6C11\u6C11\u4E3B\u5171\u548C\u570B",
      "LV": "\u62C9\u812B\u7DAD\u4E9E",
      "LB": "\u9ECE\u5DF4\u5AE9",
      "LS": "\u8CF4\u7D22\u6258",
      "LR": "\u8CF4\u6BD4\u745E\u4E9E",
      "LY": "\u5229\u6BD4\u4E9E",
      "LI": "\u5217\u652F\u6566\u65AF\u767B",
      "LT": "\u7ACB\u9676\u5B9B",
      "LU": "\u76E7\u68EE\u5821",
      "MO": "\u6FB3\u9580\u7279\u5225\u884C\u653F\u5340",
      "MK": "\u5317\u99AC\u5176\u9813",
      "MG": "\u99AC\u9054\u52A0\u65AF\u52A0",
      "MW": "\u99AC\u62C9\u7DAD",
      "MY": "\u99AC\u4F86\u897F\u4E9E",
      "MV": "\u99AC\u723E\u5730\u592B",
      "ML": "\u99AC\u5229",
      "MT": "\u99AC\u723E\u4ED6",
      "MH": "\u99AC\u7D39\u723E\u7FA4\u5CF6",
      "MQ": "\u6CD5\u5C6C\u99AC\u4E01\u5C3C\u514B",
      "MR": "\u8305\u5229\u5854\u5C3C\u4E9E",
      "MU": "\u6A21\u91CC\u897F\u65AF",
      "YT": "\u99AC\u7D04\u7279",
      "FX": "\u6CD5\u5C6C\u7F8E\u7279\u7F85\u6CE2\u5229\u5766",
      "MX": "\u58A8\u897F\u54E5",
      "FM": "\u5BC6\u514B\u7F85\u5C3C\u897F\u4E9E\u806F\u90A6",
      "MI": "\u4E2D\u9014\u5CF6",
      "MD": "\u6469\u723E\u591A\u74E6\u5171\u548C\u570B",
      "MC": "\u6469\u7D0D\u54E5",
      "MN": "\u8499\u53E4",
      "ME": "\u8499\u7279\u5167\u54E5\u7F85",
      "MS": "\u8499\u54F2\u81D8",
      "MA": "\u6469\u6D1B\u54E5",
      "MZ": "\u83AB\u4E09\u6BD4\u514B",
      "MM": "\u7DEC\u7538",
      "NA": "\u7D0D\u7C73\u6BD4\u4E9E",
      "NR": "\u8AFE\u9B6F",
      "NP": "\u5C3C\u6CCA\u723E",
      "NL": "\u8377\u862D",
      "AN": "\u8377\u5C6C\u5B89\u5730\u5217\u65AF",
      "NT": "\u4E2D\u7ACB\u5340",
      "NC": "\u65B0\u5580\u91CC\u591A\u5C3C\u4E9E",
      "NZ": "\u7D10\u897F\u862D",
      "NI": "\u5C3C\u52A0\u62C9\u74DC",
      "NE": "\u5C3C\u65E5",
      "NG": "\u5948\u53CA\u5229\u4E9E",
      "NU": "\u7D10\u57C3",
      "NF": "\u8AFE\u798F\u514B\u5CF6",
      "VD": "\u8D8A\u5357\u5317\u90E8",
      "MP": "\u5317\u99AC\u91CC\u4E9E\u7D0D\u7FA4\u5CF6",
      "NO": "\u632A\u5A01",
      "OM": "\u963F\u66FC",
      "OM_mobile": "\u5DF4\u57FA\u65AF\u5766",
      "QO": "\u96E2\u5CF6\u5927\u6D0B\u6D32",
      "PC": "\u592A\u5E73\u6D0B\u7FA4\u5CF6\u8A17\u7BA1\u5730",
      "PK": "\u5DF4\u57FA\u65AF\u5766",
      "PW": "\u5E1B\u7409",
      "PS": "\u5DF4\u52D2\u65AF\u5766\u570B",
      "PA": "\u5DF4\u62FF\u99AC",
      "PZ": "\u5DF4\u5E03\u4E9E\u7D10\u5E7E\u5167\u4E9E",
      "PY": "\u5DF4\u62C9\u572D",
      "YD": "\u8449\u9580\u4EBA\u6C11\u6C11\u4E3B\u5171\u548C\u570B",
      "PE": "\u79D8\u9B6F",
      "PH": "\u83F2\u5F8B\u8CD3",
      "PN": "\u76AE\u7279\u80AF",
      "PL": "\u6CE2\u862D",
      "PT": "\u8461\u8404\u7259",
      "PR": "\u6CE2\u591A\u9ECE\u5404",
      "QA": "\u5361\u9054",
      "RE": "\u7559\u5C3C\u65FA",
      "RO": "\u7F85\u99AC\u5C3C\u4E9E",
      "RU": "\u4FC4\u7F85\u65AF\u806F\u90A6",
      "RW": "\u76E7\u5B89\u9054",
      "BL": "\u8056\u5DF4\u745F\u7C73",
      "SH": "\u8056\u8D6B\u52D2\u62FF\u3001\u4E9E\u68EE\u6B23\u3001\u7279\u91CC\u65AF\u5766\u9054\u5EAB\u5C3C\u4E9E\u7FA4\u5CF6",
      "KN": "\u8056\u57FA\u8328\u53CA\u5C3C\u7DAD\u65AF",
      "LC": "\u8056\u9732\u897F\u4E9E",
      "MF": "\u6CD5\u5C6C\u8056\u99AC\u4E01",
      "PM": "\u8056\u76AE\u57C3\u53CA\u5BC6\u514B\u9686\u7FA4\u5CF6",
      "VC": "\u8056\u6587\u68EE\u53CA\u683C\u745E\u7D0D\u4E01\u65AF",
      "WS": "\u85A9\u6469\u4E9E",
      "SM": "\u8056\u99AC\u5229\u8AFE",
      "ST": "\u8056\u591A\u7F8E\u53CA\u666E\u6797\u897F\u6BD4",
      "SA": "\u6C99\u70CF\u5730\u963F\u62C9\u4F2F",
      "SN": "\u585E\u5167\u52A0\u723E",
      "RS": "\u585E\u723E\u7DAD\u4E9E",
      "CS": "\u585E\u723E\u7DAD\u4E9E\u8207\u8499\u7279\u5167\u54E5\u7F85",
      "SC": "\u585E\u5E2D\u723E",
      "SL": "\u7345\u5B50\u5C71",
      "SG": "\u65B0\u52A0\u5761",
      "SX": "\u8377\u5C6C\u8056\u99AC\u4E01",
      "SK": "\u65AF\u6D1B\u4F10\u514B",
      "SI": "\u65AF\u6D1B\u7DAD\u5C3C\u4E9E",
      "SB": "\u7D22\u7F85\u9580\u7FA4\u5CF6",
      "SO": "\u7D22\u746A\u5229\u4E9E",
      "ZA": "\u5357\u975E",
      "GS": "\u5357\u55AC\u6CBB\u4E9E\u5CF6\u53CA\u5357\u4E09\u660E\u6CBB\u7FA4\u5CF6",
      "ES": "\u897F\u73ED\u7259",
      "LK": "\u65AF\u91CC\u862D\u5361",
      "SR": "\u8607\u5229\u5357",
      "SJ": "\u65AF\u74E6\u723E\u5DF4\u53CA\u63DA\u99AC\u5EF6",
      "SZ": "\u53F2\u74E6\u5E1D\u5C3C",
      "SE": "\u745E\u5178",
      "CH": "\u745E\u58EB",
      "SY": "\u963F\u62C9\u4F2F\u6558\u5229\u4E9E\u5171\u548C\u570B",
      "TW": "\u4E2D\u570B\u53F0\u7063",
      "TW_mobile": "\u53F0\u7063\u5927\u54E5\u5927",
      "TJ": "\u5854\u5409\u514B\u65AF\u5766",
      "TZ": "\u5766\u5C1A\u5C3C\u4E9E\u806F\u5408\u5171\u548C\u570B",
      "TH": "\u6CF0\u570B",
      "TL": "\u6771\u5E1D\u6C76",
      "TG": "\u591A\u54E5",
      "TK": "\u6258\u514B\u52DE",
      "TO": "\u6771\u52A0",
      "TT": "\u7279\u7ACB\u5C3C\u9054\u53CA\u591A\u5DF4\u54E5",
      "TA": "\u5D14\u65AF\u5766\u9054\u5EAB\u5C3C\u4E9E",
      "TN": "\u7A81\u5C3C\u897F\u4E9E",
      "TR": "\u571F\u8033\u5176",
      "TM": "\u571F\u5EAB\u66FC\u65AF\u5766",
      "TC": "\u571F\u514B\u65AF\u53CA\u958B\u79D1\u65AF\u7FA4\u5CF6",
      "TV": "\u5410\u74E6\u9B6F",
      "UM": "\u7F8E\u570B\u672C\u571F\u5916\u5C0F\u5CF6\u5DBC",
      "PU": "\u7F8E\u5C6C\u592A\u5E73\u6D0B\u7FA4\u5CF6",
      "VI": "\u7F8E\u5C6C\u7DAD\u4EAC\u7FA4\u5CF6",
      "UG": "\u70CF\u5E72\u9054",
      "UA": "\u70CF\u514B\u862D",
      "AE": "\u963F\u62C9\u4F2F\u806F\u5408\u914B\u9577\u570B",
      "GB": "\u82F1\u570B",
      "US": "\u7F8E\u5229\u5805\u5408\u773E\u570B",
      "UY": "\u70CF\u62C9\u572D",
      "UZ": "\u70CF\u7386\u5225\u514B\u65AF\u5766",
      "VU": "\u842C\u90A3\u675C",
      "VA": "\u6559\u5EF7",
      "VE": "\u59D4\u5167\u745E\u62C9\u73BB\u5229\u74E6\u5171\u548C\u570B",
      "VN": "\u8D8A\u5357",
      "WK": "\u5A01\u514B\u5CF6",
      "WF": "\u74E6\u5229\u65AF\u7FA4\u5CF6\u53CA\u5BCC\u5716\u90A3\u7FA4\u5CF6",
      "EH": "\u897F\u6492\u54C8\u62C9",
      "YE": "\u8449\u9580",
      "ZM": "\u5C1A\u6BD4\u4E9E",
      "SD": "\u8607\u4E39",
      "SS": "\u5357\u8607\u4E39",
      "ZW": "\u8F9B\u5DF4\u5A01",
      "TW-TW": "\u53F0\u7063",
      "language.display": "{0}\uFF08{1}\uFF09",
      "en-US": "\u7F8E\u570B",
      "en-GB": "\u82F1\u570B",
      "zh-CN": "\u4E2D\u570B",
      "es-ES": "\u897F\u73ED\u7259",
      "fr-FR": "\u6CD5\u570B",
      "jp-JP": "\u65E5\u672C",
      "de-DE": "\u5FB7\u570B",
      "pt-PT": "\u8461\u8404\u7259\u8A9E",
      "ru-RU": "\u4FC4\u8A9E",
      "PG": "\u5DF4\u5E03\u4E9E\u7D10\u5E7E\u5167\u4E9E",
      "CG": "\u525B\u679C"
    }
  }
};

const defaultLocale = 'en-US';
const lang = i18n[locale] ? i18n[locale] : i18n[defaultLocale];
addLang(lang);

const countryMap = [
  {'id': 'AF', 'text': 'country.AF', 'code': '93', 'useType': 'both'},
  {'id': 'AX', 'text': 'country.AX', 'code': '358', 'useType': 'both'},
  {'id': 'AL', 'text': 'country.AL', 'code': '355', 'useType': 'both'},
  {'id': 'DZ', 'text': 'country.DZ', 'code': '213', 'useType': 'both'},
  {'id': 'AS', 'text': 'country.AS', 'code': '1', 'useType': 'both'},
  {'id': 'AD', 'text': 'country.AD', 'code': '376', 'useType': 'both'},
  {'id': 'AO', 'text': 'country.AO', 'code': '244', 'useType': 'both'},
  {'id': 'AI', 'text': 'country.AI', 'code': '1', 'useType': 'both'},
  {'id': 'AQ', 'text': 'country.AQ', 'code': '672', 'useType': 'both'},
  {'id': 'AG', 'text': 'country.AG', 'code': '1', 'useType': 'both'},
  {'id': 'AR', 'text': 'country.AR', 'code': '54', 'useType': 'both'},
  {'id': 'AM', 'text': 'country.AM', 'code': '374', 'useType': 'both'},
  {'id': 'AW', 'text': 'country.AW', 'code': '297', 'useType': 'both'},
  {'id': 'AC', 'text': 'country.AC', 'code': '247', 'useType': 'web'},
  {'id': 'AU', 'text': 'country.AU', 'code': '61', 'useType': 'both'},
  {'id': 'AT', 'text': 'country.AT', 'code': '43', 'useType': 'both'},
  {'id': 'AZ', 'text': 'country.AZ', 'code': '994', 'useType': 'both'},
  {'id': 'BS', 'text': 'country.BS', 'code': '1', 'useType': 'both'},
  {'id': 'BH', 'text': 'country.BH', 'code': '973', 'useType': 'both'},
  {'id': 'BD', 'text': 'country.BD', 'code': '880', 'useType': 'both'},
  {'id': 'BB', 'text': 'country.BB', 'code': '1', 'useType': 'both'},
  {'id': 'BY', 'text': 'country.BY', 'code': '375', 'useType': 'both'},
  {'id': 'BE', 'text': 'country.BE', 'code': '32', 'useType': 'both'},
  {'id': 'BZ', 'text': 'country.BZ', 'code': '501', 'useType': 'both'},
  {'id': 'BJ', 'text': 'country.BJ', 'code': '229', 'useType': 'both'},
  {'id': 'BM', 'text': 'country.BM', 'code': '1', 'useType': 'both'},
  {'id': 'BT', 'text': 'country.BT', 'code': '975', 'useType': 'both'},
  {'id': 'BO', 'text': 'country.BO', 'code': '591', 'useType': 'both'},
  {'id': 'BQ', 'text': 'country.BQ', 'code': '599', 'useType': 'both'},
  {'id': 'BA', 'text': 'country.BA', 'code': '387', 'useType': 'both'},
  {'id': 'BW', 'text': 'country.BW', 'code': '267', 'useType': 'both'},
  {'id': 'BV', 'text': 'country.BV', 'useType': 'both'},
  {'id': 'BR', 'text': 'country.BR', 'code': '55', 'useType': 'both'},
  {'id': 'IO', 'text': 'country.IO', 'useType': 'web'},
  {'id': 'VG', 'text': 'country.VG', 'code': '284', 'useType': 'web'},
  {'id': 'BN', 'text': 'country.BN', 'code': '673', 'useType': 'both'},
  {'id': 'BG', 'text': 'country.BG', 'code': '359', 'useType': 'both'},
  {'id': 'BF', 'text': 'country.BF', 'code': '226', 'useType': 'both'},
  {'id': 'BI', 'text': 'country.BI', 'code': '257', 'useType': 'both'},
  {'id': 'KH', 'text': 'country.KH', 'code': '855', 'useType': 'both'},
  {'id': 'CM', 'text': 'country.CM', 'code': '237', 'useType': 'both'},
  {'id': 'CA', 'text': 'country.CA', 'code': '1', 'useType': 'both'},
  {'id': 'IC', 'text': 'country.IC', 'useType': 'web'},
  {'id': 'CT', 'text': 'country.CT', 'useType': 'web'},
  {'id': 'CV', 'text': 'country.CV', 'code': '238', 'useType': 'both'},
  {'id': 'KY', 'text': 'country.KY', 'code': '1', 'useType': 'both'},
  {'id': 'CF', 'text': 'country.CF', 'code': '236', 'useType': 'both'},
  {'id': 'EA', 'text': 'country.EA', 'useType': 'web'},
  {'id': 'TD', 'text': 'country.TD', 'code': '235', 'useType': 'both'},
  {'id': 'CL', 'text': 'country.CL', 'code': '56', 'useType': 'both'},
  {'id': 'CN', 'text': 'country.CN', 'code': '86', 'useType': 'both'},
  {'id': 'CX', 'text': 'country.CX', 'code': '61', 'useType': 'both'},
  {'id': 'CP', 'text': 'country.CP', 'useType': 'web'},
  {'id': 'CC', 'text': 'country.CC', 'code': '61', 'useType': 'both'},
  {'id': 'CO', 'text': 'country.CO', 'code': '57', 'useType': 'both'},
  {'id': 'KM', 'text': 'country.KM', 'code': '269', 'useType': 'both'},
  {'id': 'CD', 'text': 'country.CD', 'code': '243', 'useType': 'both'},
  {'id': 'CK', 'text': 'country.CK', 'code': '682', 'useType': 'both'},
  {'id': 'CR', 'text': 'country.CR', 'code': '506', 'useType': 'both'},
  {'id': 'CI', 'text': 'country.CI', 'code': '225', 'useType': 'both'},
  {'id': 'HR', 'text': 'country.HR', 'code': '385', 'useType': 'both'},
  {'id': 'CU', 'text': 'country.CU', 'code': '53', 'useType': 'both'},
  {'id': 'CW', 'text': 'country.CW', 'code': '599', 'useType': 'both'},
  {'id': 'CY', 'text': 'country.CY', 'code': '357', 'useType': 'both'},
  {'id': 'CZ', 'text': 'country.CZ', 'code': '420', 'useType': 'both'},
  {'id': 'DK', 'text': 'country.DK', 'code': '45', 'useType': 'both'},
  {'id': 'DG', 'text': 'country.DG', 'code': '246', 'useType': 'web'},
  {'id': 'DJ', 'text': 'country.DJ', 'code': '253', 'useType': 'both'},
  {'id': 'NQ', 'text': 'country.NQ', 'useType': 'web'},
  {'id': 'TL', 'text': 'country.TL', 'code': '670', 'useType': 'both'},
  {'id': 'DM', 'text': 'country.DM', 'code': '1', 'useType': 'both'},
  {'id': 'DO', 'text': 'country.DO', 'code': '1', 'useType': 'both'},
  {'id': 'EC', 'text': 'country.EC', 'code': '593', 'useType': 'both'},
  {'id': 'EG', 'text': 'country.EG', 'code': '20', 'useType': 'both'},
  {'id': 'SV', 'text': 'country.SV', 'code': '503', 'useType': 'both'},
  {'id': 'GQ', 'text': 'country.GQ', 'code': '240', 'useType': 'both'},
  {'id': 'ER', 'text': 'country.ER', 'code': '291', 'useType': 'both'},
  {'id': 'EE', 'text': 'country.EE', 'code': '372', 'useType': 'both'},
  {'id': 'ET', 'text': 'country.ET', 'code': '251', 'useType': 'both'},
  {'id': 'EU', 'text': 'country.EU', 'useType': 'web'},
  {'id': 'FK', 'text': 'country.FK', 'code': '500', 'useType': 'both'},
  {'id': 'FO', 'text': 'country.FO', 'code': '298', 'useType': 'both'},
  {'id': 'FJ', 'text': 'country.FJ', 'code': '679', 'useType': 'both'},
  {'id': 'FI', 'text': 'country.FI', 'code': '358', 'useType': 'both'},
  {'id': 'FR', 'text': 'country.FR', 'code': '33', 'useType': 'both'},
  {'id': 'GF', 'text': 'country.GF', 'code': '594', 'useType': 'both'},
  {'id': 'PF', 'text': 'country.PF', 'code': '689', 'useType': 'both'},
  {'id': 'TF', 'text': 'country.TF', 'useType': 'both'},
  {'id': 'FQ', 'text': 'country.FQ', 'useType': 'web'},
  {'id': 'GA', 'text': 'country.GA', 'code': '241', 'useType': 'both'},
  {'id': 'GM', 'text': 'country.GM', 'code': '220', 'useType': 'both'},
  {'id': 'GE', 'text': 'country.GE', 'code': '995', 'useType': 'both'},
  {'id': 'DE', 'text': 'country.DE', 'code': '49', 'useType': 'both'},
  {'id': 'GH', 'text': 'country.GH', 'code': '233', 'useType': 'both'},
  {'id': 'GI', 'text': 'country.GI', 'code': '350', 'useType': 'both'},
  {'id': 'GR', 'text': 'country.GR', 'code': '30', 'useType': 'both'},
  {'id': 'GL', 'text': 'country.GL', 'code': '299', 'useType': 'both'},
  {'id': 'GD', 'text': 'country.GD', 'code': '1', 'useType': 'both'},
  {'id': 'GP', 'text': 'country.GP', 'code': '590', 'useType': 'both'},
  {'id': 'GU', 'text': 'country.GU', 'code': '1', 'useType': 'both'},
  {'id': 'GT', 'text': 'country.GT', 'code': '502', 'useType': 'both'},
  {'id': 'GG', 'text': 'country.GG', 'code': '44', 'useType': 'both'},
  {'id': 'GN', 'text': 'country.GN', 'code': '', 'useType': 'both'},
  {'id': 'GW', 'text': 'country.GW', 'code': '245', 'useType': 'both'},
  {'id': 'GY', 'text': 'country.GY', 'code': '592', 'useType': 'both'},
  {'id': 'HT', 'text': 'country.HT', 'code': '509', 'useType': 'both'},
  {'id': 'HM', 'text': 'country.HM', 'code': '', 'useType': 'both'},
  {'id': 'VA', 'text': 'country.VA', 'code': '379', 'useType': 'both'},
  {'id': 'HN', 'text': 'country.HN', 'code': '504', 'useType': 'both'},
  {'id': 'HK', 'text': 'country.HK', 'code': '852', 'useType': 'both'},
  {'id': 'HU', 'text': 'country.HU', 'code': '36', 'useType': 'both'},
  {'id': 'IS', 'text': 'country.IS', 'code': '354', 'useType': 'both'},
  {'id': 'IN', 'text': 'country.IN', 'code': '91', 'useType': 'both'},
  {'id': 'ID', 'text': 'country.ID', 'code': '62', 'useType': 'both'},
  {'id': 'IR', 'text': 'country.IR', 'code': '', 'useType': 'both'},
  {'id': 'IE', 'text': 'country.IE', 'code': '353', 'useType': 'both'},
  {'id': 'IM', 'text': 'country.IM', 'code': '44', 'useType': 'both'},
  {'id': 'IL', 'text': 'country.IL', 'code': '972', 'useType': 'both'},
  {'id': 'IQ', 'text': 'country.IQ', 'code': '964', 'useType': 'both'},
  {'id': 'IT', 'text': 'country.IT', 'code': '39', 'useType': 'both'},
  {'id': 'JM', 'text': 'country.JM', 'code': '1', 'useType': 'both'},
  {'id': 'JP', 'text': 'country.JP', 'code': '81', 'useType': 'both'},
  {'id': 'JE', 'text': 'country.JE', 'code': '44', 'useType': 'both'},
  {'id': 'JT', 'text': 'country.JT', 'code': '', 'useType': 'web'},
  {'id': 'JO', 'text': 'country.JO', 'code': '962', 'useType': 'both'},
  {'id': 'KZ', 'text': 'country.KZ', 'code': '7', 'useType': 'both'},
  {'id': 'KE', 'text': 'country.KE', 'code': '254', 'useType': 'both'},
  {'id': 'KI', 'text': 'country.KI', 'code': '686', 'useType': 'both'},
  {'id': 'KP', 'text': 'country.KP', 'code': '850', 'useType': 'both'},
  {'id': 'XK', 'text': 'country.XK', 'code': '', 'useType': 'zuora'},
  {'id': 'KW', 'text': 'country.KW', 'code': '965', 'useType': 'both'},
  {'id': 'KG', 'text': 'country.KG', 'code': '996', 'useType': 'both'},
  {'id': 'LA', 'text': 'country.LA', 'code': '856', 'useType': 'both'},
  {'id': 'LV', 'text': 'country.LV', 'code': '371', 'useType': 'both'},
  {'id': 'LB', 'text': 'country.LB', 'code': '', 'useType': 'both'},
  {'id': 'LS', 'text': 'country.LS', 'code': '266', 'useType': 'both'},
  {'id': 'LR', 'text': 'country.LR', 'code': '231', 'useType': 'both'},
  {'id': 'LY', 'text': 'country.LY', 'code': '218', 'useType': 'both'},
  {'id': 'LI', 'text': 'country.LI', 'code': '423', 'useType': 'both'},
  {'id': 'LT', 'text': 'country.LT', 'code': '370', 'useType': 'both'},
  {'id': 'LU', 'text': 'country.LU', 'code': '352', 'useType': 'both'},
  {'id': 'MO', 'text': 'country.MO', 'code': '853', 'useType': 'both'},
  {'id': 'MK', 'text': 'country.MK', 'code': '389', 'useType': 'both'},
  {'id': 'MG', 'text': 'country.MG', 'code': '261', 'useType': 'both'},
  {'id': 'MW', 'text': 'country.MW', 'code': '265', 'useType': 'both'},
  {'id': 'MY', 'text': 'country.MY', 'code': '60', 'useType': 'both'},
  {'id': 'MV', 'text': 'country.MV', 'code': '960', 'useType': 'both'},
  {'id': 'ML', 'text': 'country.ML', 'code': '223', 'useType': 'both'},
  {'id': 'MT', 'text': 'country.MT', 'code': '356', 'useType': 'both'},
  {'id': 'MH', 'text': 'country.MH', 'code': '692', 'useType': 'both'},
  {'id': 'MQ', 'text': 'country.MQ', 'code': '596', 'useType': 'both'},
  {'id': 'MR', 'text': 'country.MR', 'code': '222', 'useType': 'both'},
  {'id': 'MU', 'text': 'country.MU', 'code': '230', 'useType': 'both'},
  {'id': 'FX', 'text': 'country.FX', 'useType': 'web'},
  {'id': 'YT', 'text': 'country.YT', 'code': '262', 'useType': 'both'},
  {'id': 'MX', 'text': 'country.MX', 'code': '52', 'useType': 'both'},
  {'id': 'FM', 'text': 'country.FM', 'code': '691', 'useType': 'both'},
  {'id': 'MI', 'text': 'country.MI', 'useType': 'web'},
  {'id': 'MD', 'text': 'country.MD', 'code': '373', 'useType': 'both'},
  {'id': 'MC', 'text': 'country.MC', 'code': '377', 'useType': 'both'},
  {'id': 'MN', 'text': 'country.MN', 'code': '976', 'useType': 'both'},
  {'id': 'ME', 'text': 'country.ME', 'code': '382', 'useType': 'both'},
  {'id': 'MS', 'text': 'country.MS', 'code': '1', 'useType': 'both'},
  {'id': 'MA', 'text': 'country.MA', 'code': '212', 'useType': 'both'},
  {'id': 'MZ', 'text': 'country.MZ', 'code': '258', 'useType': 'both'},
  {'id': 'MM', 'text': 'country.MM', 'code': '95', 'useType': 'both'},
  {'id': 'NA', 'text': 'country.NA', 'code': '264', 'useType': 'both'},
  {'id': 'NR', 'text': 'country.NR', 'code': '674', 'useType': 'both'},
  {'id': 'NP', 'text': 'country.NP', 'code': '977', 'useType': 'both'},
  {'id': 'NL', 'text': 'country.NL', 'code': '31', 'useType': 'both'},
  {'id': 'AN', 'text': 'country.AN', 'code': '599', 'useType': 'web'},
  {'id': 'NT', 'text': 'country.NT', 'useType': 'web'},
  {'id': 'NC', 'text': 'country.NC', 'code': '687', 'useType': 'both'},
  {'id': 'NZ', 'text': 'country.NZ', 'code': '64', 'useType': 'both'},
  {'id': 'NI', 'text': 'country.NI', 'code': '505', 'useType': 'both'},
  {'id': 'NE', 'text': 'country.NE', 'code': '227', 'useType': 'both'},
  {'id': 'NG', 'text': 'country.NG', 'code': '234', 'useType': 'both'},
  {'id': 'NU', 'text': 'country.NU', 'code': '683', 'useType': 'both'},
  {'id': 'VD', 'text': 'country.VD', 'useType': 'web'},
  {'id': 'NF', 'text': 'country.NF', 'code': '672', 'useType': 'both'},
  {'id': 'MP', 'text': 'country.MP', 'code': '1', 'useType': 'both'},
  {'id': 'NO', 'text': 'country.NO', 'code': '47', 'useType': 'both'},
  {'id': 'OM', 'text': 'country.OM', 'code': '968', 'useType': 'both'},
  {'id': 'QO', 'text': 'country.QO', 'useType': 'web'},
  {'id': 'PC', 'text': 'country.PC', 'useType': 'web'},
  {'id': 'PK', 'text': 'country.PK', 'code': '92', 'useType': 'both'},
  {'id': 'PW', 'text': 'country.PW', 'code': '680', 'useType': 'both'},
  {'id': 'PS', 'text': 'country.PS', 'code': '970', 'useType': 'both'},
  {'id': 'PA', 'text': 'country.PA', 'code': '507', 'useType': 'both'},
  {'id': 'PZ', 'text': 'country.PZ', 'useType': 'web'},
  {'id': 'PY', 'text': 'country.PY', 'code': '595', 'useType': 'both'},
  {'id': 'YD', 'text': 'country.YD', 'useType': 'web'},
  {'id': 'PE', 'text': 'country.PE', 'code': '51', 'useType': 'both'},
  {'id': 'PH', 'text': 'country.PH', 'code': '63', 'useType': 'both'},
  {'id': 'PN', 'text': 'country.PN', 'code': '870', 'useType': 'both'},
  {'id': 'PL', 'text': 'country.PL', 'code': '48', 'useType': 'both'},
  {'id': 'PT', 'text': 'country.PT', 'code': '351', 'useType': 'both'},
  {'id': 'PR', 'text': 'country.PR', 'code': '1', 'useType': 'both'},
  {'id': 'QA', 'text': 'country.QA', 'code': '974', 'useType': 'both'},
  {'id': 'RO', 'text': 'country.RO', 'code': '40', 'useType': 'both'},
  {'id': 'RU', 'text': 'country.RU', 'code': '7', 'useType': 'both'},
  {'id': 'RW', 'text': 'country.RW', 'code': '250', 'useType': 'both'},
  {'id': 'RE', 'text': 'country.RE', 'code': '262', 'useType': 'both'},
  {'id': 'BL', 'text': 'country.BL', 'code': '590', 'useType': 'both'},
  {'id': 'SH', 'text': 'country.SH', 'code': '290', 'useType': 'both'},
  {'id': 'KN', 'text': 'country.KN', 'code': '1', 'useType': 'both'},
  {'id': 'LC', 'text': 'country.LC', 'code': '1', 'useType': 'both'},
  {'id': 'MF', 'text': 'country.MF', 'code': '590', 'useType': 'both'},
  {'id': 'PM', 'text': 'country.PM', 'code': '508', 'useType': 'both'},
  {'id': 'VC', 'text': 'country.VC', 'code': '1', 'useType': 'both'},
  {'id': 'WS', 'text': 'country.WS', 'code': '685', 'useType': 'both'},
  {'id': 'SM', 'text': 'country.SM', 'code': '378', 'useType': 'both'},
  {'id': 'SA', 'text': 'country.SA', 'code': '966', 'useType': 'both'},
  {'id': 'SN', 'text': 'country.SN', 'code': '221', 'useType': 'both'},
  {'id': 'RS', 'text': 'country.RS', 'code': '381', 'useType': 'both'},
  {'id': 'CS', 'text': 'country.CS', 'code': '381', 'useType': 'web'},
  {'id': 'SC', 'text': 'country.SC', 'code': '248', 'useType': 'both'},
  {'id': 'SL', 'text': 'country.SL', 'code': '232', 'useType': 'both'},
  {'id': 'SG', 'text': 'country.SG', 'code': '65', 'useType': 'both'},
  {'id': 'SX', 'text': 'country.SX', 'code': '', 'useType': 'both'},
  {'id': 'SK', 'text': 'country.SK', 'code': '421', 'useType': 'both'},
  {'id': 'SI', 'text': 'country.SI', 'code': '386', 'useType': 'both'},
  {'id': 'SB', 'text': 'country.SB', 'code': '677', 'useType': 'both'},
  {'id': 'SO', 'text': 'country.SO', 'code': '252', 'useType': 'both'},
  {'id': 'ZA', 'text': 'country.ZA', 'code': '27', 'useType': 'both'},
  {'id': 'GS', 'text': 'country.GS', 'useType': 'both'},
  {'id': 'KR', 'text': 'country.KR', 'code': '82', 'useType': 'both'},
  {'id': 'SS', 'text': 'country.SS', 'useType': 'both'},
  {'id': 'ES', 'text': 'country.ES', 'code': '34', 'useType': 'both'},
  {'id': 'LK', 'text': 'country.LK', 'code': '94', 'useType': 'both'},
  {'id': 'SD', 'text': 'country.SD', 'code': '294', 'useType': 'both'},
  {'id': 'SR', 'text': 'country.SR', 'code': '597', 'useType': 'both'},
  {'id': 'SJ', 'text': 'country.SJ', 'useType': 'both'},
  {'id': 'SZ', 'text': 'country.SZ', 'code': '268', 'useType': 'both'},
  {'id': 'SE', 'text': 'country.SE', 'code': '46', 'useType': 'both'},
  {'id': 'CH', 'text': 'country.CH', 'code': '41', 'useType': 'both'},
  {'id': 'SY', 'text': 'country.SY', 'code': '963', 'useType': 'both'},
  {'id': 'ST', 'text': 'country.ST', 'code': '239', 'useType': 'both'},
  {'id': 'TW', 'text': 'country.TW', 'code': '886', 'useType': 'both'},
  {'id': 'TJ', 'text': 'country.TJ', 'code': '992', 'useType': 'both'},
  {'id': 'TZ', 'text': 'country.TZ', 'code': '255', 'useType': 'both'},
  {'id': 'TH', 'text': 'country.TH', 'code': '66', 'useType': 'both'},
  {'id': 'TG', 'text': 'country.TG', 'code': '228', 'useType': 'both'},
  {'id': 'TK', 'text': 'country.TK', 'code': '690', 'useType': 'both'},
  {'id': 'TO', 'text': 'country.TO', 'code': '676', 'useType': 'both'},
  {'id': 'TT', 'text': 'country.TT', 'code': '1', 'useType': 'both'},
  {'id': 'TA', 'text': 'country.TA', 'useType': 'web'},
  {'id': 'TN', 'text': 'country.TN', 'code': '216', 'useType': 'both'},
  {'id': 'TR', 'text': 'country.TR', 'code': '90', 'useType': 'both'},
  {'id': 'TM', 'text': 'country.TM', 'code': '993', 'useType': 'both'},
  {'id': 'TC', 'text': 'country.TC', 'code': '1', 'useType': 'both'},
  {'id': 'TV', 'text': 'country.TV', 'code': '688', 'useType': 'both'},
  {'id': 'UM', 'text': 'country.UM', 'useType': 'web'},
  {'id': 'PU', 'text': 'country.PU', 'useType': 'web'},
  {'id': 'VI', 'text': 'country.VI', 'code': '1', 'useType': 'web'},
  {'id': 'UG', 'text': 'country.UG', 'code': '256', 'useType': 'both'},
  {'id': 'UA', 'text': 'country.UA', 'code': '380', 'useType': 'both'},
  {'id': 'AE', 'text': 'country.AE', 'code': '971', 'useType': 'both'},
  {'id': 'GB', 'text': 'country.GB', 'code': '44', 'useType': 'both'},
  {'id': 'US', 'text': 'country.US', 'code': '1', 'useType': 'both'},
  {'id': 'UM', 'text': 'country.UM', 'code': '', 'useType': 'both'},
  {'id': 'UY', 'text': 'country.UY', 'code': '598', 'useType': 'both'},
  {'id': 'UZ', 'text': 'country.UZ', 'code': '998', 'useType': 'both'},
  {'id': 'VU', 'text': 'country.VU', 'code': '678', 'useType': 'both'},
  {'id': 'VA', 'text': 'country.VA', 'code': '379', 'useType': 'web'},
  {'id': 'VE', 'text': 'country.VE', 'code': '58', 'useType': 'both'},
  {'id': 'VN', 'text': 'country.VN', 'code': '84', 'useType': 'both'},
  {'id': 'WK', 'text': 'country.WK', 'useType': 'web'},
  {'id': 'VG', 'text': 'country.VG', 'code': '', 'useType': 'both'},
  {'id': 'VI', 'text': 'country.VI', 'code': '', 'useType': 'both'},
  {'id': 'WF', 'text': 'country.WF', 'code': '681', 'useType': 'both'},
  {'id': 'EH', 'text': 'country.EH', 'useType': 'both'},
  {'id': 'YE', 'text': 'country.YE', 'code': '967', 'useType': 'both'},
  {'id': 'ZM', 'text': 'country.ZM', 'code': '260', 'useType': 'both'},
  {'id': 'ZW', 'text': 'country.ZW', 'code': '263', 'useType': 'both'},
  {'id': 'CG', 'text': 'country.CG', 'code': '242', 'useType': 'both'},
  {'id': 'PG', 'text': 'country.PG', 'code': '675', 'useType': 'both'}
];

export default countryMap;


